import * as React from 'react';

export const AugurLoadingLogo = (
  <svg viewBox="50 50 205 205">
    <path
      className="outer-lines"
      d="M66.3 199.1L152.8 55M152.8 251l-86.5-51.9M239.7 199.1L152.8 251M152.8 55l86.9 144.1"
    />
    <path
      className="inner-bottom-line"
      d="M152.8 250.5l.3-33.8c0-6.3 3.4-12.1 9-15.2l5.6-2.8c6-3 11.1-7.7 14.5-13.6l2.2-3.7"
    />
    <path
      className="inner-lines"
      d="M158.1 135.2s13.6 3.1 20.2 11c11.3 13.5 6.3 25.5 13.7 30.7 8.5 6 46.4 22.2 46.4 22.2m-118.7-30.8s.2-9.8 5.9-18.5c6.9-10.5 18-12.4 23.5-17.8 4.5-4.4 4-13 4-13l-.3-62.5m-4 144.5s-7.8-1-13.4-4.7c-7.3-4.9-12.5-15.1-17.6-17.1-5.5-2.1-11.4 1-11.4 1L66.3 199"
    />
    <path
      className="mask"
      d="M183.1 170.7s2.5 9 7.5 12.8c5 3.8-1.9 6.4-8.1.9s.6-13.7.6-13.7zm-22.2-33.9c4.5-6.9.9-13.4-2.1-7.8-3 5.5-11.5 9.4-11.5 9.4s9.1 5.4 13.6-1.6zm-41.5 29.4c-8.1-1.8-12.8 3.9-6.6 4.7s12.9 7.4 12.9 7.4 1.8-10.3-6.3-12.1zm34.6 36.4c3.3-7.5-1.3-13.3-3.4-7.4-2.1 6-9.8 11.2-9.8 11.2s9.9 3.8 13.2-3.8z"
    />
  </svg>
);

export const AugurLogo = (
  <svg viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.02796 10.428L5.53596 11.394C5.67796 11.484 5.86596 11.44 5.95196 11.296L10.822 3.152C10.88 3.056 11.02 3.056 11.078 3.152L15.948 11.296C16.034 11.44 16.224 11.484 16.364 11.394L17.872 10.428C18.008 10.342 18.05 10.162 17.968 10.024L12.148 0.29C12.04 0.11 11.846 0 11.636 0H10.264C10.054 0 9.85996 0.11 9.75196 0.29L3.93196 10.024C3.84996 10.162 3.89196 10.342 4.02796 10.428Z" fill="#2AE7A8"/>
    <path d="M21.8161 16.462L19.4981 12.586C19.4121 12.442 19.2221 12.398 19.0821 12.488L17.5741 13.454C17.4381 13.54 17.3961 13.72 17.4781 13.858L18.8021 16.072C18.8441 16.142 18.8221 16.23 18.7541 16.274L11.0301 21.224C10.9801 21.256 10.9181 21.256 10.8701 21.224L3.14611 16.274C3.07811 16.23 3.05811 16.14 3.09811 16.072L4.42211 13.858C4.50411 13.72 4.46211 13.54 4.32611 13.454L2.81811 12.488C2.67611 12.398 2.48811 12.442 2.40211 12.586L0.0841132 16.462C-0.0818868 16.738 0.00211318 17.096 0.274113 17.27L10.6281 23.906C10.8241 24.032 11.0761 24.032 11.2721 23.906L21.6261 17.27C21.8961 17.096 21.9801 16.738 21.8161 16.462Z" fill="white"/>
  </svg>
);

export const AugurLogoWithText = (
  <svg viewBox="0 0 144 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <path d="M8.05641 20.856L11.0724 22.788C11.3564 22.968 11.7324 22.88 11.9044 22.592L21.6444 6.304C21.7604 6.112 22.0404 6.112 22.1564 6.304L31.8964 22.592C32.0684 22.88 32.4484 22.968 32.7284 22.788L35.7444 20.856C36.0164 20.684 36.1004 20.324 35.9364 20.048L24.2964 0.58C24.0804 0.22 23.6924 0 23.2724 0H20.5284C20.1084 0 19.7204 0.22 19.5044 0.58L7.86441 20.048C7.70041 20.324 7.78441 20.684 8.05641 20.856Z" fill="#2AE7A8"/>
      <path d="M43.6322 32.924L38.9962 25.172C38.8242 24.884 38.4442 24.796 38.1642 24.976L35.1482 26.908C34.8762 27.08 34.7922 27.44 34.9562 27.716L37.6042 32.144C37.6882 32.284 37.6442 32.46 37.5082 32.548L22.0602 42.448C21.9602 42.512 21.8362 42.512 21.7402 42.448L6.29223 32.548C6.15623 32.46 6.11623 32.28 6.19623 32.144L8.84423 27.716C9.00823 27.44 8.92423 27.08 8.65223 26.908L5.63623 24.976C5.35223 24.796 4.97623 24.884 4.80423 25.172L0.168226 32.924C-0.163774 33.476 0.00422635 34.192 0.548226 34.54L21.2562 47.812C21.6482 48.064 22.1522 48.064 22.5442 47.812L43.2522 34.54C43.7922 34.192 43.9602 33.476 43.6322 32.924Z" fill="white"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M66.888 14.2881C68.108 14.8441 69.048 15.6041 69.704 16.5761C70.36 17.5481 70.688 18.6481 70.688 19.8841V32.4721C70.688 32.8761 70.484 33.0761 70.084 33.0761H66.908C66.504 33.0761 66.304 32.8761 66.304 32.4721V31.5281C66.304 31.4281 66.28 31.3721 66.228 31.3561C66.176 31.3441 66.116 31.3641 66.04 31.4121C64.68 32.7241 62.864 33.3761 60.596 33.3761C58.732 33.3761 57.2 32.8961 56.004 31.9401C54.808 30.9841 54.208 29.5601 54.208 27.6681C54.208 25.7041 54.896 24.1721 56.268 23.0761C57.64 21.9801 59.576 21.4321 62.072 21.4321H66.08C66.232 21.4321 66.308 21.3561 66.308 21.2041V20.3361C66.308 19.3521 66.012 18.5921 65.42 18.0481C64.828 17.5081 63.952 17.2361 62.792 17.2361C61.908 17.2361 61.18 17.3921 60.6 17.7081C60.02 18.0241 59.628 18.4601 59.428 19.0121C59.328 19.3641 59.1 19.5281 58.748 19.5041L55.348 19.0881C55.144 19.0641 54.996 19.0081 54.896 18.9161C54.796 18.8281 54.756 18.7201 54.784 18.5961C55.012 17.0841 55.848 15.8481 57.296 14.8921C58.744 13.9361 60.54 13.4561 62.684 13.4561C64.26 13.4561 65.668 13.7361 66.888 14.2881ZM64.98 28.9161C65.86 28.2601 66.304 27.4281 66.304 26.4201V24.6801C66.304 24.5281 66.228 24.4521 66.076 24.4521H62.94C61.604 24.4521 60.544 24.7041 59.764 25.2081C58.984 25.7121 58.592 26.4321 58.592 27.3641C58.592 28.1721 58.896 28.7961 59.5 29.2361C60.104 29.6761 60.872 29.8961 61.804 29.8961C63.04 29.9001 64.096 29.5721 64.98 28.9161ZM86.208 13.7601H89.344C89.748 13.7601 89.948 13.9641 89.948 14.3641V32.4721C89.948 32.8761 89.744 33.0761 89.344 33.0761H86.208C85.804 33.0761 85.604 32.8761 85.604 32.4721V31.4881C85.604 31.3881 85.572 31.3241 85.508 31.3001C85.444 31.2761 85.388 31.3121 85.336 31.4121C84.328 32.6961 82.792 33.3401 80.724 33.3401C78.808 33.3401 77.204 32.7841 75.904 31.6761C74.604 30.5681 73.9561 28.9921 73.9561 26.9521V14.3641C73.9561 13.9601 74.156 13.7601 74.56 13.7601H77.736C78.14 13.7601 78.3401 13.9641 78.3401 14.3641V25.7041C78.3401 26.8881 78.648 27.8321 79.268 28.5401C79.884 29.2441 80.748 29.6001 81.856 29.6001C82.988 29.6001 83.896 29.2481 84.576 28.5401C85.256 27.8361 85.596 26.8881 85.596 25.7041V14.3641C85.604 13.9601 85.804 13.7601 86.208 13.7601ZM108.896 13.76H105.72C105.316 13.76 105.116 13.96 105.108 14.372V15.052C105.108 15.152 105.084 15.216 105.032 15.24C104.984 15.264 104.92 15.24 104.844 15.164C103.708 14.032 102.172 13.464 100.232 13.464C98.568 13.464 97.12 13.924 95.884 14.844C94.648 15.764 93.78 16.992 93.276 18.528C92.872 19.636 92.672 21.236 92.672 23.328C92.672 25.192 92.836 26.716 93.164 27.9C93.696 29.612 94.64 30.884 96 31.716C97.364 32.548 98.86 32.964 100.5 32.964C102.364 32.964 103.816 32.424 104.848 31.34C104.924 31.264 104.984 31.24 105.036 31.264C105.088 31.288 105.112 31.352 105.112 31.452V31.68C105.112 33.444 104.668 34.696 103.772 35.44C102.876 36.184 101.472 36.556 99.556 36.556C99.228 36.556 98.636 36.532 97.78 36.48C97.576 36.452 97.412 36.492 97.288 36.592C97.164 36.692 97.1 36.832 97.1 37.008L96.988 39.804C96.988 40.232 97.164 40.46 97.516 40.484C98.248 40.56 98.968 40.596 99.672 40.596C102.596 40.596 104.968 39.92 106.78 38.556C108.592 37.192 109.5 34.936 109.5 31.788V14.364C109.5 13.964 109.3 13.76 108.896 13.76ZM105.116 23.284C105.116 24.268 105.096 24.98 105.06 25.42C105.02 25.86 104.952 26.272 104.852 26.652C104.652 27.456 104.248 28.112 103.644 28.616C103.04 29.12 102.248 29.372 101.264 29.372C100.332 29.372 99.532 29.112 98.864 28.596C98.196 28.08 97.736 27.42 97.484 26.612C97.232 25.984 97.108 24.888 97.108 23.324C97.108 21.812 97.256 20.7 97.56 19.996C97.836 19.164 98.288 18.496 98.92 17.992C99.548 17.488 100.316 17.236 101.224 17.236C102.184 17.236 102.972 17.488 103.588 17.992C104.204 18.496 104.612 19.164 104.816 19.996C104.94 20.4 105.024 20.808 105.06 21.224C105.096 21.64 105.116 22.328 105.116 23.284ZM125.02 13.7601H128.156C128.56 13.7601 128.76 13.9641 128.76 14.3641V32.4721C128.76 32.8761 128.556 33.0761 128.156 33.0761H125.02C124.616 33.0761 124.416 32.8761 124.416 32.4721V31.4881C124.416 31.3881 124.384 31.3241 124.32 31.3001C124.256 31.2761 124.2 31.3121 124.148 31.4121C123.14 32.6961 121.604 33.3401 119.536 33.3401C117.62 33.3401 116.016 32.7841 114.716 31.6761C113.416 30.5681 112.768 28.9921 112.768 26.9521V14.3641C112.768 13.9601 112.968 13.7601 113.372 13.7601H116.548C116.952 13.7601 117.152 13.9641 117.152 14.3641V25.7041C117.152 26.8881 117.46 27.8321 118.08 28.5401C118.696 29.2441 119.56 29.6001 120.668 29.6001C121.8 29.6001 122.708 29.2481 123.388 28.5401C124.068 27.8361 124.408 26.8881 124.408 25.7041V14.3641C124.416 13.9601 124.62 13.7601 125.02 13.7601ZM143.376 14.7041C143.452 14.3521 143.34 14.1001 143.036 13.9481C142.432 13.6721 141.764 13.5321 141.032 13.5361C139.168 13.5361 137.708 14.3281 136.648 15.9161C136.596 16.0161 136.548 16.0521 136.496 16.0281C136.444 16.0041 136.42 15.9401 136.42 15.8401V14.3641C136.42 13.9641 136.22 13.7601 135.816 13.7601H132.64C132.236 13.7601 132.036 13.9601 132.036 14.3641V32.4681C132.036 32.8721 132.236 33.0721 132.64 33.0721H135.816C136.216 33.0721 136.42 32.8721 136.42 32.4681V21.9201C136.42 20.8121 136.776 19.9081 137.48 19.2161C138.184 18.5241 139.064 18.1521 140.124 18.1001C140.3 18.0761 140.54 18.0641 140.844 18.0641C141.348 18.0641 141.748 18.1161 142.052 18.2161C142.28 18.2681 142.452 18.2681 142.564 18.2161C142.676 18.1681 142.748 18.0441 142.772 17.8401L143.376 14.7041Z" fill="white"/>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

export const LargeDaiIcon = (
  <svg viewBox="0 0 64 64" fill="none">
    <path d="M31.8562 6.40002L57.6 32.1438L32.1438 57.6L6.39999 31.8562L31.8562 6.40002ZM39.3143 32.0411L50.2857 32.1028L31.8973 13.7143L13.7143 31.8973L24.6857 31.9589L31.9589 24.6857L39.3143 32.0411Z" />
  </svg>
);

export const LargeDollarIcon = (
  <svg viewBox="0 0 52 52" fill="none">
    <path d="M21.1453 19.7689C21.1453 21.9261 22.6038 22.7484 24.6569 23.5332V16.54C22.7581 16.8862 21.1453 17.8311 21.1453 19.7689Z" />
    <path d="M27.3422 27.4544V34.5175C29.8984 34.1291 31.1846 33.016 31.1846 31.1667C31.1846 28.9592 29.5116 28.2157 27.3422 27.4544Z" />
    <path d="M26 0.8125C12.1111 0.8125 0.8125 12.1119 0.8125 26C0.8125 39.8881 12.1111 51.1875 26 51.1875C39.8889 51.1875 51.1875 39.8881 51.1875 26C51.1875 12.1119 39.8889 0.8125 26 0.8125ZM32.4326 35.048C31.2114 36.1075 29.5124 36.7811 27.3423 37.0728V41.4375H24.6577V37.2564C22.5477 37.2417 19.6064 36.9338 17.6954 36.0482V33.1849C19.6698 34.0657 22.4729 34.6905 24.6577 34.7206V26.5923C20.8414 25.3549 18.044 23.7746 18.044 19.8063C18.044 16.2988 21.1299 14.4454 24.6577 14.0173V10.5625H27.3423V13.9612C29.5433 14.0376 31.6688 14.4828 33.7171 15.3091L32.7624 17.7133C30.9847 17.0097 29.1777 16.5896 27.3414 16.4442V24.44C29.1907 25.0356 30.5841 25.6173 31.5144 26.1836C33.5083 27.3983 34.3037 28.873 34.3037 30.9278C34.3046 32.5918 33.6806 33.9649 32.4326 35.048Z" />
  </svg>
);

export const QuestionIcon = (
  <svg viewBox="0 0 12 12">
    <circle cx="6" cy="6" r="5.5" />
    <path d="M5.45117 7.41992C5.45117 7.1888 5.45768 6.99512 5.4707 6.83887C5.48372 6.68262 5.51302 6.54427 5.55859 6.42383C5.60417 6.30339 5.67253 6.19108 5.76367 6.08691C5.85482 5.97949 5.98014 5.85742 6.13965 5.7207C6.24707 5.61328 6.35775 5.5026 6.47168 5.38867C6.58561 5.27148 6.68815 5.15104 6.7793 5.02734C6.8737 4.90039 6.9502 4.77018 7.00879 4.63672C7.07064 4.50326 7.10156 4.36491 7.10156 4.22168C7.10156 3.89941 7.01204 3.66016 6.83301 3.50391C6.65397 3.3444 6.39518 3.26465 6.05664 3.26465C5.92643 3.26465 5.79785 3.28255 5.6709 3.31836C5.5472 3.35091 5.43652 3.40299 5.33887 3.47461C5.24121 3.54622 5.16146 3.639 5.09961 3.75293C5.04102 3.86361 5.01172 3.99707 5.01172 4.15332H3.83984C3.8431 3.85059 3.90169 3.58366 4.01562 3.35254C4.13281 3.11816 4.29069 2.92285 4.48926 2.7666C4.68783 2.6071 4.92057 2.48828 5.1875 2.41016C5.45443 2.32878 5.74414 2.28809 6.05664 2.28809C6.4082 2.28809 6.7207 2.3304 6.99414 2.41504C7.26758 2.49642 7.4987 2.61686 7.6875 2.77637C7.87956 2.93587 8.02441 3.13281 8.12207 3.36719C8.22298 3.60156 8.27344 3.87012 8.27344 4.17285C8.27344 4.40397 8.23275 4.62044 8.15137 4.82227C8.07324 5.02083 7.96908 5.20801 7.83887 5.38379C7.71191 5.55957 7.56868 5.72396 7.40918 5.87695C7.24967 6.02995 7.0918 6.17643 6.93555 6.31641C6.83789 6.41406 6.76302 6.50195 6.71094 6.58008C6.65885 6.6582 6.61979 6.73796 6.59375 6.81934C6.57096 6.90072 6.55794 6.98861 6.55469 7.08301C6.55143 7.17741 6.5498 7.28971 6.5498 7.41992H5.45117ZM5.2998 8.91406C5.2998 8.72201 5.3584 8.56413 5.47559 8.44043C5.59603 8.31348 5.76693 8.25 5.98828 8.25C6.20964 8.25 6.38053 8.31348 6.50098 8.44043C6.62467 8.56413 6.68652 8.72201 6.68652 8.91406C6.68652 9.09961 6.62467 9.25423 6.50098 9.37793C6.38053 9.49837 6.20964 9.55859 5.98828 9.55859C5.76693 9.55859 5.59603 9.49837 5.47559 9.37793C5.3584 9.25423 5.2998 9.09961 5.2998 8.91406Z" />
  </svg>
);

export const BackIcon = (
  <svg viewBox="0 0 10 10" fill="none">
    <path d="M3.54294 6.79039C3.68939 6.93684 3.68939 7.17428 3.54294 7.32072C3.3965 7.46717 3.15906 7.46717 3.01261 7.32072L1.23484 5.54294C1.08839 5.3965 1.08839 5.15906 1.23484 5.01261L3.01261 3.23483C3.15906 3.08839 3.3965 3.08839 3.54294 3.23483C3.68939 3.38128 3.68939 3.61872 3.54294 3.76517L2.40811 4.9H8.62501C8.83211 4.9 9.00001 5.06789 9.00001 5.275C9.00001 5.48211 8.83211 5.65 8.62501 5.65H2.40255L3.54294 6.79039Z" />
  </svg>
);

export const Calendar = (
  <svg viewBox="0 0 20 20" fill="none">
    <path d="M16.4 3.45455H15.6V2H14V3.45455H6V2H4.4V3.45455H3.6C2.72 3.45455 2 4.10909 2 4.90909V16.5455C2 17.3455 2.72 18 3.6 18H16.4C17.28 18 18 17.3455 18 16.5455V4.90909C18 4.10909 17.28 3.45455 16.4 3.45455ZM16.4 16.5455H3.6V7.09091H16.4V16.5455Z" />
  </svg>
);

export const Clock = (
  <svg viewBox="0 0 20 20" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 2C5.6 2 2 5.6 2 10C2 14.4 5.6 18 10 18C14.4 18 18 14.4 18 10C18 5.6 14.4 2 10 2ZM10 16.4C6.48 16.4 3.6 13.52 3.6 10C3.6 6.48 6.48 3.6 10 3.6C13.52 3.6 16.4 6.48 16.4 10C16.4 13.52 13.52 16.4 10 16.4ZM10.4 6H9.2V10.8L13.36 13.36L14 12.32L10.4 10.16V6Z"
    />
  </svg>
);

export const RightAngle = (
  <svg viewBox="0 0 10 10">
    <line x1="0.5" y1="2.18556e-08" x2="0.5" y2="10" />
    <line x1="10" y1="9.5" y2="9.5" />
  </svg>
);

export const Arrow = (
  <svg>
    <path d="M0,10 20,10 10,0z"></path>
    <path d="M0,10 10,0 20,10"></path>
  </svg>
);

export const Ellipsis = (
  <svg viewBox="0 0 40 40" fill="none">
    <circle cx="20" cy="20" r="20" />
  </svg>
);

export const EmptyRadio = (
  <svg viewBox="0 0 20 20" fill="none">
    <circle cx="10" cy="10" r="9" strokeWidth="2" />
    <circle cx="10" cy="10" r="4" />
  </svg>
);

export const FilledRadio = (
  <svg viewBox="0 0 20 20" fill="none">
    <circle cx="10" cy="10" r="9" strokeWidth="2" />
    <circle cx="10" cy="10" r="4" />
  </svg>
);

export const EmptyCheckbox = (
  <svg viewBox="0 0 20 20" fill="none">
    <rect x="1" y="1" width="18" height="18" rx="2" strokeWidth="2" />
  </svg>
);

export const FilledCheckbox = (
  <svg viewBox="0 0 20 20" fill="none">
    <rect
      x="1"
      y="1"
      width="18"
      height="18"
      rx="1"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M6.38184 10.5L8.1258 12.5L13.756 6.66669"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ViewIcon = (
  <svg viewBox="0 0 10 10">
    <path d="M8.75 8.75V9.25H9.25V8.75H8.75ZM1.25 8.75H0.75V9.25H1.25V8.75ZM1.25 1.25V0.75H0.75V1.25H1.25ZM8.75 1.25H9.25V0.75H8.75V1.25ZM8.25 5C8.25 5.27614 8.47386 5.5 8.75 5.5C9.02614 5.5 9.25 5.27614 9.25 5H8.25ZM5 0.75C4.72386 0.75 4.5 0.973858 4.5 1.25C4.5 1.52614 4.72386 1.75 5 1.75V0.75ZM9.25 7.1875C9.25 6.91136 9.02614 6.6875 8.75 6.6875C8.47386 6.6875 8.25 6.91136 8.25 7.1875H9.25ZM2.8125 1.75C3.08864 1.75 3.3125 1.52614 3.3125 1.25C3.3125 0.973858 3.08864 0.75 2.8125 0.75V1.75ZM8.75 8.25H1.25V9.25H8.75V8.25ZM1.75 8.75V1.25H0.75V8.75H1.75ZM8.25 1.25V5H9.25V1.25H8.25ZM5 1.75H8.75V0.75H5V1.75ZM8.25 7.1875V8.75H9.25V7.1875H8.25ZM1.25 1.75H2.8125V0.75H1.25V1.75Z" />
    <path d="M8.75 1.25L4.0625 5.9375" strokeLinecap="round" />
  </svg>
);

export const CopyIcon = (
  <svg viewBox="0 0 9 10">
    <path d="M6.66683 0.416992H1.66683C1.2085 0.416992 0.833496 0.791992 0.833496 1.25033V7.08366H1.66683V1.25033H6.66683V0.416992ZM6.25016 2.08366L8.75016 4.58366V8.75032C8.75016 9.20866 8.37516 9.58366 7.91683 9.58366H3.32933C2.871 9.58366 2.50016 9.20866 2.50016 8.75032L2.50433 2.91699C2.50433 2.45866 2.87516 2.08366 3.3335 2.08366H6.25016ZM5.8335 5.00033H8.12516L5.8335 2.70866V5.00033Z" />
  </svg>
);

export const ScalarIcon = (
  <svg viewBox="0 0 20 6">
    <rect y="2" rx="0.75" height="1.5" width="20" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 2.7998C9 4.18052 7.88071 5.2998 6.5 5.2998C5.11929 5.2998 4 4.18052 4 2.7998C4 1.41909 5.11929 0.299805 6.5 0.299805C7.88071 0.299805 9 1.41909 9 2.7998Z"
    />
  </svg>
);

export const CheckCircleIcon = (
  <svg viewBox="0 0 14 14">
    <path d="M10.0597 4.0535L5.66634 8.44683L3.27301 6.06016L2.33301 7.00016L5.66634 10.3335L10.9997 5.00016L10.0597 4.0535ZM6.99967 0.333496C3.31967 0.333496 0.333008 3.32016 0.333008 7.00016C0.333008 10.6802 3.31967 13.6668 6.99967 13.6668C10.6797 13.6668 13.6663 10.6802 13.6663 7.00016C13.6663 3.32016 10.6797 0.333496 6.99967 0.333496ZM6.99967 12.3335C4.05301 12.3335 1.66634 9.94683 1.66634 7.00016C1.66634 4.0535 4.05301 1.66683 6.99967 1.66683C9.94634 1.66683 12.333 4.0535 12.333 7.00016C12.333 9.94683 9.94634 12.3335 6.99967 12.3335Z" />
  </svg>
);

export const PlusCircleIcon = (
  <svg viewBox="0 0 12 12">
    <circle cx="6" cy="6" r="6" fillOpacity="0.2" />
    <rect rx="0.5" transform="matrix(1 3.37175e-06 3.37175e-06 1 2 5.5)" />
    <rect rx="0.5" transform="matrix(3.37175e-06 1 -1 -3.37175e-06 6.5 2)" />
  </svg>
);

export const EthIcon = (
  <svg  viewBox="0 0 7 12">
    <path d="M3.49891 11.9999L3.49895 12.0001L3.49897 12L7 6.80985L3.49897 8.98586L0 6.80981L3.49891 11.9999Z" />
    <path d="M3.49896 0L3.49892 6.83319e-05L0 6.11126L2.6703e-05 6.11128L3.49894 8.28837L3.49897 8.2884V8.28836L6.99792 6.11126L3.49896 0Z" />
  </svg>
);

export const DaiLogoIcon = (
  <svg viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#clip0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.13103 2.3999H7.53696C10.217 2.3999 12.2484 3.8409 13.0042 5.93773H14.3767V7.20508H13.2932C13.3144 7.40537 13.3253 7.60939 13.3253 7.81669V7.84782C13.3253 8.08119 13.3116 8.31063 13.2848 8.53533H14.3767V9.80267H12.9781C12.2024 11.8703 10.1867 13.2976 7.53696 13.2976H3.13103V9.80267H1.6V8.53533H3.13103V7.20508H1.6V5.93773H3.13103V2.3999ZM4.36275 9.80267V12.1607H7.53696C9.49575 12.1607 10.9511 11.2163 11.6285 9.80267H4.36275ZM12.0058 8.53533H4.36275V7.20508H12.0078C12.0361 7.41443 12.0506 7.62902 12.0506 7.84782V7.87894C12.0506 8.10279 12.0355 8.32193 12.0058 8.53533ZM7.53696 3.53493C9.50477 3.53493 10.9644 4.50426 11.6378 5.93773H4.36275V3.53493H7.53696Z"
        fill="#D7DDE0"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="12.8"
          height="10.9147"
          fill="white"
          transform="translate(1.6 2.3999)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const AlternateDaiLogoIcon = (
  <svg viewBox="0 0 12 10" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.74004 0.100098H5.59523C7.94025 0.100098 9.71778 1.36097 10.3791 3.1957H11.58V4.30463H10.632C10.6505 4.47988 10.66 4.6584 10.66 4.83979V4.86702C10.66 5.07123 10.648 5.27199 10.6246 5.4686H11.58V6.57752H10.3562C9.6775 8.38673 7.91374 9.63557 5.59523 9.63557H1.74004V6.57752H0.400391V5.4686H1.74004V4.30463H0.400391V3.1957H1.74004V0.100098ZM2.8178 6.57752V8.64078H5.59523C7.30917 8.64078 8.58257 7.81442 9.17532 6.57752H2.8178ZM9.50549 5.4686H2.8178V4.30463H9.50721C9.532 4.48781 9.54465 4.67558 9.54465 4.86702V4.89426C9.54465 5.09013 9.53143 5.28188 9.50549 5.4686ZM5.59523 1.09325C7.31707 1.09325 8.59427 1.94141 9.18345 3.1957H2.8178V1.09325H5.59523Z"
      fill="#9599A5"
    />
    <defs>
      <clipPath id="clip0">
        <rect
          width="11.2"
          height="9.55039"
          fill="white"
          transform="translate(0.400391 0.100098)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const PercentIcon = (
  <svg viewBox="0 0 8 8">
    <path d="M7.46115 0.452142C7.43104 0.422001 7.39528 0.398098 7.35591 0.381803C7.31655 0.365507 7.27436 0.357139 7.23175 0.357178C7.18915 0.357217 7.14697 0.365663 7.10764 0.382031C7.0683 0.398399 7.03259 0.422368 7.00253 0.452565L0.419268 7.05379C0.358563 7.11472 0.324549 7.19727 0.324708 7.28327C0.324866 7.36928 0.359184 7.4517 0.420112 7.51241C0.48104 7.57311 0.563587 7.60712 0.649594 7.60697C0.735601 7.60681 0.818023 7.57249 0.878727 7.51156L7.46199 0.910767C7.49206 0.880604 7.51589 0.844812 7.53212 0.805436C7.54836 0.766059 7.55667 0.72387 7.55659 0.68128C7.55651 0.638689 7.54804 0.596531 7.53167 0.557215C7.51529 0.517899 7.49133 0.482194 7.46115 0.452142Z" />
    <path d="M1.72973 3.45946C2.07184 3.45946 2.40626 3.35801 2.69072 3.16795C2.97517 2.97788 3.19687 2.70774 3.32779 2.39167C3.45871 2.0756 3.49297 1.72781 3.42622 1.39228C3.35948 1.05674 3.19474 0.748534 2.95283 0.506627C2.71093 0.26472 2.40272 0.0999791 2.06718 0.0332371C1.73165 -0.033505 1.38386 0.000749468 1.06779 0.131669C0.751724 0.262588 0.481577 0.484291 0.291512 0.768744C0.101447 1.0532 0 1.38762 0 1.72973C0 2.18848 0.182239 2.62845 0.506626 2.95283C0.831013 3.27722 1.27098 3.45946 1.72973 3.45946ZM1.72973 0.576577C1.9578 0.576577 2.18075 0.644209 2.37039 0.770919C2.56002 0.897629 2.70783 1.07773 2.7951 1.28844C2.88238 1.49915 2.90522 1.73101 2.86073 1.9547C2.81623 2.17839 2.7064 2.38386 2.54513 2.54513C2.38386 2.7064 2.17839 2.81623 1.9547 2.86073C1.73101 2.90522 1.49915 2.88238 1.28844 2.7951C1.07773 2.70783 0.897628 2.56002 0.770918 2.37039C0.644208 2.18075 0.576577 1.9578 0.576577 1.72973C0.57692 1.424 0.698523 1.13089 0.914707 0.914707C1.13089 0.698524 1.424 0.576921 1.72973 0.576577Z" />
    <path d="M6.18823 4.54053C5.84612 4.54053 5.51169 4.64197 5.22724 4.83204C4.94279 5.0221 4.72108 5.29225 4.59016 5.60832C4.45925 5.92438 4.42499 6.27218 4.49173 6.60771C4.55848 6.94325 4.72322 7.25145 4.96512 7.49336C5.20703 7.73527 5.51524 7.90001 5.85077 7.96675C6.18631 8.03349 6.5341 7.99924 6.85017 7.86832C7.16623 7.7374 7.43638 7.5157 7.62644 7.23124C7.81651 6.94679 7.91796 6.61237 7.91796 6.27026C7.91796 6.04311 7.87322 5.81818 7.78629 5.60832C7.69936 5.39846 7.57195 5.20777 7.41133 5.04715C7.25071 4.88653 7.06003 4.75912 6.85017 4.6722C6.64031 4.58527 6.41538 4.54053 6.18823 4.54053ZM6.18823 7.42341C5.96015 7.42341 5.7372 7.35578 5.54757 7.22907C5.35793 7.10236 5.21013 6.92226 5.12285 6.71155C5.03557 6.50084 5.01274 6.26898 5.05723 6.04529C5.10173 5.8216 5.21155 5.61613 5.37282 5.45485C5.5341 5.29358 5.73957 5.18376 5.96326 5.13926C6.18695 5.09477 6.41881 5.1176 6.62952 5.20488C6.84023 5.29216 7.02033 5.43996 7.14704 5.6296C7.27375 5.81923 7.34138 6.04218 7.34138 6.27026C7.34104 6.57599 7.21943 6.8691 7.00325 7.08528C6.78707 7.30146 6.49396 7.42307 6.18823 7.42341Z" />
  </svg>
);

export const Chevron = (
  <svg viewBox="0 0 20 12">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.35355 0.146447C1.15829 -0.0488155 0.841709 -0.0488155 0.646447 0.146447C0.451184 0.341709 0.451184 0.658291 0.646447 0.853553L8.64562 8.85272C8.64589 8.853 8.64617 8.85328 8.64645 8.85355C8.84171 9.04882 9.15829 9.04882 9.35355 8.85355C9.35375 8.85336 9.35394 8.85316 9.35414 8.85297L17.3536 0.853553C17.5488 0.658291 17.5488 0.341709 17.3536 0.146447C17.1583 -0.0488155 16.8417 -0.0488155 16.6464 0.146447L9 7.79289L1.35355 0.146447Z"
    />
  </svg>
);

export const OutlineChevron = (
  <svg viewBox="0 0 32 32" fill="none">
    <rect
      x="-0.5"
      y="0.5"
      width="31"
      height="31"
      rx="2.5"
      transform="matrix(-1 0 0 1 31 0)"
    />
    <path
      d="M18 20L14 16L18 12"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MarketIcon = (
  <svg viewBox="0 0 14 9">
    <path d="M13.25 0.5H13.75C13.75 0.223858 13.5261 0 13.25 0V0.5ZM12.75 4.41304C12.75 4.68919 12.9739 4.91304 13.25 4.91304C13.5261 4.91304 13.75 4.68919 13.75 4.41304H12.75ZM9.5 0C9.22386 0 9 0.223858 9 0.5C9 0.776142 9.22386 1 9.5 1V0ZM12.75 0.5V4.41304H13.75V0.5H12.75ZM9.5 1H13.25V0H9.5V1Z" />
    <path
      d="M12.5 1.29004L7.1967 6.82392L4.56723 4.08013L1.20142 7.59229"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CopyAlternateIcon = (
  <svg viewBox="0 0 20 20">
    <path d="M13.1818 2H4.45455C3.65091 2 3 2.65091 3 3.45455V13.6364H4.45455V3.45455H13.1818V2ZM15.3636 4.90909H7.36364C6.56 4.90909 5.90909 5.56 5.90909 6.36364V16.5455C5.90909 17.3491 6.56 18 7.36364 18H15.3636C16.1673 18 16.8182 17.3491 16.8182 16.5455V6.36364C16.8182 5.56 16.1673 4.90909 15.3636 4.90909ZM15.3636 16.5455H7.36364V6.36364H15.3636V16.5455Z" />
  </svg>
);

export const StarIcon = (
  <svg viewBox="0 0 14 13" fill="none">
    <path d="M6.81109 1.06634C6.87335 0.887223 7.12665 0.887225 7.18891 1.06634L8.2487 4.11521C8.41349 4.5893 8.85592 4.91074 9.35773 4.92097L12.5849 4.98673C12.7745 4.99059 12.8527 5.2315 12.7016 5.34606L10.1295 7.29614C9.72951 7.59936 9.56052 8.11947 9.70586 8.59987L10.6406 11.6894C10.6955 11.8709 10.4905 12.0198 10.3349 11.9115L7.68542 10.0678C7.27344 9.78113 6.72656 9.78113 6.31458 10.0678L3.66511 11.9115C3.50946 12.0198 3.30454 11.8709 3.35945 11.6894L4.29414 8.59988C4.43948 8.11947 4.27049 7.59936 3.87053 7.29614L1.29837 5.34606C1.14727 5.2315 1.22554 4.99059 1.41513 4.98673L4.64227 4.92097C5.14408 4.91074 5.58651 4.5893 5.7513 4.11521L6.81109 1.06634Z" />
  </svg>
);

export const QRCodeIcon = (
  <svg viewBox="0 0 16 16">
    <path d="M0 16.0001H7.27271V8.72729H0V16.0001ZM1.45443 10.182H5.81812V14.5343H1.45443V10.182Z" />
    <path d="M4.36369 11.6362H2.90918V13.0909H4.36369V11.6362Z" />
    <path d="M13.0916 14.5452H11.6367V15.9997H13.0916V14.5452Z" />
    <path d="M15.9997 14.5452H14.5449V15.9997H15.9997V14.5452Z" />
    <path d="M14.5458 10.182H13.0913V8.72729H8.72754V16.0001H10.1822V11.6364H11.6365V13.0911H16.0003V8.72729H14.5458V10.182Z" />
    <path d="M0 7.27286H7.27271V0H0V7.27286ZM1.45443 1.45443H5.81812V5.81812H1.45443V1.45443Z" />
    <path d="M4.36369 2.90894H2.90918V4.36356H4.36369V2.90894Z" />
    <path d="M8.72754 0V7.27286H16.0004V0H8.72754ZM14.5458 5.81812H10.1822V1.45443H14.5458V5.81812Z" />
    <path d="M13.0916 2.90894H11.6367V4.36356H13.0916V2.90894Z" />
  </svg>
);

export const PaperAirplaneIcon = (
  <svg viewBox="0 0 16 16">
    <path d="M15.75 0.0982143C15.9464 0.241071 16.0268 0.431548 15.9911 0.669643L13.7054 14.3839C13.6756 14.5565 13.5804 14.6905 13.4197 14.7857C13.3363 14.8333 13.2441 14.8571 13.1429 14.8571C13.0774 14.8571 13.006 14.8423 12.9286 14.8125L8.88394 13.1607L6.72323 15.7946C6.61609 15.9315 6.47025 16 6.28573 16C6.20835 16 6.14287 15.9881 6.0893 15.9643C5.97621 15.9226 5.88543 15.8527 5.81698 15.7545C5.74853 15.6563 5.7143 15.5476 5.7143 15.4286V12.3125L13.4286 2.85714L3.88394 11.1161L0.357158 9.66964C0.13692 9.58631 0.0178726 9.42262 1.5501e-05 9.17857C-0.0118893 8.94048 0.0833488 8.76488 0.28573 8.65179L15.1429 0.0803571C15.2322 0.0267857 15.3274 0 15.4286 0C15.5476 0 15.6548 0.0327381 15.75 0.0982143Z" />
  </svg>
);

export const TwoArrowsOutline = (
  <svg viewBox="0 0 6 12">
    <path
      d="M1 3L3 1L5 3M5 9L3 11L1 9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TwoArrows = (
  <svg viewBox="20 20 20 15">
    <path
      d="M34 31L30 35L26 31"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M34 23L30 19L26 23"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BackArrow = (
  <svg viewBox="0 0 18 10">
    <path
      d="M5 1L1 5L5 9"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="2" y="4" width="16" height="2" rx="1" />
  </svg>
);

export const DirectionArrow = (
  <svg viewBox="0 0 16 16" fill="none">
    <path d="M10.3313 5.13537C10.097 4.90106 10.097 4.52116 10.3313 4.28684C10.5656 4.05253 10.9455 4.05253 11.1798 4.28684L14.0243 7.13129C14.2586 7.36561 14.2586 7.7455 14.0243 7.97982L11.1798 10.8243C10.9455 11.0586 10.5656 11.0586 10.3313 10.8243C10.097 10.5899 10.097 10.2101 10.3313 9.97574L12.147 8.16L2.2 8.16C1.86863 8.16 1.6 7.89137 1.6 7.56C1.6 7.22863 1.86863 6.96 2.2 6.96L12.1559 6.96L10.3313 5.13537Z" />
  </svg>
);

export const SortByIcon = (
  <svg viewBox="0 0 14 14">
    <path d="M4.78481 6.2001L4.51041 5.1545H2.69841L2.41601 6.2001H0.76001L2.58001 0.600098H4.59041L6.43041 6.2001H4.78481ZM4.19761 3.9193L3.95681 3.0001C3.90161 2.7961 3.83281 2.5329 3.75281 2.2105C3.67281 1.8881 3.62001 1.6561 3.59281 1.5161C3.57041 1.6457 3.52534 1.85903 3.45761 2.1561C3.38988 2.45316 3.24054 3.03983 3.00961 3.9161L4.19761 3.9193Z" />
    <path d="M5.77756 13.4H1.41516V12.4648L3.83996 9.02485H1.47276V7.80005H5.71676V8.73125L3.29196 12.1784H5.77756V13.4Z" />
    <path d="M10.8064 9.4001V0.600098H9.2064V9.4001H6.8064L10.0064 13.4001L13.2064 9.4001H10.8064Z" />
  </svg>
);

export const helpIcon = (
  <svg viewBox="0 0 12 12">
    <circle cx="6" cy="6" r="5.5" />
    <path d="M5.45117 7.91992C5.45117 7.6888 5.45768 7.49512 5.4707 7.33887C5.48372 7.18262 5.51302 7.04427 5.55859 6.92383C5.60417 6.80339 5.67253 6.69108 5.76367 6.58691C5.85482 6.47949 5.98014 6.35742 6.13965 6.2207C6.24707 6.11328 6.35775 6.0026 6.47168 5.88867C6.58561 5.77148 6.68815 5.65104 6.7793 5.52734C6.8737 5.40039 6.9502 5.27018 7.00879 5.13672C7.07064 5.00326 7.10156 4.86491 7.10156 4.72168C7.10156 4.39941 7.01204 4.16016 6.83301 4.00391C6.65397 3.8444 6.39518 3.76465 6.05664 3.76465C5.92643 3.76465 5.79785 3.78255 5.6709 3.81836C5.5472 3.85091 5.43652 3.90299 5.33887 3.97461C5.24121 4.04622 5.16146 4.139 5.09961 4.25293C5.04102 4.36361 5.01172 4.49707 5.01172 4.65332H3.83984C3.8431 4.35059 3.90169 4.08366 4.01562 3.85254C4.13281 3.61816 4.29069 3.42285 4.48926 3.2666C4.68783 3.1071 4.92057 2.98828 5.1875 2.91016C5.45443 2.82878 5.74414 2.78809 6.05664 2.78809C6.4082 2.78809 6.7207 2.8304 6.99414 2.91504C7.26758 2.99642 7.4987 3.11686 7.6875 3.27637C7.87956 3.43587 8.02441 3.63281 8.12207 3.86719C8.22298 4.10156 8.27344 4.37012 8.27344 4.67285C8.27344 4.90397 8.23275 5.12044 8.15137 5.32227C8.07324 5.52083 7.96908 5.70801 7.83887 5.88379C7.71191 6.05957 7.56868 6.22396 7.40918 6.37695C7.24967 6.52995 7.0918 6.67643 6.93555 6.81641C6.83789 6.91406 6.76302 7.00195 6.71094 7.08008C6.65885 7.1582 6.61979 7.23796 6.59375 7.31934C6.57096 7.40072 6.55794 7.48861 6.55469 7.58301C6.55143 7.67741 6.5498 7.78971 6.5498 7.91992H5.45117ZM5.2998 9.41406C5.2998 9.22201 5.3584 9.06413 5.47559 8.94043C5.59603 8.81348 5.76693 8.75 5.98828 8.75C6.20964 8.75 6.38053 8.81348 6.50098 8.94043C6.62467 9.06413 6.68652 9.22201 6.68652 9.41406C6.68652 9.59961 6.62467 9.75423 6.50098 9.87793C6.38053 9.99837 6.20964 10.0586 5.98828 10.0586C5.76693 10.0586 5.59603 9.99837 5.47559 9.87793C5.3584 9.75423 5.2998 9.59961 5.2998 9.41406Z" />
  </svg>
);

export const InfoIcon = (
  <svg viewBox="0 0 18 18">
    <circle cx="9" cy="9" r="8" />
    <path d="M6.5 6.30273H9.74023V11.7051H11.8086V12.6426H6.5V11.7051H8.65625V7.24609H6.5V6.30273ZM8.51562 4.63867C8.51562 4.45898 8.56836 4.30859 8.67383 4.1875C8.7832 4.0625 8.94727 4 9.16602 4C9.38086 4 9.54297 4.0625 9.65234 4.1875C9.76172 4.30859 9.81641 4.45898 9.81641 4.63867C9.81641 4.81445 9.76172 4.96094 9.65234 5.07812C9.54297 5.19531 9.38086 5.25391 9.16602 5.25391C8.94727 5.25391 8.7832 5.19531 8.67383 5.07812C8.56836 4.96094 8.51562 4.81445 8.51562 4.63867Z" />
  </svg>
);

export const InformationIcon = (
  <svg viewBox="0 0 14 14">
    <path d="M6.35998 10.2H7.63998V6.35998H6.35998V10.2ZM6.99998 0.599976C3.46398 0.599976 0.599976 3.46398 0.599976 6.99998C0.599976 10.536 3.46398 13.4 6.99998 13.4C10.536 13.4 13.4 10.536 13.4 6.99998C13.4 3.46398 10.536 0.599976 6.99998 0.599976ZM6.99998 12.12C4.17758 12.12 1.87998 9.82238 1.87998 6.99998C1.87998 4.17758 4.17758 1.87998 6.99998 1.87998C9.82238 1.87998 12.12 4.17758 12.12 6.99998C12.12 9.82238 9.82238 12.12 6.99998 12.12ZM6.35998 5.07998H7.63998V3.79998H6.35998V5.07998Z" />
  </svg>
);

export const SearchIcon = (
  <svg viewBox="0 0 12 12">
    <g fillRule="evenodd">
      <path d="M8.337 7.402h-.494l-.172-.17c.608-.707.977-1.624.977-2.63C8.647 2.37 6.837.56 4.604.56 2.37.56.56 2.37.56 4.603s1.81 4.043 4.044 4.043c1.004 0 1.92-.368 2.628-.974l.17.17v.493l3.11 3.105.928-.928-3.103-3.11zm-3.733 0c-1.547 0-2.8-1.252-2.8-2.8 0-1.544 1.253-2.798 2.8-2.798 1.545 0 2.8 1.254 2.8 2.8 0 1.546-1.255 2.798-2.8 2.798z" />
    </g>
  </svg>
);

export const FilterIcon = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#clip0)">
      <path
        d="M5.35993 6.08008C4.57176 6.07886 3.87889 6.60179 3.66393 7.36008H1.67993V8.32008H3.66393C3.87527 9.08221 4.56904 9.60978 5.35993 9.60978C6.15083 9.60978 6.84459 9.08221 7.05593 8.32008H14.3199V7.36008H7.05593C6.84098 6.60179 6.1481 6.07886 5.35993 6.08008ZM5.35993 8.64008C4.9181 8.64008 4.55993 8.28191 4.55993 7.84008C4.55993 7.39825 4.9181 7.04008 5.35993 7.04008C5.80176 7.04008 6.15993 7.39825 6.15993 7.84008C6.15993 8.28191 5.80176 8.64008 5.35993 8.64008Z"
        fill="white"
      />
      <path
        d="M10.6399 1.68018C9.85176 1.67896 9.15889 2.20189 8.94393 2.96018H1.67993V3.92018H8.94393C9.15527 4.68231 9.84904 5.20988 10.6399 5.20988C11.4308 5.20988 12.1246 4.68231 12.3359 3.92018H14.3199V2.96018H12.3359C12.121 2.20189 11.4281 1.67896 10.6399 1.68018ZM10.6399 4.24018C10.1981 4.24018 9.83993 3.88201 9.83993 3.44018C9.83993 2.99835 10.1981 2.64018 10.6399 2.64018C11.0818 2.64018 11.4399 2.99835 11.4399 3.44018C11.4399 3.88201 11.0818 4.24018 10.6399 4.24018Z"
        fill="white"
      />
      <path
        d="M10.5802 10.5601C9.80986 10.5589 9.13268 11.0699 8.9226 11.811H1.82324V12.7493H8.9226C9.12915 13.4942 9.80719 14.0098 10.5802 14.0098C11.3531 14.0098 12.0312 13.4942 12.2377 12.7493H14.1767V11.811H12.2377C12.0276 11.0699 11.3505 10.5589 10.5802 10.5601ZM10.5802 13.062C10.1483 13.062 9.79829 12.712 9.79829 12.2802C9.79829 11.8484 10.1483 11.4983 10.5802 11.4983C11.012 11.4983 11.362 11.8484 11.362 12.2802C11.362 12.712 11.012 13.062 10.5802 13.062Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="12.8"
          height="12.8"
          fill="white"
          transform="translate(1.59998 1.6001)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const XIcon = (
  <svg viewBox="0 0 10 10">
    <path d="M1 1L9 9" strokeLinecap="round" />
    <path d="M9 1L1 9" strokeLinecap="round" />
  </svg>
);

export const AddIcon = (
  <svg viewBox="0 0 16 16">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.8001 2.39998C8.8001 1.95815 8.44192 1.59998 8.0001 1.59998C7.55827 1.59997 7.2001 1.95815 7.2001 2.39997L7.20011 7.2L2.40009 7.19998C1.95827 7.19998 1.6001 7.55815 1.6001 7.99998C1.6001 8.44181 1.95827 8.79998 2.4001 8.79998L7.20012 8.8L7.20014 13.6C7.20014 14.0418 7.55831 14.4 8.00014 14.4C8.44197 14.4 8.80014 14.0418 8.80014 13.6L8.80012 8.8L13.6001 8.80002C14.0419 8.80002 14.4001 8.44185 14.4001 8.00002C14.4001 7.55819 14.0419 7.20002 13.6001 7.20002L8.80011 7.2L8.8001 2.39998Z"
    />
  </svg>
);

export const ZoomOutIcon = (
  <svg viewBox="0 0 12 2">
    <rect width="12" height="2" />
  </svg>
);

export const ZoomInIcon = (
  <svg viewBox="0 0 12 12">
    <rect y="5" width="12" height="2" />
    <rect x="5" y="12" width="12" height="2" transform="rotate(-90 5 12)" />
  </svg>
);

export const ExclamationCircle = (
  <svg viewBox="0 0 16 16">
    <circle cx="8" cy="8" r="7.5" />
    <rect x="7.55566" y="3.55554" width="1.15556" height="6.22222" />
    <path d="M7.57252 10.8973C7.44279 11.0463 7.37793 11.2313 7.37793 11.4523C7.37793 11.6685 7.44279 11.8487 7.57252 11.9928C7.70706 12.137 7.90886 12.209 8.17793 12.209C8.44219 12.209 8.64159 12.137 8.77613 11.9928C8.91066 11.8487 8.97793 11.6685 8.97793 11.4523C8.97793 11.2313 8.91066 11.0463 8.77613 10.8973C8.64159 10.7436 8.44219 10.6667 8.17793 10.6667C7.90886 10.6667 7.70706 10.7436 7.57252 10.8973Z" />
  </svg>
);

export const InputErrorIcon = (c = '#ff2727') => (
  <svg viewBox="0 0 16 16">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-682.000000, -464.000000)">
        <g transform="translate(682.000000, 464.000000)">
          <circle stroke={c} strokeWidth="1" cx="8" cy="8" r="7" />
          <text
            transform="translate(8.000000, 7.500000) scale(-1, 1) translate(-8.000000, -7.500000) "
            fontFamily=".AppleSystemUIFont"
            fontSize="10.5"
            fontWeight="normal"
            letterSpacing="0.262500018"
            fill={c}
          >
            <tspan x="6.7" y="11.5">
              !
            </tspan>
          </text>
        </g>
      </g>
    </g>
  </svg>
);

export const Hint = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <circle cx="9" cy="9" r="8" strokeWidth="2" />
    <path d="M6.5 6.30273H9.74023V11.7051H11.8086V12.6426H6.5V11.7051H8.65625V7.24609H6.5V6.30273ZM8.51562 4.63867C8.51562 4.45898 8.56836 4.30859 8.67383 4.1875C8.7832 4.0625 8.94727 4 9.16602 4C9.38086 4 9.54297 4.0625 9.65234 4.1875C9.76172 4.30859 9.81641 4.45898 9.81641 4.63867C9.81641 4.81445 9.76172 4.96094 9.65234 5.07812C9.54297 5.19531 9.38086 5.25391 9.16602 5.25391C8.94727 5.25391 8.7832 5.19531 8.67383 5.07812C8.56836 4.96094 8.51562 4.81445 8.51562 4.63867Z" />
  </svg>
);

export const HintAlternate = (
  <svg viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM7.23242 8.47445C7.09961 8.79867 7.0332 9.23421 7.0332 9.78109H8.5332L8.55664 9.42367C8.59961 9.04086 8.76953 8.70687 9.06641 8.42171L9.54102 7.97054C9.91211 7.61117 10.1719 7.285 10.3203 6.99203C10.4688 6.69515 10.543 6.3807 10.543 6.04867C10.543 5.3182 10.3145 4.75375 9.85742 4.35531C9.40039 3.95296 8.75781 3.75179 7.92969 3.75179C7.10937 3.75179 6.46094 3.96273 5.98437 4.38461C5.51172 4.80648 5.27148 5.39046 5.26367 6.13656H6.96289C6.9707 5.82406 7.06055 5.57992 7.23242 5.40414C7.4082 5.22445 7.64062 5.13461 7.92969 5.13461C8.53906 5.13461 8.84375 5.46468 8.84375 6.12484C8.84375 6.34359 8.78516 6.55257 8.66797 6.75179C8.55078 6.94711 8.31445 7.20296 7.95898 7.51937C7.60742 7.83187 7.36523 8.15023 7.23242 8.47445ZM7.12695 10.9354C6.95117 11.1034 6.86328 11.3182 6.86328 11.5799C6.86328 11.8377 6.94922 12.0506 7.12109 12.2186C7.29688 12.3866 7.52734 12.4705 7.8125 12.4705C8.09766 12.4705 8.32617 12.3866 8.49805 12.2186C8.67383 12.0506 8.76172 11.8377 8.76172 11.5799C8.76172 11.3182 8.67188 11.1034 8.49219 10.9354C8.31641 10.7635 8.08984 10.6776 7.8125 10.6776C7.53516 10.6776 7.30664 10.7635 7.12695 10.9354Z"
    />
  </svg>
);

export const ImmediateImportance = (
  <svg viewBox="0 0 16 16">
    <circle cx="8" cy="8" r="7.5" />
    <rect x="7.55566" y="3.55566" width="1.15556" height="6.22222" />
    <path d="M7.57252 10.8974C7.44279 11.0463 7.37793 11.2313 7.37793 11.4523C7.37793 11.6685 7.44279 11.8487 7.57252 11.9929C7.70706 12.137 7.90886 12.2091 8.17793 12.2091C8.44219 12.2091 8.64159 12.137 8.77613 11.9929C8.91066 11.8487 8.97793 11.6685 8.97793 11.4523C8.97793 11.2313 8.91066 11.0463 8.77613 10.8974C8.64159 10.7436 8.44219 10.6667 8.17793 10.6667C7.90886 10.6667 7.70706 10.7436 7.57252 10.8974Z" />
  </svg>
);

export const DownloadIcon = (
  <svg viewBox="0 0 10 14">
    <path
      d="M8 6.46143L5 9.69219L2 6.46143"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="4"
      y="10.7693"
      width="10.7692"
      height="2"
      rx="1"
      transform="rotate(-90 4 10.7693)"
    />
  </svg>
);

export const DoubleArrowIcon = (
  <svg viewBox="0 0 15 16">
    <path
      d="M9.92676 9L13.1575 12L9.92676 15"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12 12C12 12.5523 11.5523 13 11 13H0.999998C0.447714 13 -1.43051e-06 12.5523 -1.43051e-06 12C-1.43051e-06 11.4477 0.447714 11 0.999999 11L11 11C11.5523 11 12 11.4477 12 12Z" />
    <path
      d="M4.23242 1L1.00165 4L4.23242 7"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2.15918 4C2.15918 4.55228 2.60689 5 3.15918 5H13.1592C13.7115 5 14.1592 4.55228 14.1592 4C14.1592 3.44772 13.7115 3 13.1592 3L3.15918 3C2.60689 3 2.15918 3.44772 2.15918 4Z" />
  </svg>
);

export const RepLogoIcon = (
  <svg viewBox="0 0 21 22">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6853 12.1662L13.7202 12.3743L13.7319 12.4565C13.8794 13.6022 14.3239 13.9371 15.4262 14.4253C15.4285 14.4262 15.4308 14.4258 15.4332 14.4267L19.432 16.193L10.4035 21.3478V18.3974C10.4035 17.3148 10.4686 17.1207 11.4291 16.5896C11.6178 16.4856 11.8086 16.3767 12.0177 16.2581L12.1481 16.1832C12.746 15.8639 13.2333 15.3915 13.5928 14.8316C13.6058 14.811 13.7019 14.6661 13.7147 14.6454C13.6522 14.6153 13.5862 14.5632 13.5083 14.4953C13.4569 14.4506 13.3806 14.3637 13.3431 14.2922C13.0285 14.9045 12.5507 15.4224 11.9392 15.7594L11.7912 15.8442C11.585 15.9614 11.3747 16.0763 11.1866 16.1796C10.0087 16.8309 9.91503 17.2299 9.91503 18.3974V21.351L0.803073 16.1023L4.70229 14.3971L4.95595 14.2878C5.05517 14.2394 5.36698 14.1121 5.60772 14.1047C5.85351 14.0896 6.2263 14.1054 6.42696 14.3614C6.71197 14.7226 6.98468 15.0676 6.98468 15.0676C7.41452 15.6252 7.97667 16.0813 8.64824 16.355C8.64824 16.355 8.6518 16.3573 8.65414 16.3582C8.65463 16.3582 8.65463 16.3585 8.65463 16.3585V16.3584C8.83169 16.4308 9.02214 16.4724 9.21124 16.5165C9.2501 16.4418 9.31145 16.3549 9.36752 16.2844C9.40809 16.2335 9.46883 16.1708 9.52551 16.1121C9.24014 16.056 8.9116 15.9654 8.65562 15.8425L8.65463 15.8419C8.14462 15.5991 7.70346 15.2592 7.36448 14.822C7.35944 14.816 7.34764 14.8019 7.34309 14.7952C7.3426 14.7946 7.32969 14.7767 7.31911 14.7616C7.28493 14.7158 7.25038 14.6717 7.21854 14.6243C7.12817 14.5026 6.9912 14.3212 6.79926 14.0789C6.67016 13.9148 6.48991 13.8069 6.29798 13.7374C6.29848 13.7375 6.29848 13.7378 6.29848 13.7379C6.09142 13.6636 5.85203 13.6306 5.591 13.6324C5.19534 13.6454 4.75578 13.8566 4.74705 13.8607L4.61008 13.9198H4.60971L4.59951 13.9241L4.24442 14.0771C4.24208 14.078 4.24208 14.0805 4.24024 14.0814L0.832582 15.5719L9.90679 1.08633V7.21776C9.90679 8.27733 9.82933 8.50873 8.86033 9.0444C8.78607 9.08542 8.70726 9.123 8.62611 9.16129C8.58504 9.18114 8.54311 9.20255 8.50106 9.22312C8.46922 9.23727 8.43934 9.25403 8.40836 9.26913C8.40786 9.26913 8.407 9.26937 8.407 9.26961L8.40651 9.26985C7.13517 9.88031 6.24782 11.1185 6.17024 12.5637C6.25384 12.5864 6.38012 12.6223 6.45069 12.6437C6.50233 12.6592 6.58028 12.6979 6.64619 12.7334C6.65873 11.3978 7.46481 10.2457 8.6293 9.68959C8.6298 9.68935 8.6298 9.68923 8.6298 9.68888C8.63299 9.68757 8.63582 9.68816 8.63853 9.68685C8.70861 9.65071 8.77636 9.61836 8.84324 9.5865C8.93324 9.54345 9.01993 9.50172 9.10329 9.45558C9.27715 9.35974 9.42112 9.26961 9.55219 9.18114C9.5876 9.15796 9.6176 9.13311 9.64994 9.10992C9.72088 9.05843 9.78777 9.00576 9.84581 8.95391C9.87962 8.92466 9.91048 8.89696 9.93261 8.86997C10.3205 8.47615 10.3965 8.03286 10.3965 7.21776V1.08348L19.4989 15.7034L15.4815 13.9291C15.481 13.9286 15.4801 13.9292 15.4793 13.9291C14.5882 13.5347 14.3175 13.2051 14.198 12.2574C14.1963 12.2444 14.1926 12.2122 14.1894 12.2001C13.9598 10.6845 12.828 9.46842 11.3414 9.04321C11.2399 9.0142 11.1599 8.99042 11.1407 8.98519C11.1101 9.08245 11.0662 9.16521 11.0415 9.20754C10.9896 9.29601 10.9368 9.3576 10.8829 9.41694C10.9057 9.42205 11.0474 9.45273 11.0699 9.4582C12.4066 9.78555 13.4403 10.8369 13.6853 12.1662ZM20.252 15.9966L10.3633 0.114269C10.3195 0.043401 10.2401 0 10.1544 0C10.0686 0 9.98929 0.0434009 9.94552 0.113913L0.0351062 15.933C0.00153995 15.9865 -0.00866518 16.0516 0.00756467 16.1125C0.0226879 16.1733 0.0627707 16.226 0.119083 16.2582L10.0295 21.9668C10.0677 21.9889 10.1116 22 10.1544 22C10.1973 22 10.2401 21.9889 10.2785 21.9672L20.1671 16.3218C20.2234 16.2895 20.263 16.2374 20.2798 16.1765C20.2959 16.1152 20.2861 16.0506 20.252 15.9966Z"
    />
  </svg>
);

export const Syncing = (
  <svg viewBox="0 0 14 12">
    <path d="M6.36643 0.00734295C4.12225 0.125763 2.1423 1.64454 1.53941 3.84715C1.50649 3.97009 1.52359 4.10106 1.58697 4.21143C1.65034 4.3218 1.75483 4.40259 1.8776 4.43613C2.00036 4.46968 2.13142 4.45327 2.24212 4.39047C2.35281 4.32767 2.43414 4.2236 2.46833 4.10101C3.02943 2.05098 5.05513 0.721383 7.21826 1.0002C9.15088 1.24931 10.6264 2.70899 10.9208 4.52974L10.6369 4.24956C10.5918 4.2035 10.538 4.16696 10.4785 4.14209C10.4191 4.11721 10.3553 4.10452 10.2909 4.10477C10.1949 4.10515 10.1012 4.13419 10.0219 4.18818C9.94258 4.24216 9.88119 4.31862 9.84562 4.40775C9.81005 4.49687 9.80193 4.59459 9.82229 4.68837C9.84266 4.78214 9.89058 4.86769 9.95991 4.93403L11.1258 6.08485C11.2159 6.17395 11.3375 6.22392 11.4642 6.22392C11.591 6.22392 11.7126 6.17395 11.8027 6.08485L12.9667 4.93403C13.0158 4.89072 13.0556 4.83785 13.0836 4.77864C13.1116 4.71943 13.1272 4.65514 13.1295 4.58969C13.1317 4.52424 13.1207 4.45901 13.0969 4.398C13.0731 4.33698 13.0371 4.28146 12.9911 4.23483C12.9451 4.18821 12.8901 4.15145 12.8294 4.12682C12.7687 4.10219 12.7037 4.09019 12.6382 4.09157C12.5727 4.09295 12.5082 4.10767 12.4486 4.13484C12.389 4.162 12.3356 4.20104 12.2916 4.24956L11.893 4.64257C11.635 2.28394 9.77694 0.359012 7.34049 0.0449513C7.01232 0.00264943 6.68703 -0.00957422 6.36643 0.00734295ZM2.03395 5.77834C1.91074 5.78029 1.79296 5.82942 1.70488 5.91561L0.540905 7.06642C0.494468 7.11043 0.457267 7.16325 0.431477 7.2218C0.405687 7.28034 0.391824 7.34344 0.390699 7.40741C0.389575 7.47138 0.40121 7.53492 0.424926 7.59434C0.448642 7.65376 0.483963 7.70785 0.528825 7.75347C0.573686 7.79908 0.627188 7.83529 0.686205 7.85999C0.745221 7.88469 0.808569 7.89737 0.872544 7.89731C0.93652 7.89724 0.999842 7.88443 1.05881 7.85961C1.11778 7.8348 1.1712 7.79848 1.21597 7.75277L1.61462 7.35977C1.87388 9.71706 3.73166 11.6416 6.16711 11.9555C8.79251 12.2939 11.2792 10.6707 11.9682 8.1533C12.0011 8.03036 11.984 7.89938 11.9206 7.78901C11.8573 7.67864 11.7528 7.59784 11.63 7.56429C11.5072 7.53074 11.3762 7.54716 11.2655 7.60997C11.1548 7.67277 11.0734 7.77685 11.0393 7.89945C10.4782 9.94948 8.45249 11.281 6.28933 11.0021C4.35792 10.7532 2.88251 9.29209 2.5868 7.47259L2.87074 7.75277C2.96183 7.84215 3.08466 7.89175 3.21227 7.89071C3.33988 7.88966 3.46187 7.83804 3.55149 7.74718C3.6411 7.65632 3.69103 7.53363 3.69032 7.40602C3.68961 7.2784 3.63831 7.15628 3.54769 7.06642L2.38183 5.91561C2.33593 5.87068 2.28151 5.83539 2.22177 5.81181C2.16202 5.78824 2.09816 5.77686 2.03395 5.77834Z" />
  </svg>
);

export const MenuChevron = (
  <svg width="6" height="10" viewBox="0 0 6 10" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.83773 7.77749C5.13988 8.06083 5.15513 8.53546 4.8718 8.8376C4.58846 9.13975 4.11383 9.15501 3.81168 8.87167L0.266756 5.54749C0.205989 5.49051 0.156826 5.42579 0.119363 5.35629C-0.0389517 5.06387 0.0123345 4.69061 0.266282 4.45248L3.81121 1.1283C4.11336 0.844963 4.58799 0.860216 4.87132 1.16237C5.15466 1.46452 5.1394 1.93914 4.83725 2.22248L1.87554 4.99976L4.83773 7.77749Z"
    />
  </svg>
);

export const RotatableChevron = (
  <svg viewBox="0 0 16 16">
    <path
      d="M6 12L10 8L6 4"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LeftChevron = (
  <svg viewBox="0 0 6 10" fill="none">
    <path
      d="M5 9L1 5L5 1"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SortIcon = (
  <svg viewBox="0 0 6 8">
    <path d="M3 8L5.59808 5H0.401924L3 8Z" />
    <path d="M3 0L5.59808 3H0.401924L3 0Z" />
  </svg>
);

export const CheckMark = (
  <svg viewBox="0 0 11 9" fill="none">
    <path
      d="M0.658203 5.6L2.75096 8L9.50721 1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Dot = (
  <svg viewBox="0 0 4 4">
    <circle cx="2" cy="2" r="2" />
  </svg>
);

export const DotDotDot = (
  <svg viewBox="0 0 10 16">
    <circle cx="8" cy="1.5" r="1.5" />
    <circle cx="8" cy="14.5" r="1.5" />
    <circle cx="8" cy="8" r="1.5" />
  </svg>
);

export const ShareIcon = (
  <svg viewBox="0 0 16 16" fill="none">
    <path d="M11.7889 1.59961C10.8513 1.59961 10.0814 2.37393 10.0814 3.31201C10.0814 3.48512 10.1162 3.64911 10.1647 3.80674L5.31556 6.79693C5.00586 6.48522 4.5771 6.2905 4.10618 6.2905C3.16863 6.2905 2.40039 7.0582 2.40039 7.99631C2.40039 8.93439 3.16863 9.70872 4.10618 9.70872C4.57747 9.70872 5.00747 9.51269 5.31723 9.19894L10.1664 12.1891C10.1162 12.3497 10.0814 12.5177 10.0814 12.6939C10.0814 13.632 10.8513 14.3996 11.7889 14.3996C12.7265 14.3996 13.4947 13.632 13.4947 12.6939C13.4947 11.7558 12.7265 10.9814 11.7889 10.9814C11.3332 10.9814 10.9182 11.1655 10.6112 11.4612L5.74035 8.45936C5.78274 8.31076 5.81361 8.15768 5.81361 7.99631C5.81361 7.83675 5.7835 7.68489 5.74197 7.53818L10.6045 4.53471C10.9121 4.83224 11.3302 5.01783 11.7889 5.01783C12.7264 5.01783 13.4946 4.25013 13.4946 3.31201C13.4946 2.37393 12.7264 1.59961 11.7889 1.59961ZM11.7889 2.45576C12.2645 2.45576 12.6384 2.83387 12.6384 3.31201C12.6384 3.79016 12.2645 4.16827 11.7889 4.16827C11.3132 4.16827 10.931 3.79016 10.931 3.31201C10.931 2.83387 11.3132 2.45576 11.7889 2.45576ZM4.10614 7.14006C4.58177 7.14006 4.96404 7.51817 4.96404 7.99631C4.96404 8.47446 4.58177 8.85247 4.10614 8.85247C3.63053 8.85247 3.25658 8.47446 3.25658 7.99631C3.25658 7.51817 3.63053 7.14006 4.10614 7.14006ZM11.7889 11.8376C12.2645 11.8376 12.6384 12.2157 12.6384 12.6939C12.6384 13.172 12.2645 13.55 11.7889 13.55C11.3132 13.55 10.931 13.172 10.931 12.6939C10.931 12.2157 11.3132 11.8376 11.7889 11.8376Z" />
  </svg>
);

export const Close = (
  <svg viewBox="0 0 8 8" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.19701 6.85218C-0.0655349 7.11473 -0.0655349 7.54039 0.19701 7.80294C0.459555 8.06548 0.885225 8.06548 1.14777 7.80294L3.99992 4.95081L6.85223 7.80309C7.11478 8.06564 7.54044 8.06564 7.80299 7.80309C8.06554 7.54055 8.06554 7.11488 7.80299 6.85234L4.95068 4.00005L7.80309 1.14766C8.06564 0.885118 8.06564 0.459451 7.80309 0.196908C7.54055 -0.0656359 7.11488 -0.0656359 6.85233 0.196908L3.99992 3.0493L1.14767 0.197064C0.885124 -0.0654795 0.459454 -0.0654795 0.196909 0.197064C-0.0656363 0.459607 -0.0656363 0.885274 0.196909 1.14782L3.04916 4.00005L0.19701 6.85218Z"
    ></path>
  </svg>
);

export const PaperClip = (
  <svg viewBox="0 0 22 22">
    <path d="M3.78899 13.089C2.21787 14.6601 2.21787 17.2179 3.78898 18.789C5.36009 20.3601 7.91786 20.3601 9.48898 18.789L12.639 15.639C12.6995 15.5802 12.7476 15.51 12.7807 15.4324C12.8138 15.3548 12.8312 15.2715 12.8318 15.1871C12.8324 15.1028 12.8162 15.0192 12.7842 14.9411C12.7522 14.8631 12.705 14.7922 12.6454 14.7326C12.5858 14.6729 12.5149 14.6257 12.4368 14.5937C12.3588 14.5617 12.2752 14.5456 12.1908 14.5462C12.1065 14.5468 12.0231 14.5641 11.9456 14.5972C11.868 14.6303 11.7978 14.6785 11.739 14.739L8.58898 17.889C7.50089 18.9771 5.77707 18.9771 4.68898 17.889C3.6009 16.8009 3.6009 15.0771 4.68899 13.989L7.83899 10.839C8.92707 9.7509 10.6509 9.7509 11.739 10.839C11.7978 10.8995 11.868 10.9476 11.9456 10.9807C12.0231 11.0138 12.1065 11.0312 12.1908 11.0318C12.2752 11.0324 12.3588 11.0162 12.4368 10.9842C12.5149 10.9522 12.5858 10.905 12.6454 10.8454C12.705 10.7858 12.7522 10.7149 12.7842 10.6368C12.8162 10.5588 12.8324 10.4752 12.8318 10.3908C12.8312 10.3065 12.8138 10.2231 12.7807 10.1456C12.7476 10.068 12.6995 9.99777 12.639 9.93898C11.0679 8.36787 8.5101 8.36787 6.93899 9.93899L3.78899 13.089ZM9.90617 6.97181C9.84921 7.03306 9.80488 7.10492 9.7757 7.18331C9.74652 7.26169 9.73305 7.34505 9.73609 7.42863C9.73913 7.51221 9.75861 7.59438 9.79341 7.67043C9.82821 7.74649 9.87765 7.81495 9.93891 7.8719C10.0002 7.92885 10.072 7.97316 10.1504 8.00233C10.2288 8.0315 10.3122 8.04494 10.3958 8.04188C10.4794 8.03883 10.5615 8.01933 10.6376 7.98452C10.7136 7.94971 10.7821 7.90026 10.839 7.83899L13.989 4.68899C15.0771 3.6009 16.8009 3.6009 17.889 4.68898C18.9771 5.77707 18.9771 7.5009 17.889 8.58898L14.739 11.739C13.6509 12.8271 11.9271 12.8271 10.839 11.739C10.7802 11.6785 10.71 11.6303 10.6324 11.5972C10.5548 11.5641 10.4715 11.5468 10.3871 11.5462C10.3028 11.5456 10.2192 11.5618 10.1411 11.5938C10.0631 11.6257 9.99221 11.6729 9.93257 11.7326C9.87294 11.7922 9.82575 11.8631 9.79375 11.9411C9.76175 12.0192 9.74558 12.1028 9.74618 12.1871C9.74677 12.2715 9.76412 12.3548 9.79722 12.4324C9.83032 12.51 9.87851 12.5802 9.93898 12.639C11.5101 14.2101 14.0679 14.2101 15.639 12.639L18.789 9.48898C20.3601 7.91786 20.3601 5.3601 18.789 3.78898C17.2179 2.21787 14.6601 2.21787 13.089 3.78899L9.93899 6.93899C9.92765 6.94953 9.91671 6.96047 9.90617 6.97181Z" />
  </svg>
);
// prevIcon, nextIcon need to be refactored still to remove colors, leaving for now.
export const prevIcon = (
  <svg width="7px" height="11px" viewBox="0 0 7 11">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-24.000000, -406.000000)"
        fill="#FFFFFF"
        fillRule="nonzero"
      >
        <g transform="translate(-1.000000, 72.000000)">
          <g transform="translate(0.000000, 152.000000)">
            <g transform="translate(25.000000, 179.000000)">
              <polygon
                transform="translate(3.333333, 8.083333) rotate(-90.000000) translate(-3.333333, -8.083333) "
                points="3.33333333 4.75 8.33333333 11.4166667 -1.66666667 11.4166667"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const nextIcon = (
  <svg width="7px" height="11px" viewBox="0 0 7 11">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-156.000000, -406.000000)"
        fill="#FFFFFF"
        fillRule="nonzero"
      >
        <g transform="translate(-1.000000, 72.000000)">
          <g transform="translate(0.000000, 152.000000)">
            <g transform="translate(119.000000, 179.000000)">
              <polygon
                transform="translate(41.333333, 8.083333) scale(-1, 1) rotate(-90.000000) translate(-41.333333, -8.083333) "
                points="41.3333333 4.75 46.3333333 11.4166667 36.3333333 11.4166667"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const Person = (
  <svg viewBox="0 0 15 16">
    <path d="M11.7333 4.26667C11.7333 6.62308 9.82309 8.53333 7.46668 8.53333C5.11026 8.53333 3.20001 6.62308 3.20001 4.26667C3.20001 1.91025 5.11026 0 7.46668 0C9.82309 0 11.7333 1.91025 11.7333 4.26667Z" />
    <path d="M5.03344 8.93878C2.10437 9.94792 0 12.7282 0 16H14.9333C14.9333 12.7282 12.829 9.94793 9.89991 8.93879C9.1721 9.3186 8.34447 9.53335 7.46668 9.53335C6.58889 9.53335 5.76125 9.3186 5.03344 8.93878Z" />
  </svg>
);

export const Filter = (
  <svg viewBox="0 0 24 24">
    <path d="M7.04999 8.39991C5.57218 8.39762 4.27303 9.37811 3.86999 10.7999H0.149994V12.5999H3.86999C4.26626 14.0289 5.56707 15.0181 7.04999 15.0181C8.53292 15.0181 9.83373 14.0289 10.23 12.5999H23.85V10.7999H10.23C9.82695 9.37811 8.52781 8.39762 7.04999 8.39991ZM7.04999 13.1999C6.22157 13.1999 5.54999 12.5283 5.54999 11.6999C5.54999 10.8715 6.22157 10.1999 7.04999 10.1999C7.87842 10.1999 8.54999 10.8715 8.54999 11.6999C8.54999 12.5283 7.87842 13.1999 7.04999 13.1999Z" />
    <path d="M16.95 0.149906C15.4722 0.147624 14.173 1.12811 13.77 2.54991H0.149994V4.34991H13.77C14.1663 5.77891 15.4671 6.76809 16.95 6.76809C18.4329 6.76809 19.7337 5.77891 20.13 4.34991H23.85V2.54991H20.13C19.727 1.12811 18.4278 0.147624 16.95 0.149906ZM16.95 4.94991C16.1216 4.94991 15.45 4.27833 15.45 3.44991C15.45 2.62148 16.1216 1.94991 16.95 1.94991C17.7784 1.94991 18.45 2.62148 18.45 3.44991C18.45 4.27833 17.7784 4.94991 16.95 4.94991Z" />
    <path d="M16.8378 16.8001C15.3935 16.7978 14.1238 17.7561 13.7299 19.1457H0.418579V20.9049H13.7299C14.1172 22.3015 15.3885 23.2682 16.8378 23.2682C18.2871 23.2682 19.5584 22.3015 19.9457 20.9049H23.5814V19.1457H19.9457C19.5518 17.7561 18.2821 16.7978 16.8378 16.8001ZM16.8378 21.4913C16.0281 21.4913 15.3718 20.8349 15.3718 20.0253C15.3718 19.2156 16.0281 18.5593 16.8378 18.5593C17.6474 18.5593 18.3038 19.2156 18.3038 20.0253C18.3038 20.8349 17.6474 21.4913 16.8378 21.4913Z" />
  </svg>
);

export const MobileNavHamburgerIcon = () => (
  <svg viewBox="0 0 16 12" className="mobile-nav-hamburger-icon">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
    >
      <g
        id="Nav/Header"
        transform="translate(-16.000000, -18.000000)"
        stroke="#FFFFFF"
      >
        <g id="Icon/Mobile/Menu" transform="translate(16.000000, 16.000000)">
          <g id="Group" transform="translate(0.666667, 2.000000)">
            <path d="M0,6 L14.6676925,6" id="MobileNavHamburgerIconLine1" />
            <path
              d="M0,11.3333333 L14.6676925,11.3333333"
              id="MobileNavHamburgerIconLine2"
            />
            <path
              d="M0,0.666666667 L14.6676925,0.666666667"
              id="MobileNavHamburgerIconLine3"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const MobileNavCloseIcon = () => (
  <svg viewBox="0 0 16 14" className="mobile-nav-close-icon">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
    >
      <g
        id="Nav/Header-Close"
        transform="translate(-16.000000, -17.000000)"
        stroke="#F6F6F8"
      >
        <g id="Icon/Close" transform="translate(16.000000, 16.000000)">
          <path
            d="M1.50624875,1.50624875 L14.4759537,14.4759537"
            id="MobileNavCloseIconLine"
          />
          <path
            d="M14.3030383,1.33333333 L1.33333333,14.3030383 L14.3030383,1.33333333 Z"
            id="MobileNavCloseIconLineJoinRound"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const MobileNavBackIcon = () => (
  <svg viewBox="0 0 8 14" className="mobile-nav-back-icon">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g
        id="Nav/Header-Back"
        transform="translate(-20.000000, -17.000000)"
        stroke="#FFFFFF"
      >
        <g id="Icon/back" transform="translate(16.000000, 16.000000)">
          <polyline
            id="Stroke-3"
            transform="translate(11.156854, 7.863961) rotate(-135.000000) translate(-11.156854, -7.863961) "
            points="6.65685425 3.36396103 15.6568542 3.36396103 15.6568542 12.363961"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const ArchivedIcon = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="7.5" fill="#252429" stroke="#3C3B43" />
    <g clipPath="url(#clip0)">
      <path
        d="M10.6191 6.42858V5.38096H6.95238L6.42857 4.33334H4.33334V10.0952"
        stroke="#9599A5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.85715 11.6667L6.42858 7.4762H12.1905L10.6191 11.6667H4.85715Z"
        stroke="#9599A5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect x="4" y="4" width="8.66667" height="8" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// ## STATIC ICONS FOR THIRD PARTY
export const Ledger = (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    xmlns="http://www.w3.org/1999/xlink"
  >
    <defs />
    <g
      id="Create/Connect-Account"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="SoftwareWalletDisconnectedActive"
        transform="translate(-24.000000, -239.000000)"
        fill="#FFFFFF"
        fillRule="nonzero"
      >
        <g id="dropdown" transform="translate(0.000000, 72.000000)">
          <g id="ledger" transform="translate(0.000000, 152.000000)">
            <g id="ledgerLogo" transform="translate(24.000000, 15.000000)">
              <path d="M15.1127835,0 L6.82994618,0 L6.82994618,11.1103292 L17.9461595,11.1103292 L17.9461475,2.89067605 C17.9506737,1.32998241 16.674302,1.60715874e-16 15.1127835,0 Z M4.28625516,0 L2.89672999,0 C1.33521148,0 0,1.27117366 0,2.8951998 L0,4.28399095 L4.28625516,4.28399095 L4.28625516,0 Z M0,6.88514702 L4.28625516,6.88514702 L4.28625516,11.169138 L0,11.169138 L0,6.88514702 Z M13.6644185,17.9954763 L15.0539437,17.9954763 C16.6154622,17.9954763 17.9506737,16.7243026 17.9506737,15.1002765 L17.9506737,13.716009 L13.6644185,13.716009 L13.6644185,17.9954763 Z M6.82994618,13.716009 L11.1162013,13.716009 L11.1162013,18 L6.82994618,18 L6.82994618,13.716009 Z M0,13.716009 L0,15.1048002 C0,16.6654938 1.27184551,18 2.89672999,18 L4.28625516,18 L4.28625516,13.716009 L0,13.716009 Z" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const Trezor = (
  <svg width="13px" height="18px" viewBox="0 0 13 18" version="1.1">
    <defs />
    <g
      id="Create/Connect-Account"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="SoftwareWalletDisconnectedActive"
        transform="translate(-27.000000, -191.000000)"
        fill="#FFFFFF"
        fillRule="nonzero"
      >
        <g id="dropdown" transform="translate(0.000000, 72.000000)">
          <g id="trezor" transform="translate(0.000000, 104.000000)">
            <path
              d="M37.5237142,20.5296365 L39.326924,20.5296365 L39.326924,30.1125063 L39.3145205,30.1125063 L33.1636759,33 L27.0124035,30.1125063 L27,30.1125063 L27,20.5296365 L28.8040653,20.5296365 L28.8040653,19.1842878 C28.8040653,16.8773006 30.760394,15 33.1645313,15 C35.5673854,15 37.5237142,16.8773006 37.5237142,19.1842878 L37.5237142,20.5296365 Z M36.8462273,28.5187988 L36.8462273,22.7781863 L29.4806967,22.7781863 L29.4806967,28.5187988 L33.1636759,30.2435607 L36.8462273,28.5187988 Z M31.0405417,19.1842878 L31.0405417,20.5296365 L35.2872378,20.5296365 L35.2872378,19.1842878 C35.2872378,18.1165167 34.3343081,17.2476904 33.1645313,17.2476904 C31.9934714,17.2476904 31.0405417,18.1165167 31.0405417,19.1842878 Z"
              id="trezorLogo"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const Fortmatic = (
  <svg width="24px" height="24px" viewBox="0 0 10 10" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.77778 1H9V2.77778H2.77778V9H1V2.77778V1H2.77778ZM5 5H9L9.00001 6.77778V7.66667L7.22223 9V6.77778H5V5Z"
      fill="white"
    />
  </svg>
);

export const Portis = (
  <svg width="24px" height="24px" viewBox="0 0 10 10" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.01409 8.99973C6.67872 8.99973 8.02817 7.65028 8.02817 5.98564C8.02817 4.82127 7.04504 3.48339 6.11029 2.21136C5.85458 1.86337 5.60248 1.52031 5.37513 1.18708C5.20494 0.937639 4.82324 0.93764 4.65305 1.18708C4.42569 1.52031 4.1736 1.86337 3.91788 2.21136C2.98313 3.48339 2 4.82127 2 5.98564C2 7.65028 3.34945 8.99973 5.01409 8.99973ZM7.89422 5.2317L5.01409 3.55721L2.13396 5.2317L5.01409 6.90619L7.89422 5.2317Z"
      fill="white"
    />
  </svg>
);

export const MetaMask = (
  <svg width="19px" height="20px" viewBox="0 0 19 20" version="1.1">
    <defs />
    <g
      id="Create/Connect-Account"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="SoftwareWalletDisconnectedActive"
        transform="translate(-23.000000, -94.000000)"
        stroke="#FFFFFF"
      >
        <g id="dropdown" transform="translate(0.000000, 72.000000)">
          <g id="metaMask" transform="translate(0.000000, 8.000000)">
            <g id="metamaskLogo" transform="translate(23.909091, 15.000000)">
              <polygon
                id="Stroke-1"
                strokeLinecap="round"
                points="5.42289817 0.156604444 7.37789817 2.49299556 10.8538254 2.49299556 16.7192436 1.00627556 14.98128 5.46684444 15.6332255 6.10389332 15.1983164 6.52872888 15.6332255 6.74135112 15.1983164 7.16618668 15.4157709 7.80364444 14.8453709 8.97184 14.7638255 10.1400356 14.98128 11.6267556 14.98128 13.3260978 16.2847527 14.8128178 16.93628 15.2376533 16.5017891 16.2995378 15.1983164 17.7866667 12.8088254 17.7866667 7.31809816 15.9229511 1.72951637 17.7866667 0.209007273 13.9635556 2.38146182 9.07774224 1.51248 8.22807112 2.16442546 8.01585776 1.07798909 7.37880888 1.94697091 7.16618668 0.860952727 6.52872888 1.51248 6.31651556 1.51248 5.25463112 2.81595273 2.70561778"
              />
              <polyline
                id="Stroke-3"
                strokeLinecap="round"
                points="16.3932291 14.9191289 15.3072109 14.9191289 15.0897564 15.3439644 15.0897564 16.6184711 16.3719018 16.4267022"
              />
              <polygon
                id="Stroke-6"
                strokeLinecap="round"
                points="14.1816431 10.6363636 14.7272727 11.2907831 13.9090909 11.4545455"
              />
              <polygon
                id="Stroke-7"
                strokeLinecap="round"
                points="9.74372357 10.6363636 10.6363636 12.2727273 8.18181818 11.7272728"
              />
              <polyline
                id="Stroke-8"
                points="7.31079802 2.45454545 9 5.11343951 5.62159599 8.7952577 2.45454545 9"
              />
              <polyline
                id="Stroke-9"
                strokeLinecap="round"
                points="8.75830948 13.9090909 14.7272727 15.645097 7.36363636 16.3636364"
              />
              <polyline
                id="Stroke-10"
                strokeLinecap="round"
                points="9 13.0909091 6.38165021 10.6363637 5.72727273 9"
              />
              <polyline
                id="Stroke-11"
                strokeLinecap="round"
                points="14.7272727 14.7272727 11.6590768 11.802648 11.0452014 10.1314339 9 4.90909091"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const LogoutIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 18 18"
    className="nav-logout-icon"
    style={{ marginLeft: '.28rem', width: '1.2rem' }}
  >
    <g fill="#FFF" fillRule="nonzero">
      <path d="M14.16 10.123H5.624a1.125 1.125 0 0 1 0-2.25h8.534l-1.454-1.455a1.125 1.125 0 0 1 1.59-1.59l3.375 3.374a1.125 1.125 0 0 1 0 1.591l-3.375 3.375a1.125 1.125 0 1 1-1.59-1.59l1.454-1.455z" />
      <path d="M9 15.5v-2a1 1 0 0 1 2 0v4H0V0h11v4a1 1 0 0 1-2 0V2H2v13.5h7z" />
    </g>
  </svg>
);

export const errorIcon = (
  <svg width="16px" height="16px" viewBox="0 0 16 16">
    <defs />
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-24.000000, -607.000000)">
        <g transform="translate(24.000000, 607.000000)">
          <g>
            <g>
              <circle fill="#FF0050" cx="8" cy="8" r="8" />
              <path
                d="M8.87821659,10.1462941 L6.93119318,10.1462941 L6.62451916,3.05 L9.1848906,3.05 L8.87821659,10.1462941 Z M6.55319962,12.3571998 C6.55319962,12.005355 6.68038486,11.7165137 6.93475916,11.4906674 C7.18913345,11.2648211 7.50650222,11.1518996 7.886875,11.1518996 C8.26724777,11.1518996 8.58461655,11.2648211 8.83899084,11.4906674 C9.09336513,11.7165137 9.22055037,12.005355 9.22055037,12.3571998 C9.22055037,12.7090446 9.09336513,12.9978859 8.83899084,13.2237322 C8.58461655,13.4495785 8.26724777,13.5625 7.886875,13.5625 C7.50650222,13.5625 7.18913345,13.4495785 6.93475916,13.2237322 C6.68038486,12.9978859 6.55319962,12.7090446 6.55319962,12.3571998 Z"
                fill="#FFFFFF"
                transform="translate(7.886875, 8.306250) scale(-1, 1) translate(-7.886875, -8.306250) "
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const Alerts = unseenCount => (
  <svg viewBox="0 0 34 24">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <g
          transform="translate(4.000000, 1.000000)"
          stroke="#FFFFFF"
          strokeWidth="0"
        >
          <path
            d="M7.9209 2.57172V1.94672C7.9209 1.12172 8.5959 0.446716 9.4209 0.446716C10.2459 0.446716 10.9209 1.12172 10.9209 1.94672V2.54672"
            stroke="#FFFFFF"
            strokeWidth="0.894"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.4209 20.4472C11.4209 21.5512 10.5249 22.4472 9.4209 22.4472C8.3169 22.4472 7.4209 21.5512 7.4209 20.4472"
            fill="#FFFFFF"
          />
          <path
            d="M11.4209 20.4472C11.4209 21.5512 10.5249 22.4472 9.4209 22.4472C8.3169 22.4472 7.4209 21.5512 7.4209 20.4472C7.4209 20.4472 8.63985 20.4472 9.4209 20.4472C10.2019 20.4472 11.4209 20.4472 11.4209 20.4472Z"
            stroke="#FFFFFF"
            strokeWidth="0.894"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.3387 17.4493C16.5787 14.4473 15.2627 11.4473 15.4207 8.44727C15.5787 5.44727 12.7347 2.44727 9.42066 2.44727C6.10666 2.44727 3.24666 5.13827 3.42066 8.44727C3.57866 11.4473 2.57866 14.4473 0.578663 17.4473C-1.42134 20.4473 20.0987 20.4503 18.3387 17.4493Z"
            fill="#FFFFFF"
            stroke="#FFFFFF"
            strokeWidth="0.894"
          />
        </g>
        {!!unseenCount && (
          <g transform="translate(13.000000, 2.000000)" textAnchor="middle">
            <rect
              x="0.5"
              y="0.5"
              width="21"
              height="13"
              rx="6.5"
              fill="#FD6266"
              stroke="#211A32"
            />
            <text
              fontFamily="Inter-Bold, Inter"
              fontSize="8"
              fontWeight="bold"
              fill="#FFFFFF"
            >
              <tspan x="11.01902362" y="10.0428031">
                {unseenCount}
              </tspan>
            </text>
          </g>
        )}
      </g>
    </g>
  </svg>
);
// TODO: ChevronUp and Down are only used by marketHeader... refactor
export const ChevronUp = () => (
  <svg viewBox="0 0 16 16">
    <g
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g stroke="#A7A2B2">
        <polyline
          transform="translate(8.156854, 11.156854) scale(1, -1) rotate(-225.000000) translate(-8.156854, -11.156854) "
          points="3.65685425 6.65685425 12.6568542 6.65685425 12.6568542 15.6568542"
        />
      </g>
    </g>
  </svg>
);
export const ChevronDown = p => (
  <svg viewBox="0 0 16 16">
    <g
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g stroke={p.stroke || '#A7A2B2'}>
        <polyline
          transform="translate(8.156854, 6.156854) rotate(-225.000000) translate(-8.156854, -6.156854) "
          points="3.65685425 1.65685425 12.6568542 1.65685425 12.6568542 10.6568542"
        />
      </g>
    </g>
  </svg>
);

export const ThickChevron = (
  <svg viewBox="0 0 10 6" fill="none">
    <path d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L5 3.58579L8.29289 0.292893C8.68342 -0.0976311 9.31658 -0.0976311 9.70711 0.292893C10.0976 0.683417 10.0976 1.31658 9.70711 1.70711L5.70711 5.70711C5.31658 6.09763 4.68342 6.09763 4.29289 5.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z" />
  </svg>
);

export const MarketCreator = (
  <svg viewBox="0 0 16 16">
    <circle cx="8" cy="8" r="7.5" fill="#252429" stroke="#3C3B43" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00002 4C7.11637 4 6.40002 4.71634 6.40002 5.6C6.40002 6.48366 7.11637 7.2 8.00002 7.2C8.88368 7.2 9.60002 6.48366 9.60002 5.6C9.60002 4.71634 8.88368 4 8.00002 4ZM5.40002 5.6C5.40002 4.16406 6.56408 3 8.00002 3C9.43596 3 10.6 4.16406 10.6 5.6C10.6 7.03594 9.43596 8.2 8.00002 8.2C6.56408 8.2 5.40002 7.03594 5.40002 5.6Z"
      fill="#D7DDE0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.17157 8.67157C5.92172 7.92143 6.93913 7.5 8 7.5C9.06087 7.5 10.0783 7.92143 10.8284 8.67157C11.0237 8.86683 11.0237 9.18342 10.8284 9.37868C10.6332 9.57394 10.3166 9.57394 10.1213 9.37868C9.55871 8.81607 8.79565 8.5 8 8.5C7.20435 8.5 6.44129 8.81607 5.87868 9.37868C5.31607 9.94129 5 10.7044 5 11.5C5 11.7761 4.77614 12 4.5 12C4.22386 12 4 11.7761 4 11.5C4 10.4391 4.42143 9.42172 5.17157 8.67157Z"
      fill="#D7DDE0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8284 8.67157C10.0783 7.92143 9.06087 7.5 8 7.5C6.93913 7.5 5.92172 7.92143 5.17157 8.67157C4.97631 8.86683 4.97618 9.18342 5.17145 9.37868C5.36671 9.57394 5.68341 9.57394 5.87868 9.37868C6.44129 8.81607 7.20435 8.5 8 8.5C8.79565 8.5 9.55871 8.81607 10.1213 9.37868C10.6839 9.94129 11 10.7044 11 11.5C11 11.7761 11.2238 12 11.5 12C11.7761 12 12 11.7761 12 11.5C12 10.4391 11.5786 9.42172 10.8284 8.67157Z"
      fill="#D7DDE0"
    />
  </svg>
);

export const DesignatedReporter = (
  <svg viewBox="0 0 16 16">
    <circle cx="8" cy="8" r="7.5" fill="#252429" stroke="#3C3B43" />
    <path
      d="M4.53279 9.14035L7.46455 11.1252L10.9352 5.9798"
      stroke="#D7DDE0"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PositionIcon = (
  <svg viewBox="0 0 16 16" fill="none">
    <circle cx="8.00049" cy="8" r="7.5" fill="#252429" stroke="#3C3B43" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.34895 3.7998H7.65341C9.66342 3.7998 11.187 4.88055 11.7538 6.45317H12.7832V7.40369H11.9706C11.9865 7.5539 11.9946 7.70692 11.9946 7.8624V7.88574C11.9946 8.06077 11.9844 8.23285 11.9643 8.40138H12.7832V9.35188H11.7342C11.1525 10.9026 9.64069 11.9731 7.65341 11.9731H4.34895V9.35188H3.20068V8.40138H4.34895V7.40369H3.20068V6.45317H4.34895V3.7998ZM5.27275 9.35188V11.1204H7.65341C9.1225 11.1204 10.214 10.4121 10.7221 9.35188H5.27275ZM11.0051 8.40138H5.27275V7.40369H11.0065C11.0278 7.5607 11.0386 7.72164 11.0386 7.88574V7.90908C11.0386 8.07697 11.0273 8.24133 11.0051 8.40138ZM7.65341 4.65108C9.12926 4.65108 10.224 5.37807 10.729 6.45317H5.27275V4.65108H7.65341Z"
      fill="white"
    />
    <defs>
      <rect
        width="16"
        height="16"
        fill="white"
        transform="translate(0.000488281)"
      />
      <rect
        width="9.6"
        height="8.18605"
        fill="white"
        transform="translate(3.20068 3.7998)"
      />
    </defs>
  </svg>
);

export const DisputeStake = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="7.5" fill="#252429" stroke="#3C3B43"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M5.77481 7.7475L5.15505 7.345C5.09916 7.30917 5.0819 7.23417 5.1156 7.17667L7.5075 3.12083C7.55188 3.04583 7.63161 3 7.71792 3H8.28178C8.36809 3 8.44782 3.04583 8.49221 3.12083L10.8841 7.17667C10.9178 7.23417 10.9005 7.30917 10.8447 7.345L10.2249 7.7475C10.1674 7.785 10.0893 7.76667 10.0539 7.70667L8.05246 4.31333C8.02862 4.27333 7.97108 4.27333 7.94725 4.31333L5.94578 7.70667C5.91043 7.76667 5.83317 7.785 5.77481 7.7475ZM11.5137 8.24499L12.4656 9.85916C12.533 9.97416 12.4984 10.1233 12.3883 10.1958L8.13301 12.9608C8.05246 13.0133 7.94889 13.0133 7.86834 12.9608L3.61306 10.1958C3.50127 10.1233 3.46675 9.97416 3.53497 9.85916L4.4868 8.24499C4.52214 8.18499 4.59941 8.16666 4.65777 8.20416L5.27752 8.60666C5.33342 8.64249 5.35068 8.71749 5.31698 8.77499L4.77284 9.69749C4.7564 9.72583 4.76462 9.76333 4.79257 9.78166L7.96697 11.8442C7.9867 11.8575 8.01218 11.8575 8.03273 11.8442L11.208 9.78166C11.2359 9.76333 11.2449 9.72666 11.2277 9.69749L10.6835 8.77499C10.6498 8.71749 10.6671 8.64249 10.723 8.60666L11.3428 8.20416C11.4003 8.16666 11.4784 8.18499 11.5137 8.24499Z" fill="#D7DDE0"/>
  </svg>
);

export const DoubleArrows = (
  <svg viewBox="0 0 10 6" fill="none">
    <path d="M9.60156 3L5.66662 6L5.66662 -1.72002e-07L9.60156 3Z" />
    <path d="M3.93555 3L0.000603652 6L0.000603914 -1.72002e-07L3.93555 3Z" />
  </svg>
);

export const LoadingEllipse = (
  <svg
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M1.20005 6C1.20005 8.65097 3.34908 10.8 6.00005 10.8C8.65102 10.8 10.8 8.65097 10.8 6C10.8 3.34903 8.65102 1.2 6.00005 1.2"
      strokeMiterlimit="1.5728"
    />
  </svg>
);

export const Compact = (
  <svg width="16" height="16" viewBox="0 0 16 16">
    <rect y="13.1001" width="16" height="2.9" />
    <rect y="8.7998" width="16" height="2.9" />
    <rect y="4.3999" width="16" height="2.9" />
    <path d="M0 0H16V2.9H0V0Z" />
  </svg>
);

export const Classic = (
  <svg width="16" height="16" viewBox="0 0 16 16">
    <rect y="12.2002" width="16" height="3.8" />
    <rect y="6" width="16" height="4.2" />
    <rect width="16" height="4" />
  </svg>
);

export const Expanded = (
  <svg width="16" height="16" viewBox="0 0 16 16">
    <rect y="9" width="16" height="7" />
    <rect width="16" height="7" />
  </svg>
);

export const MagnifyingGlass = (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10C17 11.887 16.2533 13.5997 15.0393 14.8586L14.8586 15.0393C13.5997 16.2533 11.887 17 10 17C6.13401 17 3 13.866 3 10ZM15.6177 17.0319C14.078 18.2635 12.125 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10C19 12.125 18.2635 14.078 17.0319 15.6177L23.4142 22L22 23.4142L15.6177 17.0319Z"
    />
  </svg>
);

export const Popcorn = (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
    <path
      d="M36.6907 11.2729C36.6907 9.82627 36.1161 8.43889 35.0931 7.41597C34.0702 6.39305 32.6828 5.81838 31.2362 5.81838C30.2969 5.82398 29.3753 6.07467 28.5626 6.54565C28.0744 5.7665 27.3963 5.12415 26.5918 4.67887C25.7874 4.2336 24.883 4 23.9635 4C23.0441 4 22.1397 4.2336 21.3352 4.67887C20.5308 5.12415 19.8527 5.7665 19.3645 6.54565C18.5517 6.07467 17.6302 5.82398 16.6908 5.81838C15.2442 5.81838 13.8568 6.39305 12.8339 7.41597C11.811 8.43889 11.2363 9.82627 11.2363 11.2729"
      stroke="#18D9C2"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.6002 43.9999L15.782 14.9092"
      stroke="#18D9C2"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.3271 43.9999L32.1453 14.9092"
      stroke="#18D9C2"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.9636 14.9092V43.9999"
      stroke="white"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.3272 14.9092H7.6001L11.2364 43.9999H36.6908L40.3272 14.9092Z"
      stroke="white"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Pencil = (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
    <path
      d="M6.33333 0.333252L7.66667 1.66659L3 6.33325L1 6.99992L1.66667 4.99992L6.33333 0.333252Z"
      stroke="#AFA7C1"
      strokeWidth="0.666667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Open = (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
    <path
      d="M8.75 8.75V9.25H9.25V8.75H8.75ZM1.25 8.75H0.75V9.25H1.25V8.75ZM1.25 1.25V0.75H0.75V1.25H1.25ZM8.75 1.25H9.25V0.75H8.75V1.25ZM8.25 5C8.25 5.27614 8.47386 5.5 8.75 5.5C9.02614 5.5 9.25 5.27614 9.25 5H8.25ZM5 0.75C4.72386 0.75 4.5 0.973858 4.5 1.25C4.5 1.52614 4.72386 1.75 5 1.75V0.75ZM9.25 7.1875C9.25 6.91136 9.02614 6.6875 8.75 6.6875C8.47386 6.6875 8.25 6.91136 8.25 7.1875H9.25ZM2.8125 1.75C3.08864 1.75 3.3125 1.52614 3.3125 1.25C3.3125 0.973858 3.08864 0.75 2.8125 0.75V1.75ZM8.75 8.25H1.25V9.25H8.75V8.25ZM1.75 8.75V1.25H0.75V8.75H1.75ZM8.25 1.25V5H9.25V1.25H8.25ZM5 1.75H8.75V0.75H5V1.75ZM8.25 7.1875V8.75H9.25V7.1875H8.25ZM1.25 1.75H2.8125V0.75H1.25V1.75Z"
      fill="#AFA7C1"
    />
    <path d="M8.75 1.25L4.0625 5.9375" stroke="#AFA7C1" strokeLinecap="round" />
  </svg>
);

export const MetaMaskLogin = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.144387 3.55334L1.0107 0.900024L6.4492 3.1674H11.5508L16.9862 0.901333L16.9879 0.900024L16.9881 0.900542L16.9893 0.900024L16.9882 0.900883L17.8542 3.55334L17.3778 6.38354L16.6588 9.11972L18 13.0088L16.9412 17.0129L12.8503 15.7104L12.2246 16.1928L10.4439 16.9646H9.04813H9H7.60428L5.82353 16.1928L5.14973 15.7104L1.05882 17.0129L0 13.0088L1.3404 9.12204L0.62083 6.38354L0.144387 3.55334ZM10.5221 15.3244L10.3542 13.9782L10.3476 13.9736L9.91444 13.7324H8.08556L7.69766 13.9484L7.52607 15.3244H9H9.04813H10.3476H10.5221ZM11.5306 9.85376L10.7033 11.6033L13.6364 10.8427L11.5306 9.85376ZM7.30707 11.6033L6.47978 9.85376L4.37395 10.8427L7.30707 11.6033ZM0.723745 3.77166L1.45746 1.52074C1.45746 1.52074 6.96034 5.69518 7.0011 5.7361C7.04187 5.77703 4.79995 7.57777 4.79995 7.57777L1.7428 8.51906L1.12727 6.17265L0.723745 3.77166ZM16.5081 1.52074L17.2418 3.77166L16.8383 6.17265L16.2228 8.51906L13.1656 7.57777C13.1656 7.57777 10.9237 5.77703 10.9645 5.7361C11.0052 5.69518 16.5081 1.52074 16.5081 1.52074Z"
      fill="#E9E5F2"
    />
  </svg>
);

export const EmailLogin = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M14.2218 17.3887C12.3586 18.1 6.67252 19.2647 3.58749 15.7164C0.601178 12.2781 1.89802 7.07502 4.1348 4.4743C6.15615 2.12502 10.3347 1.03686 13.9966 2.52327C17.6584 4.00967 18.2687 7.44767 18.1408 9.42908C18.0128 11.4105 17.4019 13.5485 15.4104 13.7041C13.4189 13.8596 13.0974 12.0008 12.9689 11.1025C12.8403 10.2042 13.3224 6.3643 13.3224 6.3643C8.95346 5.03145 7.41249 7.35458 6.92958 8.77939C6.44668 10.2042 6.28749 12.4337 8.08749 13.3939C9.88749 14.354 12.2635 13.1151 12.9703 11.1022"
      stroke="#E9E5F2"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
  </svg>
);

export const PhoneLogin = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M11.6401 10.8526L10.3565 12.4557C8.36873 11.2875 6.71201 9.63141 5.54317 7.64407L7.1477 6.36044C7.33573 6.20988 7.46862 6.00129 7.52561 5.76723C7.58259 5.53318 7.56047 5.28685 7.4627 5.06669L6.0002 1.77326C5.89532 1.53699 5.70995 1.34565 5.47711 1.23335C5.24428 1.12106 4.97913 1.09511 4.72895 1.16013L1.94457 1.88238C1.68482 1.95028 1.459 2.11108 1.30987 2.33433C1.16074 2.55758 1.09867 2.82778 1.13542 3.09373C1.62403 6.57316 3.23212 9.79893 5.71659 12.2834C8.20105 14.7679 11.4268 16.376 14.9063 16.8646C15.1722 16.9013 15.4424 16.8392 15.6657 16.6901C15.8889 16.541 16.0497 16.3152 16.1176 16.0554L16.8399 13.271C16.9047 13.0209 16.8787 12.7558 16.7665 12.5231C16.6543 12.2903 16.4631 12.1048 16.227 11.9998L12.9339 10.5373C12.7137 10.4394 12.4673 10.4172 12.2332 10.4743C11.9991 10.5313 11.7905 10.6644 11.6401 10.8526V10.8526Z"
      stroke="#E9E5F2"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const GoogleLogin = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.991 10.71V7.362H17.415C17.541 7.929 17.64 8.46 17.64 9.207C17.64 14.346 14.193 18 9 18C4.032 18 0 13.968 0 9C0 4.032 4.032 0 9 0C11.43 0 13.464 0.891 15.021 2.349L12.465 4.833C11.817 4.221 10.683 3.501 9 3.501C6.021 3.501 3.591 5.976 3.591 9.009C3.591 12.042 6.021 14.517 9 14.517C12.447 14.517 13.716 12.132 13.95 10.719H8.991V10.71Z"
      fill="#E9E5F2"
    />
  </svg>
);

export const FacebookButton = (
  <svg viewBox="0 0 20 20" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8338 14.7038V10.3514H12.0353L12.1945 8.85153H10.8338L10.8359 8.10084C10.8359 7.70965 10.873 7.50004 11.4349 7.50004H12.186V6H10.9844C9.54101 6 9.03299 6.7276 9.03299 7.95119V8.8517H8.1333V10.3516H9.03299V14.7038H10.8338Z"
    />
  </svg>
);

export const TwitterButton = (
  <svg viewBox="0 0 20 20" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.7604 8.50255L9.77719 8.77937L9.4974 8.74547C8.47895 8.61554 7.58922 8.17489 6.83378 7.43482L6.46445 7.06761L6.36933 7.33878C6.16788 7.94326 6.29658 8.58164 6.71627 9.01099C6.9401 9.24826 6.88974 9.28216 6.50363 9.14093C6.36933 9.09573 6.25181 9.06183 6.24062 9.07878C6.20145 9.11833 6.33575 9.63242 6.44207 9.83579C6.58756 10.1183 6.88414 10.3951 7.2087 10.5589L7.4829 10.6888L7.15834 10.6945C6.84497 10.6945 6.83378 10.7001 6.86735 10.8188C6.97927 11.186 7.42134 11.5758 7.91378 11.7453L8.26072 11.8639L7.95854 12.0447C7.51088 12.3046 6.98487 12.4514 6.45886 12.4627C6.20705 12.4684 6 12.491 6 12.5079C6 12.5644 6.68269 12.8808 7.08 13.0051C8.27191 13.3723 9.68765 13.2141 10.7509 12.587C11.5063 12.1407 12.2617 11.2538 12.6143 10.3951C12.8045 9.93748 12.9948 9.10138 12.9948 8.70028C12.9948 8.44041 13.0116 8.40651 13.3249 8.0958C13.5096 7.91502 13.6831 7.71729 13.7167 7.6608C13.7726 7.55346 13.767 7.55346 13.4816 7.6495C13.006 7.81898 12.9388 7.79638 13.1739 7.54216C13.3473 7.36138 13.5544 7.03372 13.5544 6.93768C13.5544 6.92073 13.4704 6.94898 13.3753 6.99982C13.2746 7.05632 13.0508 7.14106 12.8829 7.1919L12.5807 7.28794L12.3065 7.10151C12.1554 6.99982 11.9428 6.88684 11.8309 6.85294C11.5455 6.77385 11.109 6.78515 10.8516 6.87554C10.1521 7.12976 9.71004 7.78508 9.7604 8.50255Z"
    />
  </svg>
);

export const Sports = (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
    <path
      d="M33.3333 7.5C30.1666 10.8333 28.3333 15.1667 28.3333 20C28.3333 24.8333 30.1666 29.3333 33.3333 32.5"
      stroke="#D7DDE0"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M6.66666 7.5C9.83332 10.8333 11.6667 15.1667 11.6667 20C11.6667 24.8333 9.83332 29.3333 6.66666 32.5"
      stroke="#D7DDE0"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M20 1.66666V38.3333"
      stroke="#D7DDE0"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M38.3333 20H1.66666"
      stroke="#D7DDE0"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M20 38.3333C30.1252 38.3333 38.3333 30.1252 38.3333 20C38.3333 9.87477 30.1252 1.66666 20 1.66666C9.87477 1.66666 1.66666 9.87477 1.66666 20C1.66666 30.1252 9.87477 38.3333 20 38.3333Z"
      stroke="#D7DDE0"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const Politics = (
  <svg viewBox="0 0 48 48" fill="none">
    <path d="M4 24V46" strokeWidth="2" strokeMiterlimit="10" />
    <path d="M44 24V46" strokeWidth="2" strokeMiterlimit="10" />
    <path d="M34 24V46" strokeWidth="2" strokeMiterlimit="10" />
    <path d="M24 24V46" strokeWidth="2" strokeMiterlimit="10" />
    <path d="M14 24V46" strokeWidth="2" strokeMiterlimit="10" />
    <path
      d="M2 46H46"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M2 24H46"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M40 24C40 15.2 32.8 8 24 8C15.2 8 8 15.2 8 24"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M24 2V8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const Economics = (
  <svg viewBox="0 0 48 48" fill="none">
    <path
      d="M46.5 1.5H1.5V46.5H46.5V1.5Z"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M9 30L19.5 18L30 25.5L39 18"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const Olympics = (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
    <path
      d="M25.02 37.75L25 34.4167L34.3684 33.0833C35.0073 32.9918 35.5916 32.6725 36.0139 32.1844C36.4362 31.6963 36.668 31.0721 36.6667 30.4267V27.75H3.33338V30.4267C3.33207 31.0721 3.56388 31.6963 3.98617 32.1844C4.40845 32.6725 4.9928 32.9918 5.63171 33.0833L15 34.4167V37.75"
      stroke="#D7DDE0"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M19.26 3.3335C18.9841 4.93977 18.323 6.45525 17.3334 7.75016C16.185 9.25016 13.3334 10.7352 13.3334 14.4168C13.334 15.5979 13.6483 16.7576 14.2443 17.7772C14.8402 18.7969 15.6963 19.64 16.725 20.2202C16.7622 19.695 16.9137 19.1843 17.1687 18.7237C17.4238 18.2631 17.7763 17.8637 18.2017 17.5535C19.0212 17.0154 19.6504 16.2328 20 15.3168C20.8854 15.8283 21.6412 16.5365 22.2091 17.3867C22.777 18.237 23.1417 19.2064 23.275 20.2202C24.3038 19.64 25.1599 18.7969 25.7558 17.7772C26.3517 16.7576 26.6661 15.5979 26.6667 14.4168C26.6667 12.5518 26.3334 7.47516 19.26 3.3335Z"
      stroke="#D7DDE0"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const Crypto = (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
    <path
      d="M6.25 20H7.5C10.335 20 13.5325 21.5587 15 23.75H20C22.5087 23.75 25 26.2413 25 28.75H13.75"
      stroke="#D7DDE0"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M24.2013 26.25H32.5C37.0312 26.25 37.5 28.75 37.5 28.75L19.6 36.02C18.1763 36.59 16.5763 36.5238 15.2038 35.8375L6.25 31.29"
      stroke="#D7DDE0"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M30 20C32.7614 20 35 17.7614 35 15C35 12.2386 32.7614 10 30 10C27.2386 10 25 12.2386 25 15C25 17.7614 27.2386 20 30 20Z"
      stroke="#D7DDE0"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M6.25 17.5H1.25V33.75H6.25V17.5Z"
      stroke="#D7DDE0"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M15 12.5C17.7614 12.5 20 10.2614 20 7.5C20 4.73858 17.7614 2.5 15 2.5C12.2386 2.5 10 4.73858 10 7.5C10 10.2614 12.2386 12.5 15 12.5Z"
      stroke="#D7DDE0"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const Entertainment = (
  <svg viewBox="0 0 48 48" fill="none">
    <path
      d="M42 15H6L10.5 45H37.5L42 15Z"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M39 9.00003C39.0062 7.85473 38.6828 6.73183 38.0683 5.76533C37.4538 4.79883 36.5741 4.02955 35.5344 3.54929C34.4946 3.06902 33.3386 2.89806 32.2044 3.0568C31.0701 3.21554 30.0055 3.69728 29.1375 4.44453C28.6126 3.54806 27.8622 2.80455 26.9609 2.28789C26.0597 1.77123 25.0389 1.49939 24 1.49939C22.9612 1.49939 21.9404 1.77123 21.0391 2.28789C20.1379 2.80455 19.3875 3.54806 18.8625 4.44453C17.9946 3.69728 16.9299 3.21554 15.7957 3.0568C14.6614 2.89806 13.5054 3.06902 12.4657 3.54929C11.4259 4.02955 10.5463 4.79883 9.93179 5.76533C9.31728 6.73183 8.99382 7.85473 9.00003 9.00003"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path d="M18 45L16.5 15" strokeWidth="1.5" strokeMiterlimit="10" />
    <path d="M30 45L31.5 15" strokeWidth="1.5" strokeMiterlimit="10" />
  </svg>
);

export const Medical = (
  <svg viewBox="0 0 40 40" fill="none">
    <g clipPath="url(#clip0)">
      <path
        d="M8.33813 30V34.7362"
        stroke="#D7DDE0"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.01978 32.3682H10.6567"
        stroke="#D7DDE0"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.70142 19.3333H12.9752"
        stroke="#D7DDE0"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.01981 22.5208V27.257L1.38293 31.9932V37.9135H15.2936V31.9932L10.6567 27.257V22.5208"
        stroke="#D7DDE0"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5875 12.4657L14.6859 3.97591"
        stroke="#D7DDE0"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M30.2283 22.4934L27.8026 23.8939"
        stroke="#D7DDE0"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M28.1276 18.855L24.8616 20.7406"
        stroke="#D7DDE0"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M26.027 15.2163L23.6013 16.6168"
        stroke="#D7DDE0"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M27.5715 30.4958L31.0726 36.56"
        stroke="#D7DDE0"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M34.711 34.4592L31.2099 28.395"
        stroke="#D7DDE0"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M37.8805 24.5437L20.9008 34.3469"
        stroke="#D7DDE0"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M36.5304 33.4089L29.2534 37.6103"
        stroke="#D7DDE0"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M20.2416 9.9436L16.6331 12.0269"
        stroke="#D7DDE0"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M25.7522 31.5462L16.449 15.4325C16.1729 14.9543 16.3368 14.3427 16.815 14.0665L22.36 10.8651C22.8383 10.589 23.4499 10.7529 23.726 11.2312L33.0292 27.3448"
        stroke="#D7DDE0"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <path d="M0 0H40V40H0V0Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const World = (
  <svg viewBox="0 0 48 48" fill="none">
    <path
      d="M11.408 5.95801C12.796 6.98401 13.922 8.28601 14.942 9.99801C15.834 11.492 17.816 15.652 16 18C13.946 20.656 8 21.552 8 24C8 25.842 10.608 27.944 12 30C14.094 33.092 13.142 36.088 12 38C11.408 38.992 10.462 39.84 9.414 40.468"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M41.336 10.4539C37.018 12.5239 31.084 13.9219 30 13.9999C27.91 14.1499 27.6 12.4319 26 9.99987C24.8 8.17587 22 5.89387 22 3.99987C22 3.25787 22.072 2.65587 22.262 2.06787"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M24 46C36.1503 46 46 36.1503 46 24C46 11.8497 36.1503 2 24 2C11.8497 2 2 11.8497 2 24C2 36.1503 11.8497 46 24 46Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M38.028 25.8062C38.112 31.9742 30.084 39.6662 26 38.0002C22.42 36.5402 24.946 33.7242 24.028 25.8062C23.646 22.5142 27.162 19.8062 31.028 19.8062C34.894 19.8062 37.984 22.4942 38.028 25.8062Z"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
  </svg>
);

export const USPolitics = (
  <svg viewBox="0 0 48 48" fill="none">
    <path
      d="M8 14C5.79 14 4 12.21 4 10C4 7.79 5.79 6 8 6C10.21 6 12 7.79 12 10C12 12.21 10.21 14 8 14Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M12 42H6V34H2V24C2 21.79 3.79 20 6 20H8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M40 14C42.21 14 44 12.21 44 10C44 7.79 42.21 6 40 6C37.79 6 36 7.79 36 10C36 12.21 37.79 14 40 14Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M36 42H42V34H46V24C46 21.79 44.21 20 42 20H40"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M24 14C20.686 14 18 11.314 18 8C18 4.686 20.686 2 24 2C27.314 2 30 4.686 30 8C30 11.314 27.314 14 24 14Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M30 46H18V34H14V24C14 21.79 15.79 20 18 20H30C32.21 20 34 21.79 34 24V36H30V46Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const USElections = (
  <svg viewBox="0 0 48 48" fill="none">
    <path
      d="M18 16L22 20L30 12"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M44 14V40C44 41.0609 43.5786 42.0783 42.8284 42.8284C42.0783 43.5786 41.0609 44 40 44H8C6.93913 44 5.92172 43.5786 5.17157 42.8284C4.42143 42.0783 4 41.0609 4 40V14"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M10 26V4H38V26"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path d="M4 32H44" strokeWidth="2" strokeMiterlimit="10" />
  </svg>
);

export const REP = (
  <svg viewBox="0 0 48 48" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.3823 26.1203L30.4458 26.4987L30.467 26.6483C30.7353 28.7313 31.5434 29.3401 33.5476 30.2278C33.5518 30.2295 33.5561 30.2287 33.5603 30.2304L40.8309 33.4417L24.4155 42.8142V37.4498C24.4155 35.4815 24.5337 35.1285 26.2801 34.163C26.6233 33.9738 26.9702 33.7758 27.3503 33.5602L27.5875 33.424C28.6746 32.8435 29.5605 31.9846 30.2142 30.9665C30.2379 30.9291 30.4125 30.6656 30.4357 30.628C30.3222 30.5733 30.2021 30.4786 30.0606 30.3551C29.9672 30.2738 29.8283 30.1158 29.7602 29.9859C29.1881 31.0991 28.3194 32.0408 27.2077 32.6535L26.9385 32.8076C26.5636 33.0208 26.1813 33.2296 25.8393 33.4175C23.6977 34.6016 23.5273 35.3272 23.5273 37.4498V42.82L6.96013 33.277L14.0496 30.1766L14.5108 29.9779C14.6912 29.8899 15.2581 29.6583 15.6959 29.6449C16.1427 29.6175 16.8205 29.6462 17.1854 30.1117C17.7036 30.7683 18.1994 31.3957 18.1994 31.3957C18.981 32.4094 20.003 33.2387 21.2241 33.7364C21.2241 33.7364 21.2306 33.7405 21.2348 33.7422C21.5567 33.8739 21.9039 33.9498 22.2477 34.03C22.3184 33.8942 22.4299 33.7362 22.5318 33.608C22.6056 33.5155 22.7161 33.4015 22.8191 33.2947C22.3002 33.1927 21.7029 33.0279 21.2375 32.8046L21.2357 32.8035C20.3084 32.3621 19.5063 31.744 18.89 30.949C18.8808 30.9382 18.8593 30.9125 18.8511 30.9004C18.8511 30.9004 18.8267 30.8666 18.8075 30.8392C18.7453 30.756 18.6825 30.6757 18.6246 30.5897C18.4603 30.3683 18.2113 30.0386 17.8623 29.598C17.6276 29.2997 17.2998 29.1034 16.9509 28.9771V28.9771C16.5744 28.842 16.1401 28.783 15.6655 28.7862C14.9461 28.8098 14.1469 29.1937 14.131 29.2013L13.882 29.3088L13.8627 29.3165L13.2171 29.5948C13.2129 29.5963 13.2095 29.6026 13.2095 29.6026L7.01379 32.3126L23.5123 5.97515V17.1232C23.5123 19.0497 23.3715 19.4704 21.6097 20.4444C21.4747 20.519 21.3314 20.5873 21.1838 20.6569C21.1092 20.693 21.0329 20.7319 20.9565 20.7693C20.8986 20.795 20.8443 20.8255 20.7879 20.853L20.7855 20.8538C18.4739 21.9638 16.8597 24.2154 16.7186 26.8431C16.8706 26.8844 17.1002 26.9496 17.2285 26.9886C17.3224 27.0167 17.4642 27.0871 17.584 27.1516C17.6068 24.7233 19.0724 22.6286 21.1896 21.6174V21.6174C21.1955 21.6151 21.2015 21.6148 21.2064 21.6125C21.3338 21.5467 21.457 21.4879 21.5786 21.43C21.7423 21.3517 21.8999 21.2758 22.0514 21.192C22.3675 21.0177 22.6293 20.8538 22.8676 20.693C22.932 20.6508 22.9865 20.6056 23.0453 20.5635C23.1743 20.4699 23.2959 20.3741 23.4015 20.2798C23.4629 20.2267 23.519 20.1763 23.5593 20.1272C24.2646 19.4112 24.4027 18.6052 24.4027 17.1232V5.96996L40.9525 32.5517L33.6482 29.3256H33.6441C32.0241 28.6085 31.5318 28.0092 31.3145 26.2861C31.3114 26.2626 31.3047 26.204 31.2989 26.1819C30.8815 23.4263 28.8237 21.2153 26.1207 20.4422C25.9361 20.3895 25.7908 20.3462 25.7559 20.3367C25.7002 20.5135 25.6204 20.664 25.5755 20.741C25.4812 20.9018 25.385 21.0138 25.2871 21.1217C25.3285 21.131 25.5862 21.1868 25.6271 21.1967C28.0574 21.7919 29.937 23.7035 30.3823 26.1203ZM42.3218 33.0848L24.3424 4.20776C24.2628 4.07891 24.1184 4 23.9626 4C23.8065 4 23.6623 4.07891 23.5828 4.20711L5.56383 32.9691C5.5028 33.0664 5.48425 33.1847 5.51375 33.2954C5.54125 33.4061 5.61413 33.5018 5.71652 33.5604L23.7354 43.9397C23.805 43.9799 23.8848 44 23.9626 44C24.0406 44 24.1184 43.9799 24.1881 43.9403L42.1675 33.6761C42.2699 33.6173 42.3419 33.5226 42.3723 33.4119C42.4016 33.3003 42.3839 33.183 42.3218 33.0848Z"
      fill="white"
    />
  </svg>
);

export const AMPL = (
  <svg viewBox="0 0 128 128">
    <svg
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M8.1039 24.7273H0V23.6883C0.329004 23.619 1.17403 23.4182 1.92208 23.1688C2.67013 22.9195 3.48052 21.368 3.79221 20.6234L11.6883 0.25974L12.7792 0C15.2208 6.75325 20.1974 20.5091 20.5714 21.5065C21.039 22.7532 22.026 23.2208 22.2857 23.3766C22.4935 23.5013 23.5152 23.6364 24 23.6883V24.7273H14.8571V23.6883C15.0303 23.6883 15.6156 23.626 16.5714 23.3766C17.5273 23.1273 17.3853 22.026 17.1948 21.5065L11.2727 4.83117C9.80272 9.1333 6.33766 18.8571 6.33766 18.8571C6.33766 18.8571 5.35065 21.4026 5.35065 22.4416C5.35065 23.3792 7.1342 23.6537 8.1039 23.7922V24.7273Z"
        fill="#D7DDE0"
      />
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </svg>
);


export const LTC = (
  <svg viewBox="0 0 48 48" fill="none">
    <path d="M21.1971 36.0086L21.0302 36.637H21.6803H41.5839L39.7414 43.5H7.84785L11.043 31.4946L11.2899 30.567L10.3883 30.8964L6.52949 32.3059L7.79037 27.5577L12.309 25.9069L12.5536 25.8176L12.6206 25.5659L18.2269 4.5H29.5648L25.3691 20.2984L25.1229 21.2256L26.0239 20.8964L31.277 18.9773L30.0132 23.7265L24.1068 25.8844L23.862 25.9738L23.7951 26.2257L21.1971 36.0086Z" />
  </svg>
);

export const MKR = (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM6.0936 9.952V15.6H5V9.04C5.00055 8.92165 5.03391 8.80578 5.09636 8.70525C5.15882 8.60472 5.24792 8.52348 5.35378 8.47055C5.45963 8.41762 5.57809 8.39509 5.69598 8.40544C5.81388 8.41579 5.92659 8.45863 6.0216 8.5292L11.216 12.44C11.2947 12.4993 11.3586 12.576 11.4027 12.6642C11.4468 12.7523 11.4698 12.8495 11.47 12.948V15.6H10.3768V13.1756L6.0936 9.952ZM17.9392 9.952V15.6H19.0328V9.04C19.032 8.92179 18.9984 8.80612 18.9358 8.70582C18.8732 8.60553 18.7841 8.52452 18.6783 8.47179C18.5725 8.41905 18.4542 8.39665 18.3364 8.40707C18.2187 8.41748 18.1061 8.46031 18.0112 8.5308L12.8168 12.44C12.7381 12.4993 12.6742 12.576 12.6301 12.6642C12.586 12.7523 12.563 12.8495 12.5628 12.948V15.6H13.656V13.1756L17.9392 9.952Z"
    />
  </svg>
);

export const LINK = (
  <svg viewBox="0 0 24 24" fill="none">
    <path d="M12.4037 0L10.2018 1.26606L4.20183 4.73395L2 6V18L4.20183 19.2661L10.2569 22.7339L12.4587 24L14.6606 22.7339L20.6055 19.2661L22.8073 18V6L20.6055 4.73395L14.6055 1.26606L12.4037 0ZM6.40367 15.4679V8.53211L12.4037 5.06422L18.4037 8.53211V15.4679L12.4037 18.9358L6.40367 15.4679Z" />
  </svg>
);

export const COMP = (
  <svg viewBox="0 0 24 24" fill="none">
    <path d="M3.97062 18.6802C3.37746 18.3207 3 17.6556 3 16.9726V13.0721C3 12.9284 3.03595 12.7846 3.10785 12.6587C3.34152 12.2633 3.86278 12.1195 4.25821 12.3532L13.0657 17.4939C13.587 17.7994 13.8925 18.3387 13.8925 18.9498V22.9941C13.8925 23.1738 13.8386 23.3536 13.7487 23.5153C13.4612 23.9827 12.832 24.1444 12.3647 23.8568L3.97062 18.6802ZM17.11 11.2747C17.6312 11.5803 17.9368 12.1195 17.9368 12.7306V20.945C17.9368 21.1966 17.811 21.4123 17.5953 21.5381L15.672 22.6166C15.654 22.6346 15.6181 22.6346 15.6001 22.6525V18.105C15.6001 17.5118 15.2945 16.9726 14.7913 16.667L7.06223 12.0476V6.85297C7.06223 6.70918 7.09818 6.56538 7.17008 6.43956C7.40375 6.04412 7.92501 5.90033 8.32045 6.13399L17.11 11.2747ZM20.9565 5.19932C21.4778 5.50489 21.7833 6.04412 21.7833 6.65525V18.6442C21.7833 18.8959 21.6395 19.1116 21.4238 19.2374L19.5905 20.226V11.8858C19.5905 11.2927 19.2849 10.7534 18.7816 10.4479L10.8728 5.70261V0.831521C10.8728 0.687726 10.9088 0.543932 10.9807 0.41811C11.2143 0.0226718 11.7356 -0.121126 12.131 0.112542L20.9565 5.19932Z" />
  </svg>
);

export const BAL = (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.1999 4.40585C19.1999 5.73457 15.9764 6.8117 11.9999 6.8117C8.02348 6.8117 4.79993 5.73457 4.79993 4.40585C4.79993 3.07714 8.02348 2 11.9999 2C15.9764 2 19.1999 3.07714 19.1999 4.40585ZM15.0371 7.21613C18.8506 7.64075 21.6 8.84313 21.6 10.2601C21.6 12.0317 17.302 13.4679 12 13.4679C6.69809 13.4679 2.40002 12.0317 2.40002 10.2601C2.40002 8.84313 5.14948 7.64075 8.96297 7.21613C9.89703 7.36887 10.9232 7.45326 12 7.45326C13.0392 7.45326 14.0312 7.37467 14.9387 7.23196L15.0371 7.21613ZM16.8518 13.8091C21.0623 14.4318 24 15.8401 24 17.4776C24 19.6921 18.6274 21.4874 12 21.4874C5.37258 21.4874 0 19.6921 0 17.4776C0 15.8401 2.93773 14.4318 7.14824 13.8091C8.59444 14.1032 10.2461 14.2698 12 14.2698C13.7099 14.2698 15.3226 14.1115 16.7426 13.8312L16.8518 13.8091Z"
    />
  </svg>
);

export const ZRX = (
  <svg viewBox="0 0 24 24" fill="none">
    <path d="M18.52 16.1517C19.3862 17.3156 20.2794 18.5066 21.1727 19.6977C19.3862 21.809 17.1665 23.1624 14.4867 23.7309C11.5092 24.3534 8.69404 23.8933 5.96011 22.3774C8.39629 20.5639 10.7783 18.7773 13.1874 16.9908C13.7288 17.5051 14.2431 18.0194 14.7574 18.5066C15.3259 19.048 15.1093 19.0751 15.8402 18.6691C16.8417 18.1006 17.6808 17.3156 18.3305 16.3682C18.3576 16.3141 18.4117 16.26 18.4388 16.2058C18.4117 16.2058 18.4388 16.2058 18.52 16.1517ZM7.88198 18.5337C7.20527 19.048 6.58269 19.5082 5.96011 19.9954C5.49994 20.3473 5.03977 20.6721 4.5796 21.024C4.39012 21.1864 4.25478 21.1864 4.03823 20.9969C1.98101 19.1563 0.681714 16.8825 0.194477 14.1757C-0.292759 11.4418 0.14034 8.84318 1.43964 6.37994C1.46671 6.3258 1.52084 6.2446 1.54791 6.19046C1.54791 6.16339 1.57498 6.16339 1.62912 6.13632C3.41565 8.49129 5.22925 10.8462 7.01579 13.2012C6.96165 13.2824 6.93458 13.3366 6.88044 13.3907C6.33907 13.9591 5.7977 14.5276 5.22925 15.0689C5.06684 15.2313 5.03977 15.3667 5.14805 15.5562C5.71649 16.6389 6.50148 17.5322 7.47595 18.263C7.6113 18.3442 7.71957 18.4254 7.88198 18.5337ZM17.9786 1.72415C17.1124 2.34673 16.2462 2.96931 15.38 3.56481C13.8912 4.62049 12.4025 5.70323 10.9407 6.7589C10.7513 6.89424 10.6159 6.92131 10.4535 6.73183C9.96627 6.21753 9.45197 5.75737 8.96473 5.24306C8.82939 5.10772 8.69404 5.08065 8.50456 5.16186C7.34061 5.75737 6.42027 6.59649 5.66235 7.65216C5.60821 7.7063 5.55408 7.78751 5.49994 7.86871C5.06684 7.30027 4.66081 6.78597 4.25478 6.2446C3.82168 5.67616 3.41565 5.10772 3.00962 4.56635C2.87428 4.37687 2.84721 4.24153 3.03669 4.05205C5.12098 1.75122 7.6925 0.397797 10.7783 0.0729741C13.2145 -0.197711 15.5424 0.289522 17.7079 1.45347C17.7891 1.50761 17.8703 1.53467 17.9515 1.58881C17.9515 1.67002 17.9515 1.69709 17.9786 1.72415ZM22.3908 17.9653C21.8224 17.2344 21.308 16.5577 20.7937 15.881C19.6027 14.311 18.4117 12.714 17.1936 11.144C17.0312 10.9275 17.0312 10.7921 17.2207 10.6026C17.735 10.0883 18.2222 9.57403 18.7365 9.05973C18.8719 8.92438 18.926 8.78904 18.8177 8.59956C18.2222 7.46268 17.4102 6.51528 16.3545 5.75736C16.2733 5.70323 16.1921 5.62202 16.0838 5.56789C16.165 5.48668 16.2462 5.43254 16.3003 5.37841C17.329 4.59342 18.3576 3.8355 19.3862 3.05051C19.5486 2.91517 19.6839 2.86103 19.8734 3.05051C22.4449 5.37841 23.8254 8.27474 23.9608 11.7666C24.0149 13.7967 23.5547 15.7186 22.6344 17.5322C22.5532 17.6404 22.472 17.7758 22.3908 17.9653Z" />
  </svg>
);

export const ETH = (
  <svg viewBox="0 0 48 48" fill="none">
    <path d="M12.0546 24L24 17.5679L35.9454 24L24 30.4321L12.0546 24Z" />
    <path d="M23.7629 33.4402L24 33.5679L24.2371 33.4402L35.4256 27.4157L24 44.1145L12.5744 27.4157L23.7629 33.4402Z" />
    <path d="M24 30.4321L11.7047 23.8116L24 3.94993L36.2953 23.8116L24 30.4321Z" />
    <path d="M24 6V29M24 34V43" />
  </svg>
);

export const TOKENS = (
  <svg viewBox="0 0 24 24" fill="none">
    <path d="M8.18182 1C5.9994 1 4.02094 1.43555 2.53977 2.17614C1.0586 2.91672 0 4.01449 0 5.36364C0 5.44796 0.000406364 5.52846 0.00852273 5.6108L0 18.4545C0 19.8036 1.059 20.9014 2.53977 21.642C4.02055 22.3827 6 22.8182 8.18182 22.8182C10.251 22.8182 12.132 22.4249 13.5852 21.7528C14.4466 22.0903 15.384 22.2727 16.3636 22.2727C20.5746 22.2727 24 18.8474 24 14.6364C24 10.4254 20.5746 7 16.3636 7V5.90909V5.36364C16.3636 4.01449 15.305 2.91672 13.8239 2.17614C12.3427 1.43555 10.3642 1 8.18182 1ZM8.18182 2.09091C10.2168 2.09091 12.0554 2.5064 13.3381 3.14773C14.6207 3.78905 15.2727 4.60406 15.2727 5.36364C15.2727 6.12321 14.6207 6.93822 13.3381 7.57955C12.0554 8.22087 10.2168 8.63636 8.18182 8.63636C6.14679 8.63636 4.30822 8.22087 3.02557 7.57955C1.82309 6.9783 1.17576 6.22628 1.09943 5.50852V5.36364H1.09091C1.09091 4.60406 1.74292 3.78905 3.02557 3.14773C4.30822 2.5064 6.14679 2.09091 8.18182 2.09091ZM1.09943 7.58807C1.49937 7.95416 1.99218 8.27734 2.53977 8.55114C4.02094 9.29172 5.9994 9.72727 8.18182 9.72727C9.06123 9.72727 9.90217 9.65455 10.696 9.52273C10.0806 10.204 9.58681 10.997 9.24716 11.8665C8.89939 11.8931 8.54492 11.9091 8.18182 11.9091C6.14679 11.9091 4.30822 11.4851 3.02557 10.8438C1.78549 10.2237 1.14125 9.45023 1.09943 8.71307V7.58807ZM16.3636 8.09091C19.9851 8.09091 22.9091 11.015 22.9091 14.6364C22.9091 18.2578 19.9851 21.1818 16.3636 21.1818C12.7422 21.1818 9.81818 18.2578 9.81818 14.6364C9.81818 11.015 12.7422 8.09091 16.3636 8.09091ZM1.09091 10.8608C1.49239 11.2301 1.98833 11.5481 2.53977 11.8239C4.02095 12.5645 5.9994 13 8.18182 13C8.42666 13 8.66738 12.9944 8.90625 12.983C8.78803 13.516 8.72727 14.0682 8.72727 14.6364C8.72727 14.8146 8.73224 14.9895 8.74432 15.1648C8.5581 15.1725 8.37308 15.1818 8.18182 15.1818C6.14679 15.1818 4.30822 14.7578 3.02557 14.1165C1.74292 13.4752 1.09091 12.6687 1.09091 11.9091V10.8608ZM1.09091 14.1335C1.49239 14.5028 1.98833 14.8209 2.53977 15.0966C4.02095 15.8372 5.9994 16.2727 8.18182 16.2727C8.4237 16.2727 8.66166 16.2671 8.89773 16.2557C9.06079 17.0072 9.34049 17.7177 9.70739 18.3693C9.21486 18.4233 8.70732 18.4545 8.18182 18.4545C6.14679 18.4545 4.30822 18.0305 3.02557 17.3892C1.74292 16.7479 1.09091 15.9414 1.09091 15.1818V14.1335ZM1.09091 17.4062C1.49239 17.7755 1.98833 18.0936 2.53977 18.3693C4.02095 19.1099 5.9994 19.5455 8.18182 19.5455C8.949 19.5455 9.68576 19.4858 10.3892 19.3835C10.9222 20.0533 11.5644 20.6284 12.2898 21.0881C11.133 21.4813 9.71492 21.7273 8.18182 21.7273C6.14744 21.7273 4.3078 21.3032 3.02557 20.6619C1.74334 20.0206 1.09091 19.2142 1.09091 18.4545V17.4062Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.646 12.2986L19.7297 11.7465L21 11.0984V11.876L19.7187 12.529L19.0988 12.8447L13.5821 15.6555L13.2748 15.812L12.963 15.9712L12 16.462V15.6841L12.3271 15.5173C12.4488 15.4553 12.5495 15.3586 12.6164 15.2395C12.6834 15.1204 12.7136 14.9842 12.7033 14.8479C12.6959 14.7517 12.6922 14.6551 12.6922 14.5581C12.6922 13.856 12.8862 13.1676 13.253 12.5688C13.6197 11.9701 14.1448 11.4845 14.7703 11.1655C15.3958 10.8466 16.0973 10.7068 16.7973 10.7616C17.4973 10.8164 18.1685 11.0637 18.7367 11.4762L18.6441 11.5234L18.0239 11.8394C17.5497 11.5746 17.0146 11.4382 16.4715 11.4439C15.9284 11.4495 15.3962 11.5969 14.9277 11.8715C14.4591 12.1461 14.0704 12.5383 13.8 13.0094C13.5297 13.4804 13.3871 14.0139 13.3864 14.557C13.3865 14.6931 13.3954 14.8291 13.4131 14.9641L18.646 12.2986ZM13.8955 16.2717L21 12.6543V13.4296L20.6725 13.5963C20.5509 13.6585 20.4503 13.7551 20.3835 13.8742C20.3166 13.9933 20.2864 14.1295 20.2967 14.2657C20.3039 14.3625 20.3078 14.4603 20.3078 14.5582C20.3075 15.2602 20.1132 15.9485 19.7463 16.547C19.3794 17.1455 18.8542 17.6309 18.2287 17.9497C17.6032 18.2684 16.9018 18.408 16.2019 18.353C15.5021 18.2981 14.831 18.0507 14.2629 17.6383L14.9354 17.2956L14.9735 17.2754C15.4477 17.5413 15.9833 17.6786 16.527 17.6735C17.0707 17.6685 17.6037 17.5213 18.0729 17.2466C18.5422 16.972 18.9314 16.5793 19.202 16.1077C19.4726 15.6361 19.6152 15.1019 19.6155 14.5582C19.6155 14.4212 19.6066 14.2843 19.5888 14.1485L14.3505 16.8177L13.2668 17.3698L12 18.0152V17.2381L13.2756 16.5881L13.8955 16.2717Z"
      fill="#D7DDE0"
    />
    <g clipPath="url(#clip0)">
      <path
        d="M8 3C7.0111 3 6.0444 3.1173 5.22215 3.33706C4.39991 3.55682 3.75904 3.86918 3.3806 4.23463C3.00217 4.60009 2.90315 5.00222 3.09608 5.39018C3.289 5.77814 3.76521 6.13451 4.46447 6.41421C5.16373 6.69392 6.05465 6.8844 7.02455 6.96157C7.99446 7.03874 8.99979 6.99913 9.91342 6.84776C10.8271 6.69638 11.6079 6.44004 12.1573 6.11114C12.7068 5.78224 13 5.39556 13 5C13.0019 4.73812 12.8749 4.47865 12.6261 4.23641C12.3773 3.99417 12.0117 3.77391 11.5501 3.58819C11.0885 3.40247 10.5399 3.25494 9.93581 3.15402C9.33168 3.0531 8.68376 3.00076 8.02906 3H8ZM8.08475 5.0678L7.56417 5.76998H10.3487C10.3671 5.76972 10.3855 5.77091 10.4028 5.7735C10.4201 5.77609 10.4359 5.78001 10.4494 5.78505C10.4629 5.79009 10.4738 5.79614 10.4814 5.80286C10.4891 5.80958 10.4933 5.81683 10.4939 5.82421V5.84261L10.2518 6.17676C10.2411 6.19256 10.2174 6.20644 10.1844 6.21612C10.1514 6.2258 10.1111 6.2307 10.0702 6.23002H5.80872L6.523 5.25666L5.72397 5.35351L5.90557 5.13075L6.7046 5.0339L7.70945 3.66828C7.72051 3.65257 7.74439 3.63879 7.7773 3.62913C7.81021 3.61948 7.85025 3.61451 7.89104 3.61501H8.96853C8.98697 3.61475 9.00536 3.61595 9.02265 3.61854C9.03994 3.62112 9.05578 3.62505 9.06927 3.63009C9.08276 3.63512 9.09364 3.64117 9.10128 3.64789C9.10892 3.65461 9.11318 3.66187 9.1138 3.66925V3.68765L8.26635 4.84019L9.06538 4.74334L8.89589 4.97579L8.08475 5.0678Z"
        fill="#D7DDE0"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="10" height="4" fill="white" transform="translate(3 3)" />
      </clipPath>
    </defs>
  </svg>
);

export const BTC = (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.09503 23.6407C15.5244 25.2438 22.0356 21.3315 23.6382 14.9029L23.6381 14.903C25.241 8.47405 21.3289 1.96177 14.8999 0.359081C8.47253 -1.24361 1.96137 2.66903 0.359382 9.09837C-1.24401 15.5265 2.66833 22.0381 9.09503 23.6407ZM14.6659 7.24544C16.3284 7.81808 17.5442 8.6765 17.3053 10.2734L17.3054 10.2733L17.3058 10.2736C17.133 11.4426 16.4849 12.0085 15.6245 12.2069C16.8058 12.822 17.407 13.7652 16.8343 15.4003C16.1237 17.4313 14.4353 17.6027 12.1899 17.1777L11.645 19.3616L10.3281 19.0335L10.866 16.8789C10.5246 16.7941 10.1759 16.7041 9.81656 16.6066L9.27693 18.7714L7.96166 18.4432L8.50656 16.2552C8.38001 16.2229 8.25265 16.1897 8.12437 16.1562C7.94082 16.1084 7.75538 16.0601 7.56773 16.013L5.85413 15.5858L6.50789 14.0785C6.50789 14.0785 7.47816 14.3365 7.46497 14.3173C7.83778 14.4097 8.00318 14.1665 8.06835 14.0045L8.92946 10.5523C8.96415 10.5606 8.99793 10.569 9.03043 10.5772C9.04338 10.5804 9.05613 10.5836 9.06865 10.5867C9.0161 10.5656 8.96847 10.5521 8.93175 10.5428L9.5461 8.07839C9.56211 7.79861 9.46568 7.44562 8.93245 7.31254C8.95304 7.29875 7.97608 7.07481 7.97608 7.07481L8.32637 5.66838L10.1423 6.12184L10.1407 6.12865C10.4137 6.19657 10.6951 6.26103 10.9816 6.32625L11.5212 4.16376L12.8372 4.49188L12.3083 6.61202C12.6617 6.69267 13.0172 6.77403 13.3634 6.86037L13.8884 4.75413L15.2052 5.08224L14.6659 7.24544ZM10.5007 15.0885C11.5751 15.3722 13.9234 15.9925 14.2967 14.4922H14.2968C14.6793 12.9585 12.4023 12.4475 11.2909 12.198C11.1666 12.1702 11.0569 12.1455 10.9671 12.1231L10.244 15.0218C10.3177 15.0401 10.404 15.0629 10.5007 15.0885ZM11.5138 10.8527C12.4096 11.0918 14.3637 11.6133 14.704 10.2497H14.7041C15.0516 8.8552 13.1526 8.43476 12.2251 8.22941C12.1207 8.20631 12.0287 8.18593 11.9535 8.1672L11.2979 10.7962C11.3598 10.8116 11.4325 10.831 11.5138 10.8527Z"
    />
  </svg>
);

export const TV = (
  <svg viewBox="0 0 48 48" fill="none">
    <path d="M18 6L24 14" strokeWidth="2" strokeMiterlimit="10" />
    <path d="M24 14L34 2" strokeWidth="2" strokeMiterlimit="10" />
    <path
      d="M46 14H2V46H46V14Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M30 22H10V38H30V22Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M38 32V38"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M38 22V24"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const Music = (
  <svg viewBox="0 0 48 48" fill="none">
    <path
      d="M16 14H46"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path d="M46 35V2H16V39" strokeWidth="2" strokeMiterlimit="10" />
    <path
      d="M9 46C12.866 46 16 42.866 16 39C16 35.134 12.866 32 9 32C5.13401 32 2 35.134 2 39C2 42.866 5.13401 46 9 46Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M39 42C42.866 42 46 38.866 46 35C46 31.134 42.866 28 39 28C35.134 28 32 31.134 32 35C32 38.866 35.134 42 39 42Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const Movies = (
  <svg viewBox="0 0 48 48" fill="none">
    <path
      d="M46 42L32 36V28L46 22V42Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M32 20H2V44H32V20Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M24 14C26.2091 14 28 12.2091 28 10C28 7.79086 26.2091 6 24 6C21.7909 6 20 7.79086 20 10C20 12.2091 21.7909 14 24 14Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const Awards = (
  <svg viewBox="0 0 48 48" fill="none">
    <path
      d="M12 18H10C8.4087 18 6.88258 17.3679 5.75736 16.2426C4.63214 15.1174 4 13.5913 4 12V2H12"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M36 18H38C39.5913 18 41.1174 17.3679 42.2426 16.2426C43.3679 15.1174 44 13.5913 44 12V2H36"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path d="M24 38V30" strokeWidth="2" strokeMiterlimit="10" />
    <path
      d="M24 30C20.8174 30 17.7652 28.7357 15.5147 26.4853C13.2643 24.2348 12 21.1826 12 18V2H36V18C36 21.1826 34.7357 24.2348 32.4853 26.4853C30.2348 28.7357 27.1826 30 24 30Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M36 46H12C12 43.8783 12.8429 41.8434 14.3431 40.3431C15.8434 38.8429 17.8783 38 20 38H28C30.1217 38 32.1566 38.8429 33.6569 40.3431C35.1571 41.8434 36 43.8783 36 46Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const Indexes = (
  <svg viewBox="0 0 48 48" fill="none">
    <path
      d="M32 32V44"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path d="M32 4V16" strokeWidth="2" strokeMiterlimit="10" />
    <path d="M35.99 20.28L46 26" strokeWidth="2" strokeMiterlimit="10" />
    <path
      d="M2 30L12 22L20 28L28.176 21.186"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M46 4H2V44H46V4Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M32 24C34.2091 24 36 22.2091 36 20C36 17.7909 34.2091 16 32 16C29.7909 16 28 17.7909 28 20C28 22.2091 29.7909 24 32 24Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const Statistics = (
  <svg width="40" height="39" viewBox="0 0 40 39" fill="none">
    <path
      d="M36.25 7V25H37.75V7H36.25ZM36 25.25H4V26.75H36V25.25ZM3.75 25V7H2.25V25H3.75ZM4 25.25C3.86193 25.25 3.75 25.1381 3.75 25H2.25C2.25 25.9665 3.0335 26.75 4 26.75V25.25ZM36.25 25C36.25 25.1381 36.1381 25.25 36 25.25V26.75C36.9665 26.75 37.75 25.9665 37.75 25H36.25Z"
      fill="#D7DDE0"
    />
    <path
      d="M20.5 7L1.66663 7"
      stroke="#D7DDE0"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M38.6665 7.75C39.0807 7.75 39.4165 7.41421 39.4165 7C39.4165 6.58579 39.0807 6.25 38.6665 6.25V7.75ZM30.6665 6.25C30.2523 6.25 29.9165 6.58579 29.9165 7C29.9165 7.41421 30.2523 7.75 30.6665 7.75V6.25ZM38.6665 6.25H30.6665V7.75H38.6665V6.25Z"
      fill="#D7DDE0"
    />
    <rect
      x="19"
      y="26"
      width="1"
      height="10"
      rx="0.5"
      fill="#D7DDE0"
      stroke="#D7DDE0"
      strokeWidth="0.5"
    />
    <rect
      x="9.6781"
      y="26.0469"
      width="1.05556"
      height="13.0265"
      rx="0.527778"
      transform="rotate(20.0029 9.6781 26.0469)"
      fill="#D7DDE0"
      stroke="#D7DDE0"
      strokeWidth="0.5"
    />
    <rect
      x="19.2957"
      y="30.5366"
      width="1.05556"
      height="12.3843"
      rx="0.527777"
      transform="rotate(75 19.2957 30.5366)"
      fill="#D7DDE0"
    />
    <rect
      width="1.05555"
      height="12.3843"
      rx="0.527777"
      transform="matrix(-0.258819 0.965926 0.965926 0.258819 19.5547 30.5366)"
      fill="#D7DDE0"
    />
    <rect
      width="1.05556"
      height="12.8954"
      rx="0.527778"
      transform="matrix(-0.939675 0.342067 0.342068 0.939675 29.2615 26.1699)"
      fill="#D7DDE0"
      stroke="#D7DDE0"
      strokeWidth="0.5"
    />
    <path
      d="M7.64403 18.6489C7.45011 18.8455 7.45228 19.1621 7.64888 19.356C7.84548 19.5499 8.16206 19.5477 8.35597 19.3511L7.64403 18.6489ZM15.6364 11.2581L15.9763 10.8914L15.6208 10.5618L15.2804 10.9069L15.6364 11.2581ZM18.4545 13.871L18.1146 14.2376L18.4584 14.5564L18.7986 14.2338L18.4545 13.871ZM8.35597 19.3511L15.9923 11.6092L15.2804 10.9069L7.64403 18.6489L8.35597 19.3511ZM15.2964 11.6247L18.1146 14.2376L18.7945 13.5043L15.9763 10.8914L15.2964 11.6247ZM18.7986 14.2338L31.8441 1.86281L31.156 1.13719L18.1105 13.5082L18.7986 14.2338Z"
      fill="#D7DDE0"
    />
    <path d="M28 1H32V4.5" stroke="#D7DDE0" strokeLinecap="round" />
    <path
      d="M3 22.8333C3 22.3731 3.3731 22 3.83333 22H5.16667C5.6269 22 6 22.3731 6 22.8333C6 23.2936 5.6269 23.6667 5.16667 23.6667H3.83333C3.3731 23.6667 3 23.2936 3 22.8333Z"
      fill="#D7DDE0"
    />
    <path
      d="M3 16.8333C3 16.3731 3.3731 16 3.83333 16H5.16667C5.6269 16 6 16.3731 6 16.8333C6 17.2936 5.6269 17.6667 5.16667 17.6667H3.83333C3.3731 17.6667 3 17.2936 3 16.8333Z"
      fill="#D7DDE0"
    />
    <path
      d="M3 10.8333C3 10.3731 3.3731 10 3.83333 10H5.16667C5.6269 10 6 10.3731 6 10.8333C6 11.2936 5.6269 11.6667 5.16667 11.6667H3.83333C3.3731 11.6667 3 11.2936 3 10.8333Z"
      fill="#D7DDE0"
    />
    <rect x="8" y="22" width="4" height="4" fill="#D7DDE0" />
    <rect x="15" y="19" width="4" height="7" fill="#D7DDE0" />
    <rect x="22" y="22" width="4" height="4" fill="#D7DDE0" />
    <rect x="29" y="11" width="4" height="15" fill="#D7DDE0" />
  </svg>
);

export const Stocks = (
  <svg viewBox="0 0 48 48" fill="none">
    <path
      d="M28 28H20V46H28V28Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M10 36H2V46H10V36Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M46 20H38V46H46V20Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path d="M6 20L16 10L24 18L40 2" strokeWidth="2" strokeMiterlimit="10" />
    <path
      d="M30 2H40V12"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const HorseRacing = (
  <svg viewBox="0 0 48 48" fill="none">
    <path
      d="M12 44C16 36 26 34 26 26V16C26 18.1218 25.1571 20.1566 23.6569 21.6569C22.1566 23.1572 20.1217 24 18 24L9 30L5 26L16 10V4.00004C20.726 3.99196 25.3769 5.18228 29.5179 7.45975C33.659 9.73722 37.1549 13.0275 39.6791 17.0229C42.2032 21.0184 43.6731 25.5886 43.9513 30.3065C44.2295 35.0243 43.307 39.7356 41.27 44"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const Hockey = (
  <svg viewBox="0 0 48 48" fill="none">
    <path
      d="M40.9475 33.3777L26.6706 36.7078L9.36823 5.94742C8.31361 4.07251 5.93868 3.40766 4.0639 4.4625L4.0639 4.46251C2.18655 5.51879 1.52318 7.8984 2.58331 9.77357L21.359 42.9841C21.7138 43.6117 22.379 43.9998 23.1 43.9998H44C45.1045 43.9998 46 43.1043 46 41.9998V37.2367C46 34.5992 43.4921 32.6837 40.9475 33.3777Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M28 17V20.625C28 22.2819 31.134 23.625 35 23.625C38.866 23.625 42 22.2819 42 20.625V17"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M35 20C38.866 20 42 18.6569 42 17C42 15.3431 38.866 14 35 14C31.134 14 28 15.3431 28 17C28 18.6569 31.134 20 35 20Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const Tennis = (
  <svg viewBox="0 0 48 48" fill="none">
    <path
      d="M8.59998 39.6978C10.6918 37.6538 12.3533 35.2119 13.4868 32.5159C14.6203 29.8199 15.2028 26.9243 15.2 23.9998C15.2028 21.0752 14.6203 18.1796 13.4868 15.4836C12.3533 12.7876 10.6918 10.3457 8.59998 8.30176"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M39.4 39.6979C37.3098 37.6522 35.6491 35.2097 34.5154 32.5137C33.3816 29.8178 32.7976 26.9225 32.7976 23.9979C32.7976 21.0732 33.3816 18.178 34.5154 15.482C35.6491 12.786 37.3098 10.3435 39.4 8.29785"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M24 46C36.1503 46 46 36.1503 46 24C46 11.8497 36.1503 2 24 2C11.8497 2 2 11.8497 2 24C2 36.1503 11.8497 46 24 46Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const Basketball = (
  <svg viewBox="0 0 48 48" fill="none">
    <path
      d="M40 9C36.2 13 34 18.2 34 24C34 29.8 36.2 35.2 40 39"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M8 9C11.8 13 14 18.2 14 24C14 29.8 11.8 35.2 8 39"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path d="M24 2V46" strokeWidth="2" strokeMiterlimit="10" />
    <path d="M46 24H2" strokeWidth="2" strokeMiterlimit="10" />
    <path
      d="M24 46C36.1503 46 46 36.1503 46 24C46 11.8497 36.1503 2 24 2C11.8497 2 2 11.8497 2 24C2 36.1503 11.8497 46 24 46Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const Golf = (
  <svg viewBox="0 0 48 48" fill="none">
    <path
      d="M40 16.0002H26V12.3538C26 10.9011 26.7876 9.56264 28.0574 8.85716L38.0574 3.30161C40.7236 1.82042 44 3.7483 44 6.79823V12.0002C44 14.2093 42.2091 16.0002 40 16.0002Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M26 16V28"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M6 20.0003H18V15.3191C18 14.5191 17.5232 13.796 16.7878 13.4808L6.78784 9.19511C5.4681 8.62951 4 9.59757 4 11.0334V18.0003C4 19.1049 4.89543 20.0003 6 20.0003Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M18 20V28"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M36 28H8V36H36V28Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M32 36V46"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M12 46V36"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const Baseball = (
  <svg viewBox="0 0 48 48" fill="none">
    <path
      d="M20 24H12"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M17.564 13.012L10.314 16.392"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M10.314 31.6079L17.564 34.9879"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M9 40.062C11.2088 38.0101 12.9705 35.5247 14.1749 32.7609C15.3794 29.9972 16.0007 27.0148 16 24C16.0007 20.9852 15.3794 18.0027 14.1749 15.239C12.9705 12.4753 11.2088 9.98983 9 7.93799"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M36 24H28"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M37.686 16.392L30.436 13.012"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M30.436 34.9879L37.686 31.6079"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M39 40.062C36.7918 38.0097 35.0305 35.5241 33.8261 32.7605C32.6217 29.9969 32.0001 27.0146 32.0001 24C32.0001 20.9853 32.6217 18.0031 33.8261 15.2395C35.0305 12.4759 36.7918 9.99029 39 7.93799"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M24 46C36.1503 46 46 36.1503 46 24C46 11.8497 36.1503 2 24 2C11.8497 2 2 11.8497 2 24C2 36.1503 11.8497 46 24 46Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const AmericanFootball = (
  <svg viewBox="0 0 48 48" fill="none">
    <path
      d="M5.04395 26.948L21.0579 42.942"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M27.0179 5.04395L42.9539 20.9539"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M6.18197 41.8C2.12397 37.746 3.35197 22.7 13.044 13.022C22.644 3.42204 37.798 2.11604 41.858 6.17004C45.918 10.224 44.516 25.44 34.996 34.948C25.4 44.53 10.356 45.958 6.18197 41.8Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M17 23L25 31"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M23 17L31 25"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M18 30L30 18"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const Soccer = (
  <svg viewBox="0 0 48 48" fill="none">
    <path
      d="M15.93 3.5481L24 9.6001L32.07 3.5481"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M2.05603 25.354L10.304 19.554L7.04203 10"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M18.506 45.2879L15.536 35.6499L5.45001 35.7999"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M42.55 35.7999L32.464 35.6479L29.494 45.2859"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M40.958 10L37.696 19.55L45.944 25.35"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M28 30L30.966 22.33L24 16.656L17.034 22.33L20 30H28Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M24 46C36.1503 46 46 36.1503 46 24C46 11.8497 36.1503 2 24 2C11.8497 2 2 11.8497 2 24C2 36.1503 11.8497 46 24 46Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const OpenArrow = (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.2457 8.68638C16.6234 8.28351 17.2563 8.26318 17.6591 8.64096C18.062 9.01874 18.0823 9.65157 17.7046 10.0544L12.7828 15.3031C12.7069 15.384 12.6207 15.4495 12.5281 15.4995C12.1381 15.7108 11.6402 15.6425 11.3226 15.3038L6.40084 10.0551C6.02306 9.65227 6.0434 9.01944 6.44627 8.64166C6.84913 8.26388 7.48197 8.28421 7.85975 8.68708L12.0524 13.1581L16.2457 8.68638Z"
    />
  </svg>
);

export const CategoryCrypto = (
  <svg width="13" height="12" viewBox="0 0 13 12" fill="none">
    <path
      d="M2.875 6H3.25C4.1005 6 5.05975 6.46762 5.5 7.125H7C7.75262 7.125 8.5 7.87238 8.5 8.625H5.125"
      stroke="white"
      strokeMiterlimit="10"
    />
    <path
      d="M8.26038 7.875H10.75C12.1094 7.875 12.25 8.625 12.25 8.625L6.88 10.806C6.45288 10.977 5.97288 10.9571 5.56113 10.7513L2.875 9.387"
      stroke="white"
      strokeMiterlimit="10"
    />
    <path
      d="M10 6C10.8284 6 11.5 5.32843 11.5 4.5C11.5 3.67157 10.8284 3 10 3C9.17157 3 8.5 3.67157 8.5 4.5C8.5 5.32843 9.17157 6 10 6Z"
      stroke="#2AE7A8"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M2.875 5.25H1.375V10.125H2.875V5.25Z"
      stroke="white"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M5.5 3.75C6.32843 3.75 7 3.07843 7 2.25C7 1.42157 6.32843 0.75 5.5 0.75C4.67157 0.75 4 1.42157 4 2.25C4 3.07843 4.67157 3.75 5.5 3.75Z"
      stroke="#2AE7A8"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const CategoryEconomics = (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path
      d="M10.25 6L9 6L7.5 3.5L5 8.5L3.5 6L1.75 6"
      stroke="#2AE7A8"
      strokeMiterlimit="10"
    />
    <path
      d="M6 11.5C2.96243 11.5 0.500001 9.03757 0.5 6C0.5 2.96243 2.96243 0.500001 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 9.03757 9.03757 11.5 6 11.5Z"
      stroke="white"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const CategoryEntertainment = (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path
      d="M1.5 3.5L10.5 3.5L9.5 11.5L2.5 11.5L1.5 3.5Z"
      stroke="white"
      strokeMiterlimit="10"
    />
    <path
      d="M2.5 2.50006C2.5 2.10223 2.65804 1.7207 2.93934 1.4394C3.22064 1.15809 3.60218 1.00006 4 1.00006C4.25831 1.0016 4.51175 1.07054 4.73525 1.20006C4.8695 0.98579 5.05599 0.809142 5.27721 0.686691C5.49844 0.56424 5.74715 0.5 6 0.5C6.25285 0.5 6.50156 0.56424 6.72279 0.686691C6.94401 0.809142 7.1305 0.98579 7.26475 1.20006C7.48825 1.07054 7.74169 1.0016 8 1.00006C8.39782 1.00006 8.77936 1.15809 9.06066 1.4394C9.34196 1.7207 9.5 2.10223 9.5 2.50006"
      stroke="#2AE7A8"
      strokeMiterlimit="10"
    />
    <path d="M7.75 11.5L8.25 3.5" stroke="white" strokeMiterlimit="10" />
    <path d="M4.25 11.5L3.75 3.5" stroke="white" strokeMiterlimit="10" />
    <path d="M6 3.5L6 11.5" stroke="white" strokeMiterlimit="10" />
  </svg>
);

export const CategoryPolitics = (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path
      d="M9.25 6.75C9.25 4.95 7.8 3.5 6 3.5C4.2 3.5 2.75 4.95 2.75 6.75"
      stroke="#2AE7A8"
      strokeMiterlimit="10"
    />
    <path
      d="M6 3.5L6 1.75"
      stroke="white"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M11.5 10.25L0.5 10.25"
      stroke="white"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M2.5 10.25L2.5 4.25L0.5 4.25L0.500001 10.25"
      stroke="white"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M9.5 10.25L9.5 4.25L11.5 4.25L11.5 10.25"
      stroke="white"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M9.5 6.75L2.5 6.75"
      stroke="white"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const CategoryMedical = (
  <svg viewBox="0 0 16 16" fill="none">
    <path
      d="M3.5 0.5H12.5"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.5 2.5V5.5C4.43913 5.5 3.42172 5.92143 2.67157 6.67157C1.92143 7.42172 1.5 8.43913 1.5 9.5V14.5C1.5 14.7652 1.60536 15.0196 1.79289 15.2071C1.98043 15.3946 2.23478 15.5 2.5 15.5H13.5C13.7652 15.5 14.0196 15.3946 14.2071 15.2071C14.3946 15.0196 14.5 14.7652 14.5 14.5V9.5C14.5 8.43913 14.0786 7.42172 13.3284 6.67157C12.5783 5.92143 11.5609 5.5 10.5 5.5V2.5"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 7.5V12.5"
      stroke="#2AE7A8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.5 10H10.5"
      stroke="#2AE7A8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MMA = (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
    <g clipPath="url(#clip0)">
      <path
        d="M37.868 12.4991L37.8694 20.6758L27.317 25.7786L12.8982 25.7786L2.23475 20.5071L2.23475 12.4985L12.8982 6.8849L27.317 6.95488L37.868 12.4991Z"
        stroke="#D7DDE0"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.868 20.424C38.868 20.0525 38.662 19.7117 38.3332 19.5389L27.7821 13.9947C27.6401 13.9201 27.4822 13.8807 27.3218 13.8799L12.9031 13.81C12.7391 13.8092 12.5775 13.8487 12.4324 13.9251L1.76892 19.5387C1.44041 19.7116 1.23475 20.0523 1.23475 20.4236L1.23475 28.4322C1.23475 28.8126 1.45058 29.16 1.79159 29.3286L12.4551 34.6001C12.5929 34.6682 12.7445 34.7036 12.8982 34.7036L27.317 34.7036C27.4678 34.7036 27.6166 34.6695 27.7523 34.6039L38.3047 29.5012C38.6501 29.3342 38.8694 28.9843 38.8694 28.6007L38.868 20.424Z"
        stroke="#D7DDE0"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <line x1="13" y1="6.88306" x2="13" y2="13.0781" stroke="#D7DDE0" />
      <line x1="13" y1="25.7788" x2="13" y2="34.2743" stroke="#D7DDE0" />
      <line
        x1="27.6211"
        y1="6.88306"
        x2="27.6211"
        y2="14.0326"
        stroke="#D7DDE0"
      />
      <line
        x1="27.3008"
        y1="25.8208"
        x2="27.3008"
        y2="35.2708"
        stroke="#D7DDE0"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <path d="M0 0H40V40H0V0Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CategorySports = (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path
      d="M10 9.77539C9.075 8.80039 8.5 7.47539 8.5 6.00039C8.5 4.52539 9.075 3.22539 10 2.22539"
      stroke="white"
      strokeMiterlimit="10"
    />
    <path
      d="M2 9.77539C2.925 8.80039 3.5 7.47539 3.5 6.00039C3.5 4.52539 2.925 3.22539 2 2.22539"
      stroke="white"
      strokeMiterlimit="10"
    />
    <path d="M6 11.5V0.5" stroke="white" strokeMiterlimit="10" />
    <path d="M11.5 6H0.5" stroke="#2AE7A8" strokeMiterlimit="10" />
    <path
      d="M6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6C0.5 2.96243 2.96243 0.5 6 0.5Z"
      stroke="white"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const Boxing = (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
    <g clipPath="url(#clip0)">
      <path
        d="M30.125 32.875V36.8333H11.125V32.875"
        stroke="#D7DDE0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.0833 9.125V21.7917C34.0833 23.6813 33.3327 25.4936 31.9965 26.8298C30.6603 28.166 28.848 28.9167 26.9583 28.9167H11.125C9.23533 28.9167 7.42306 28.166 6.08686 26.8298C4.75067 25.4936 4 23.6813 4 21.7917V16.25C4 15.2002 4.41704 14.1934 5.15937 13.451C5.9017 12.7087 6.90852 12.2917 7.95833 12.2917H11.9167C13.1764 12.2917 14.3846 12.7921 15.2754 13.6829C16.1662 14.5737 16.6667 15.7819 16.6667 17.0417C16.6667 18.3014 16.1662 19.5096 15.2754 20.4004C14.3846 21.2912 13.1764 21.7917 11.9167 21.7917H11.125"
        stroke="#D7DDE0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5999 16.25H26.958C27.8937 16.25 28.8202 16.0657 29.6846 15.7076C30.5491 15.3496 31.3345 14.8248 31.9962 14.1631C32.6578 13.5015 33.1826 12.7161 33.5407 11.8516C33.8987 10.9872 34.083 10.0607 34.083 9.125V9.125C34.083 7.23533 33.3324 5.42306 31.9962 4.08686C30.66 2.75067 28.8477 2 26.958 2H12.708C10.8184 2 9.00609 2.75067 7.66989 4.08686C6.3337 5.42306 5.58303 7.23533 5.58303 9.125V9.125C5.57996 10.3336 5.88542 11.523 6.47049 12.5806"
        stroke="#D7DDE0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <path d="M0 0H40V40H0V0Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CarRacing = (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
    <g clipPath="url(#clip0)">
      <path
        d="M2.49759 9.52287L25.8742 3.25913L25.6004 2.23735C25.4492 1.67308 25.7812 1.09376 26.343 0.943235C26.9048 0.792705 27.482 1.1284 27.6332 1.69268L37.3133 37.8196C37.4645 38.3839 37.1325 38.9632 36.5708 39.1137C36.009 39.2643 35.4318 38.9286 35.2806 38.3643L30.8023 21.6511L7.42571 27.9149C6.86393 28.0654 6.28675 27.7297 6.13555 27.1654L1.755 10.817C1.6038 10.2527 1.9358 9.6734 2.49759 9.52287ZM5.70424 17.4248L11.8025 15.7907L10.1598 9.66007L4.06153 11.2941L5.70424 17.4248ZM14.3828 17.2896L16.0255 23.4203L22.1238 21.7863L20.481 15.6556L14.3828 17.2896ZM20.3235 6.9367L21.9662 13.0674L28.0645 11.4333L26.4218 5.30268L20.3235 6.9367Z"
        fill="#D7DDE0"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <path d="M0 0H40V40H0V0Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const RedFlagIcon = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="7.5" fill="#252429" stroke="#3C3B43" />
    <g clipPath="url(#clip0)">
      <path
        d="M5.125 4.625H11.875L10.75 6.875L11.875 9.125H5.125"
        fill="#FF2727"
      />
      <path
        d="M5.125 4.625H11.875L10.75 6.875L11.875 9.125H5.125"
        stroke="#FF2727"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M5.125 3.875V12.125"
        stroke="#FF2727"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect x="4" y="3.5" width="9" height="9" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const YellowTemplateIcon = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="7.5" fill="#252429" stroke="#3C3B43" />
    <g clipPath="url(#clip0)">
      <path
        d="M8.03031 4.00808L11.4053 4.57058C11.5366 4.59254 11.6558 4.66031 11.7418 4.76185C11.8277 4.8634 11.875 4.99214 11.875 5.12521V9.06271C11.875 10.107 11.4602 11.1085 10.7217 11.8469C9.98331 12.5854 8.98179 13.0002 7.9375 13.0002C6.89321 13.0002 5.89169 12.5854 5.15327 11.8469C4.41484 11.1085 4 10.107 4 9.06271V5.12521C4.00004 4.99214 4.04725 4.8634 4.13324 4.76185C4.21924 4.66031 4.33845 4.59254 4.46969 4.57058L7.84469 4.00808C7.90615 3.99796 7.96885 3.99796 8.03031 4.00808Z"
        fill="#F9FFD7"
      />
      <path
        d="M7.44596 10.1875C7.38081 10.1875 7.31832 10.1599 7.27225 10.1107L6.04376 8.79988C6.02029 8.7757 6.00157 8.74677 5.9887 8.71478C5.97582 8.6828 5.96904 8.6484 5.96876 8.61359C5.96848 8.57878 5.97469 8.54426 5.98705 8.51204C5.9994 8.47982 6.01764 8.45055 6.04071 8.42593C6.06378 8.40132 6.09122 8.38185 6.12141 8.36867C6.15161 8.35549 6.18396 8.34886 6.21658 8.34916C6.24921 8.34946 6.28145 8.35669 6.31142 8.37043C6.3414 8.38417 6.36851 8.40414 6.39118 8.42918L7.41157 9.51768L9.45529 6.36807C9.47329 6.33887 9.49658 6.31381 9.5238 6.29436C9.55101 6.27491 9.58159 6.26146 9.61374 6.2548C9.64589 6.24814 9.67897 6.24841 9.71102 6.25559C9.74308 6.26277 9.77346 6.27671 9.80039 6.2966C9.82732 6.3165 9.85025 6.34193 9.86784 6.37141C9.88542 6.4009 9.8973 6.43384 9.90279 6.46829C9.90827 6.50274 9.90724 6.53802 9.89975 6.57204C9.89227 6.60607 9.87849 6.63815 9.85922 6.66641L7.64793 10.0745C7.62756 10.1063 7.60089 10.1329 7.56981 10.1524C7.53872 10.1719 7.50399 10.1839 7.46808 10.1875C7.46071 10.1875 7.45334 10.1875 7.44596 10.1875Z"
        fill="#252429"
        stroke="#252429"
        strokeWidth="0.3"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect x="4" y="4" width="7.875" height="9" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const TemplateIcon = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="7.5" fill="#252429" stroke="#3C3B43" />
    <g clipPath="url(#clip0)">
      <path
        d="M8.03031 4.00759L11.4053 4.57009C11.5366 4.59205 11.6558 4.65982 11.7418 4.76137C11.8277 4.86291 11.875 4.99165 11.875 5.12472V9.06222C11.875 10.1065 11.4602 11.108 10.7217 11.8465C9.98331 12.5849 8.98179 12.9997 7.9375 12.9997C6.89321 12.9997 5.89169 12.5849 5.15327 11.8465C4.41484 11.108 4 10.1065 4 9.06222V5.12472C4.00004 4.99165 4.04725 4.86291 4.13324 4.76137C4.21924 4.65982 4.33845 4.59205 4.46969 4.57009L7.84469 4.00759C7.90615 3.99747 7.96885 3.99747 8.03031 4.00759Z"
        fill="#AEFFF0"
      />
      <path
        d="M7.44596 10.1875C7.38081 10.1875 7.31832 10.1599 7.27225 10.1107L6.04376 8.79988C6.02029 8.7757 6.00157 8.74677 5.9887 8.71478C5.97582 8.6828 5.96904 8.6484 5.96876 8.61359C5.96848 8.57878 5.97469 8.54426 5.98705 8.51204C5.9994 8.47982 6.01764 8.45055 6.04071 8.42593C6.06378 8.40132 6.09122 8.38185 6.12141 8.36867C6.15161 8.35549 6.18396 8.34886 6.21658 8.34916C6.24921 8.34946 6.28145 8.35669 6.31142 8.37043C6.3414 8.38417 6.36851 8.40414 6.39118 8.42918L7.41157 9.51768L9.45529 6.36807C9.47329 6.33887 9.49658 6.31381 9.5238 6.29436C9.55101 6.27491 9.58159 6.26146 9.61374 6.2548C9.64589 6.24814 9.67897 6.24841 9.71102 6.25559C9.74308 6.26277 9.77346 6.27671 9.80039 6.2966C9.82732 6.3165 9.85025 6.34193 9.86784 6.37141C9.88542 6.4009 9.8973 6.43384 9.90279 6.46829C9.90827 6.50274 9.90724 6.53802 9.89975 6.57204C9.89227 6.60607 9.87849 6.63815 9.85922 6.66641L7.64793 10.0745C7.62756 10.1063 7.60089 10.1329 7.56981 10.1524C7.53872 10.1719 7.50399 10.1839 7.46808 10.1875C7.46071 10.1875 7.45334 10.1875 7.44596 10.1875Z"
        fill="#1B1A1E"
        stroke="#1B1A1E"
        strokeWidth="0.3"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="7.875"
          height="9"
          fill="white"
          transform="translate(4 4)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const OnboardingCheckIcon = (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
    <path
      d="M32 1.33325C15.0667 1.33325 1.33333 15.0666 1.33333 31.9999C1.33333 48.9333 15.0667 62.6666 32 62.6666C48.9333 62.6666 62.6667 48.9333 62.6667 31.9999C62.6667 15.0666 48.9333 1.33325 32 1.33325ZM48.9333 22.2666L27.6 43.5999C27.3333 43.8666 27.0667 43.9999 26.6667 43.9999C26.2667 43.9999 26 43.8666 25.7333 43.5999L15.0667 32.9333C14.5333 32.3999 14.5333 31.5999 15.0667 31.0666C15.6 30.5333 16.4 30.5333 16.9333 31.0666L26.6667 40.7999L47.0667 20.3999C47.6 19.8666 48.4 19.8666 48.9333 20.3999C49.4667 20.9333 49.4667 21.7333 48.9333 22.2666Z"
      fill="#E0DFDF"
    />
  </svg>
);

export const OnboardingDollarDaiIcon = (
  <svg viewBox="0 0 180 64" fill="none">
    <path
      d="M95.2031 32.2578H84.7266V29.4922H95.2031V32.2578ZM95.2031 37.332H84.7266V34.5664H95.2031V37.332Z"
      fill="#D7DDE0"
    />
    <circle cx="32" cy="32" r="32" fill="#D7DDE0" />
    <path
      d="M27.4766 35.5117C27.4766 34.8711 27.2969 34.3633 26.9375 33.9883C26.5859 33.6055 25.9844 33.2539 25.1328 32.9336C24.2812 32.6133 23.5469 32.2969 22.9297 31.9844C22.3125 31.6641 21.7812 31.3008 21.3359 30.8945C20.8984 30.4805 20.5547 29.9961 20.3047 29.4414C20.0625 28.8867 19.9414 28.2266 19.9414 27.4609C19.9414 26.1406 20.3633 25.0586 21.207 24.2148C22.0508 23.3711 23.1719 22.8789 24.5703 22.7383V20.2305H26.4453V22.7734C27.8281 22.9688 28.9102 23.5469 29.6914 24.5078C30.4727 25.4609 30.8633 26.6992 30.8633 28.2227H27.4766C27.4766 27.2852 27.2812 26.5859 26.8906 26.125C26.5078 25.6562 25.9922 25.4219 25.3438 25.4219C24.7031 25.4219 24.207 25.6055 23.8555 25.9727C23.5039 26.332 23.3281 26.832 23.3281 27.4727C23.3281 28.0664 23.5 28.543 23.8438 28.9023C24.1875 29.2617 24.8242 29.6289 25.7539 30.0039C26.6914 30.3789 27.4609 30.7344 28.0625 31.0703C28.6641 31.3984 29.1719 31.7734 29.5859 32.1953C30 32.6094 30.3164 33.0859 30.5352 33.625C30.7539 34.1562 30.8633 34.7773 30.8633 35.4883C30.8633 36.8164 30.4492 37.8945 29.6211 38.7227C28.793 39.5508 27.6523 40.0391 26.1992 40.1875V42.5195H24.3359V40.1992C22.7344 40.0273 21.4922 39.4609 20.6094 38.5C19.7344 37.5312 19.2969 36.2461 19.2969 34.6445H22.6836C22.6836 35.5742 22.9023 36.2891 23.3398 36.7891C23.7852 37.2812 24.4219 37.5273 25.25 37.5273C25.9375 37.5273 26.4805 37.3477 26.8789 36.9883C27.2773 36.6211 27.4766 36.1289 27.4766 35.5117ZM41.3867 40H38V26.9453L33.957 28.1992V25.4453L41.0234 22.9141H41.3867V40Z"
      fill="#1B1A1E"
    />
    <circle cx="148" cy="32" r="32" fill="#D7DDE0" />
    <path
      d="M138.496 40H135.109V26.9453L131.066 28.1992V25.4453L138.133 22.9141H138.496V40Z"
      fill="#1B1A1E"
    />
    <g clipPath="url(#clip0)">
      <g clipPath="url(#clip1)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M146.479 21.2H154.19C158.88 21.2 162.435 23.7217 163.757 27.3912H166.159V29.6091H164.263C164.3 29.9596 164.319 30.3166 164.319 30.6794V30.7339C164.319 31.1423 164.295 31.5438 164.248 31.937H166.159V34.1548H163.712C162.354 37.7733 158.827 40.2709 154.19 40.2709H146.479V34.1548H143.8V31.937H146.479V29.6091H143.8V27.3912H146.479V21.2ZM148.635 34.1548V38.2814H154.19C157.618 38.2814 160.164 36.6286 161.35 34.1548H148.635ZM162.01 31.937H148.635V29.6091H162.014C162.063 29.9754 162.089 30.351 162.089 30.7339V30.7883C162.089 31.1801 162.062 31.5636 162.01 31.937ZM154.19 23.1863C157.633 23.1863 160.188 24.8826 161.366 27.3912H148.635V23.1863H154.19Z"
          fill="#1B1A1E"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(143 19)"
        />
      </clipPath>
      <clipPath id="clip1">
        <rect
          width="22.4"
          height="19.1008"
          fill="white"
          transform="translate(143.8 21.2)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const OnboardingPaymentIcon = (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
    <path
      d="M48 37.3335C41.372 37.3335 36 42.7055 36 49.3335C36 55.9615 41.372 61.3335 48 61.3335C54.628 61.3335 60 55.9615 60 49.3335C60 42.7055 54.628 37.3335 48 37.3335ZM53.3333 50.6668H49.3333V54.6668C49.3333 55.4028 48.736 56.0002 48 56.0002C47.264 56.0002 46.6667 55.4028 46.6667 54.6668V50.6668H42.6667C41.9307 50.6668 41.3333 50.0695 41.3333 49.3335C41.3333 48.5975 41.9307 48.0002 42.6667 48.0002H46.6667V44.0002C46.6667 43.2642 47.264 42.6668 48 42.6668C48.736 42.6668 49.3333 43.2642 49.3333 44.0002V48.0002H53.3333C54.0693 48.0002 54.6667 48.5975 54.6667 49.3335C54.6667 50.0695 54.0693 50.6668 53.3333 50.6668Z"
      fill="#E0DFDF"
    />
    <path
      d="M25.3333 37.3334H12C11.2626 37.3334 10.6666 36.7361 10.6666 36.0001C10.6666 35.2641 11.2626 34.6667 12 34.6667H25.3333C26.0706 34.6667 26.6666 35.2641 26.6666 36.0001C26.6666 36.7361 26.0706 37.3334 25.3333 37.3334Z"
      fill="#E0DFDF"
    />
    <path
      d="M57.3333 2.66675H6.66665C3.72531 2.66675 1.33331 5.05875 1.33331 8.00008V42.6667C1.33331 45.6081 3.72531 48.0001 6.66665 48.0001H30.6666V45.3334H6.66665C5.19598 45.3334 3.99998 44.1374 3.99998 42.6667V25.3334H60V37.3334H62.6666V8.00008C62.6666 5.05875 60.2746 2.66675 57.3333 2.66675ZM60 14.6667H3.99998V8.00008C3.99998 6.52941 5.19598 5.33341 6.66665 5.33341H57.3333C58.804 5.33341 60 6.52941 60 8.00008V14.6667Z"
      fill="#E0DFDF"
    />
  </svg>
);

export const YesNoMarketIcon = (
  <svg width="40" height="18" viewBox="0 0 40 18" fill="none">
    <path
      d="M7.32498 12.6671C7.14818 12.667 6.97864 12.5968 6.85364 12.4717L4.85364 10.4717C4.73221 10.346 4.66501 10.1776 4.66653 10.0028C4.66805 9.82801 4.73816 9.6608 4.86177 9.5372C4.98537 9.41359 5.15258 9.34348 5.32738 9.34196C5.50217 9.34044 5.67058 9.40764 5.79631 9.52908L7.26298 10.9957L11.465 5.59108C11.5735 5.45139 11.7331 5.36056 11.9087 5.33856C12.0842 5.31655 12.2613 5.36518 12.401 5.47374C12.5407 5.5823 12.6315 5.74191 12.6535 5.91744C12.6755 6.09298 12.6269 6.27006 12.5183 6.40974L7.85164 12.4097C7.79367 12.4847 7.7204 12.5463 7.63671 12.5907C7.55303 12.6351 7.46084 12.6611 7.36631 12.6671H7.32498Z"
      fill="#D7DDE0"
    />
    <rect
      x="0.7"
      y="1.36669"
      width="15.9333"
      height="15.9333"
      rx="2.3"
      stroke="#D7DDE0"
      strokeWidth="1.4"
    />
    <rect
      x="23.3667"
      y="1.36669"
      width="15.9333"
      height="15.9333"
      rx="2.3"
      stroke="#D7DDE0"
      strokeWidth="1.4"
    />
    <path
      d="M34.4712 6.19537C34.3462 6.07039 34.1767 6.00018 33.9999 6.00018C33.8231 6.00018 33.6536 6.07039 33.5286 6.19537L31.3332 8.39071L29.1379 6.19537C29.0122 6.07394 28.8438 6.00674 28.669 6.00826C28.4942 6.00978 28.327 6.07989 28.2033 6.2035C28.0797 6.3271 28.0096 6.49431 28.0081 6.66911C28.0066 6.8439 28.0738 7.01231 28.1952 7.13804L30.3906 9.33337L28.1952 11.5287C28.1316 11.5902 28.0808 11.6638 28.0458 11.7451C28.0109 11.8264 27.9925 11.9139 27.9917 12.0024C27.991 12.091 28.0078 12.1787 28.0413 12.2607C28.0749 12.3426 28.1244 12.417 28.187 12.4796C28.2496 12.5422 28.324 12.5917 28.4059 12.6253C28.4879 12.6588 28.5756 12.6756 28.6642 12.6749C28.7527 12.6741 28.8402 12.6557 28.9215 12.6208C29.0028 12.5858 29.0764 12.535 29.1379 12.4714L31.3332 10.276L33.5286 12.4714C33.6543 12.5928 33.8227 12.66 33.9975 12.6585C34.1723 12.657 34.3395 12.5869 34.4631 12.4633C34.5867 12.3396 34.6568 12.1724 34.6583 11.9976C34.6599 11.8228 34.5927 11.6544 34.4712 11.5287L32.2759 9.33337L34.4712 7.13804C34.5962 7.01302 34.6664 6.84348 34.6664 6.66671C34.6664 6.48993 34.5962 6.32039 34.4712 6.19537Z"
      fill="#D7DDE0"
    />
  </svg>
);

export const CategoricalMarketIcon = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M9.3855 4.79028H29.3855"
      stroke="#D7DDE0"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M9.3855 15.457H29.3855"
      stroke="#D7DDE0"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M9.3855 26.1235H29.3855"
      stroke="#D7DDE0"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M0.798157 8.2473V7.29875L1.8307 7.21476C1.99868 7.20304 2.02276 7.15487 2.02276 6.97517V2.78572C2.02276 2.64184 1.98694 2.56957 1.8665 2.53377L0.822237 2.31763L0.954397 1.33325H3.83525V6.97518C3.83525 7.16724 3.84697 7.20305 4.0273 7.21477L5.01168 7.29876V8.24733H0.798157V8.2473Z"
      fill="#D7DDE0"
    />
    <path
      d="M0.174136 19.0041V17.8875L1.78286 16.3153C2.9951 15.1388 3.51138 14.659 3.51138 13.9748C3.51138 13.5301 3.29523 13.2065 2.65916 13.2065C1.99835 13.2065 1.72231 13.4227 1.72231 14.2749L0.0901489 14.1304C0.101869 12.2222 1.55435 11.9097 2.81476 11.9097C4.67544 11.9097 5.33559 12.702 5.33559 13.8302C5.33559 14.9591 4.55564 15.7033 3.67934 16.5431L2.32258 17.84H4.08755C4.20734 17.84 4.25552 17.8159 4.2796 17.6955L4.44758 16.7475H5.71971V19.0041H0.174136V19.0041Z"
      fill="#D7DDE0"
    />
    <path
      d="M4.22525 25.9918C5.24608 26.148 5.80989 26.76 5.80989 27.8401C5.80989 29.4247 4.62175 30.1688 2.90495 30.1688C1.69271 30.1688 0.612627 29.7372 0 29.0647L0.96028 28.0087C1.41667 28.4527 1.92056 28.8004 2.76107 28.8004C3.43359 28.8004 4.00976 28.5608 4.00976 27.7203C4.00976 26.9879 3.55337 26.6877 2.80924 26.6877C2.50911 26.6877 2.28124 26.7118 1.92057 26.7717V25.5719L2.50912 25.4996C3.37305 25.3915 3.84115 24.9716 3.84115 24.2034C3.84115 23.747 3.63737 23.3752 2.96484 23.3752C2.31705 23.3752 2.0052 23.5914 2.0052 24.4436L0.360667 24.2991C0.360667 22.4026 1.78905 22.0784 3.04947 22.0784C4.89777 22.0784 5.60611 22.7867 5.60611 24.0712C5.60611 25.0797 4.98176 25.7157 4.22525 25.9436V25.9918Z"
      fill="#D7DDE0"
    />
  </svg>
);

export const ScalarMarketIcon = (
  <svg width="40" height="12" viewBox="0 0 40 12" fill="none">
    <rect y="5" width="40" height="0.999998" rx="0.499999" fill="#D7DDE0" />
    <path
      d="M13.5 11.2C16.3719 11.2 18.7 8.87188 18.7 6C18.7 3.12812 16.3719 0.8 13.5 0.8C10.6281 0.8 8.30003 3.12812 8.30003 6C8.30003 8.87188 10.6281 11.2 13.5 11.2Z"
      fill="#252429"
      stroke="#D7DDE0"
      strokeWidth="1.4"
    />
  </svg>
);

export const SwapArrow = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M8 0.75V15.25" strokeMiterlimit="10" />
    <path
      d="M12.5 10.75L8 15.25L3.5 10.75"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const ClipboardCopy = (
  <svg viewBox="0 0 7 8">
    <path d="M5.33341 0.333496H1.33341C0.966748 0.333496 0.666748 0.633496 0.666748 1.00016V5.66683H1.33341V1.00016H5.33341V0.333496ZM5.00008 1.66683L7.00008 3.66683V7.00016C7.00008 7.36683 6.70008 7.66683 6.33341 7.66683H2.66341C2.29675 7.66683 2.00008 7.36683 2.00008 7.00016L2.00341 2.3335C2.00341 1.96683 2.30008 1.66683 2.66675 1.66683H5.00008ZM4.66675 4.00016H6.50008L4.66675 2.16683V4.00016Z" />
  </svg>
);

export const P2pNetwork = (
  <svg viewBox="0 0 62 62" fill="none">
    <path d="M32.293 11.707L40.293 19.707C40.488 19.902 40.744 20 41 20C41.256 20 41.512 19.902 41.707 19.707C42.098 19.316 42.098 18.684 41.707 18.293L35.414 12H45C48.86 12 52 15.14 52 19V25C52 25.552 52.448 26 53 26C53.552 26 54 25.552 54 25V19C54 14.038 49.962 10 45 10H35.414L41.707 3.707C42.098 3.316 42.098 2.684 41.707 2.293C41.316 1.902 40.684 1.902 40.293 2.293L32.293 10.293C32.201 10.385 32.128 10.496 32.077 10.618C31.976 10.863 31.976 11.138 32.077 11.382C32.128 11.505 32.201 11.615 32.293 11.707Z" />
    <path d="M29.923 50.618C29.872 50.496 29.799 50.385 29.707 50.293L21.707 42.293C21.316 41.902 20.684 41.902 20.293 42.293C19.902 42.684 19.902 43.316 20.293 43.707L26.586 50H17C13.14 50 10 46.86 10 43V37C10 36.448 9.552 36 9 36C8.448 36 8 36.448 8 37V43C8 47.962 12.038 52 17 52H26.586L20.293 58.293C19.902 58.684 19.902 59.316 20.293 59.707C20.488 59.902 20.744 60 21 60C21.256 60 21.512 59.902 21.707 59.707L29.707 51.707C29.799 51.615 29.872 51.504 29.923 51.382C30.024 51.138 30.024 50.862 29.923 50.618Z" />
    <path d="M26 27V25.035C26 23.273 25.058 21.622 23.542 20.725C21.441 19.482 17.906 18 13 18C8.028 18 4.511 19.478 2.436 20.717C0.933 21.613 0 23.26 0 25.014V27C0 27.552 0.448 28 1 28H25C25.552 28 26 27.552 26 27Z" />
    <path d="M13 14C16.866 14 20 10.866 20 7C20 3.13401 16.866 0 13 0C9.13401 0 6 3.13401 6 7C6 10.866 9.13401 14 13 14Z" />
    <path d="M59.542 54.725C57.441 53.482 53.906 52 49 52C44.028 52 40.511 53.478 38.436 54.717C36.933 55.613 36 57.26 36 59.014V61C36 61.552 36.448 62 37 62H61C61.552 62 62 61.552 62 61V59.035C62 57.273 61.058 55.622 59.542 54.725Z" />
    <path d="M49 48C52.866 48 56 44.866 56 41C56 37.134 52.866 34 49 34C45.134 34 42 37.134 42 41C42 44.866 45.134 48 49 48Z" />
  </svg>
);

export const DollarIcon = (
  <svg viewBox="0 0 16 16" fill="none">
    <path d="M6.53333 13.5333C6.53333 13.7333 6.4 13.7999 6.2 13.7999C3.73333 12.9999 2 10.7333 2 8.06659C2 5.39993 3.73333 3.13326 6.2 2.33326C6.4 2.26659 6.53333 2.39993 6.53333 2.59993V3.06659C6.53333 3.19993 6.46667 3.33326 6.33333 3.39993C4.4 4.13326 3.06667 5.93326 3.06667 8.06659C3.06667 10.1999 4.46667 12.0666 6.33333 12.7333C6.46667 12.7999 6.53333 12.9333 6.53333 13.0666V13.5333Z" />
    <path d="M8.53342 11.8666C8.53342 12 8.40008 12.1333 8.26675 12.1333H7.73342C7.60008 12.1333 7.46675 12 7.46675 11.8666V11.0666C6.40008 10.9333 5.86675 10.3333 5.66675 9.46665C5.66675 9.33332 5.73341 9.19998 5.86675 9.19998H6.46675C6.60008 9.19998 6.66675 9.26665 6.73342 9.39998C6.86675 9.86665 7.13342 10.2666 8.00008 10.2666C8.66675 10.2666 9.13342 9.93332 9.13342 9.39998C9.13342 8.86665 8.86675 8.66665 7.93342 8.53332C6.53341 8.33332 5.86675 7.93332 5.86675 6.79998C5.86675 5.93332 6.53341 5.26665 7.46675 5.13332V4.33332C7.46675 4.19998 7.60008 4.06665 7.73342 4.06665H8.26675C8.40008 4.06665 8.53342 4.19998 8.53342 4.33332V5.13332C9.33342 5.26665 9.86675 5.73332 10.0001 6.46665C10.0001 6.59998 9.93342 6.73332 9.80008 6.73332H9.26675C9.13342 6.73332 9.06675 6.66665 9.00008 6.53332C8.86675 6.06665 8.53342 5.86665 7.93342 5.86665C7.26675 5.86665 6.93341 6.19998 6.93341 6.66665C6.93341 7.13332 7.13342 7.39998 8.13342 7.53332C9.53342 7.73332 10.2001 8.13332 10.2001 9.26665C10.2001 10.1333 9.53342 10.8667 8.53342 11.0666V11.8666Z" />
    <path d="M9.79989 13.7999C9.59989 13.8666 9.46655 13.7333 9.46655 13.5333V13.0666C9.46655 12.9333 9.53322 12.7999 9.66655 12.7333C11.5999 11.9999 12.9332 10.1999 12.9332 8.06659C12.9332 5.93325 11.5332 4.06659 9.66655 3.39992C9.53322 3.33325 9.46655 3.19992 9.46655 3.06659V2.59992C9.46655 2.39992 9.59989 2.33325 9.79989 2.33325C12.1999 3.13325 13.9999 5.39992 13.9999 8.06659C13.9999 10.7333 12.2666 12.9999 9.79989 13.7999Z" />
  </svg>
);

export const RefreshIcon = (
  <svg
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M10.23 1.7625C9.1425 0.675 7.65 0 5.9925 0C2.6775 0 0 2.685 0 6C0 9.315 2.6775 12 5.9925 12C8.79 12 11.1225 10.0875 11.79 7.5H10.23C9.615 9.2475 7.95 10.5 5.9925 10.5C3.51 10.5 1.4925 8.4825 1.4925 6C1.4925 3.5175 3.51 1.5 5.9925 1.5C7.2375 1.5 8.3475 2.0175 9.1575 2.835L6.7425 5.25H11.9925V0L10.23 1.7625Z"
    />
  </svg>
);

export const compoundIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" >
      <path d="M3.97062 18.6802C3.37746 18.3207 3 17.6556 3 16.9726V13.0721C3 12.9284 3.03595 12.7846 3.10785 12.6587C3.34152 12.2633 3.86278 12.1195 4.25821 12.3532L13.0657 17.4939C13.587 17.7994 13.8925 18.3387 13.8925 18.9498V22.9941C13.8925 23.1738 13.8386 23.3536 13.7487 23.5153C13.4612 23.9827 12.832 24.1444 12.3647 23.8568L3.97062 18.6802ZM17.11 11.2747C17.6312 11.5803 17.9368 12.1195 17.9368 12.7306V20.945C17.9368 21.1966 17.811 21.4123 17.5953 21.5381L15.672 22.6166C15.654 22.6346 15.6181 22.6346 15.6001 22.6525V18.105C15.6001 17.5118 15.2945 16.9726 14.7913 16.667L7.06223 12.0476V6.85297C7.06223 6.70918 7.09818 6.56538 7.17008 6.43956C7.40375 6.04412 7.92501 5.90033 8.32045 6.13399L17.11 11.2747ZM20.9565 5.19932C21.4778 5.50489 21.7833 6.04412 21.7833 6.65525V18.6442C21.7833 18.8959 21.6395 19.1116 21.4238 19.2374L19.5905 20.226V11.8858C19.5905 11.2927 19.2849 10.7534 18.7816 10.4479L10.8728 5.70261V0.831521C10.8728 0.687726 10.9088 0.543932 10.9807 0.41811C11.2143 0.0226718 11.7356 -0.121126 12.131 0.112542L20.9565 5.19932Z" fill="#5FCF99"/>
  </svg>
);

export const oneInchExchageIcon = (
  <svg width="26" height="32" viewBox="0 0 26 32" fill="none">
    <rect width="25.6" height="32" fill="url(#pattern0)"/>
    <defs>
    <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use xlinkHref="#image0" transform="scale(0.00833333 0.00666667)" />
    </pattern>
    <image id="image0" width="120" height="150" xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAACWCAYAAAAVKkwgAAAgAElEQVR4Ae19d5gUxfb2/edjVwUVFe/PeA2oV+9VUNkZiUuQHLZnyTm4siJRFERBQZJkEAmCIEEQAUkCCoogCipIUFSCERQlqSS5JqS+562Zt+d0TfWEZUFR93lmq7q6p7r7vHVinar5xz9O8V+BYCgrLcMZmR50VqUFnIPpwZDCJy3gbNZtQadz+h3OVaf4Mf7uPj8pAMDSg84UCSiBtZYBZ2p+3v/vvvKBAuklnPL4mF2lB5zeJojFqrf8tWeXR9RLw8foT4d2D2ou1tcFnD5mH38f/54UKO6cD9GqwZEAF3fOD4vdsAi+sEz94wB117Mz1aG5c93PhN6DJbgezk3PCGWmB0It9SDBQJGfjFDm/8twiv+er/7nv7cBosvBRnuL1vfFAAuQwcGCu3fi+9DP55as+5Fol9fE1CH20wLOAgyEPz/BT/MbpgWdUR4gIhwsOXdIj34utx7I6ab2VW+tDk2boQEvUrb+Cc/3IwZX3tucLwoEHOc0k+HPeTutcyOAuDo0w2mVFnS6ECCC+/2ocWrPLbXVN9dVUQdHjtOAO006eLixSNkGCpxO3WyKcinWP5g8VXM/rr2tZmtPP7g3pMCfk+qn8a3SgqGFICZAcUVtwOlDSzmraUcNJMAFsN9cnqnAwaZobtqyy6/TuvY58m3vwWp/TjffD85/N2q8/v6asRPV84+PVI/c96j+tGzTVV1croEBtDPlNJLjz3WrsNsTNp7ITZpzAqH3yL1ol+ACZIhmAFysSrM9xTMbbX37xmpfA/hkPm//q8Lu8rfUev2Cktl7eY9EJVRIIsr/JQ0111jyoQ7FMLnU5eCIyAZXH5z2bFgsRwDc36STBrdTs457Hr+hymvJgIprAGxm+cZbSlRv9d3ALr1+wr0weCiyIcrRBjUBMR8DurTsLe/jXh9wev+juHO+5ZI/X5MGMMNp5fdmFM/QgSA0iOwSKhhSEKEAVIL47aOD1epBo35dcmO1T2S7X33bFZmHH6+T8wlAjaePCTSfA4NLPkt60PnC7z3AvfJaGId/DZC1mxM6lO4DMogGwoBzvnt8pAaZhLqgTP1fv58w2QMuQARHb7uj7lE/QGX7vvJN1Psjxh4neN9PeEZ5dHTTTmo/Pjnd1IEOPV3dzOs9vjWkit97ZDit8Ny31mh9nM//lwE5PeBM1S9tIQ6JAYD3BOpqgGnNZobuPr4vlBsDMAwsCaJffX92rvp++owwoNm5ak/EQPO7nu17g3XVd4+PckW3BBmGn+k+gXtpEMLal5yfjO72kwpnTLs0pBBH5oPL9vfHTjwBAoOLoY8BfOPmnX4i0T1lEkABJACcLKie/qnrs3OtIOPZwv65M0VOdEBvQ6dDDRSt3Cwq3v8KEx7pgdDr5FaCLP3fVb0GapELjgUX4NoOje79ykb409lGKQCRDXvAA5wIpgDcWREVg2s9XJ+EBc5Bf8aWEGtRgOEWOVMkwPNzHjiggbuuitoyduJvuLZWtRa7TyeYfveCNICol3oZUqZC3Vz9gdUtrXFeF7XE/Y2zMxZQ24OnB0M704OhQxeUa7QDAMow5OQmHfeTwAhBgni3Vm3htvFcqiUs6FS/Y7seol7qZYIoSwRPYLCxzY3KBUPqL+EjwwIFsOPmLF1JkMnV7ermfiEJu+Ceh45cVLb+cdmWSh3AZt9c4/Vrbs9al8r3bNduu77qEbZrkT3hGRdEgAnuhhWOQQBuJ8Bw/fh+cBdtg96v7cyc8Ii4TJdVabH5+8NHD0uQi1Zs/C2JyHJIk467lt6a9TmPkylHXF9l3W231X4zPeAc0sQNOIeS+V68a6bnPPDj4Prttstr9hSrreCC4SPbUSfA0MkEOD2FuWmtvoIhZVrrfoPhD9UOtwEvvfj1de99f/ioK67RhkiTSaxkjpdcXXGHB1Rh/KDfZPqIdw3AhNF0U9UWxx4r02DzN5dl7ox3PQGG65cKwGGbJDIfrt/hDNTddI3AxUopVfWehz+9tmYbTYjCGVnbU9GZGBCXZmRtdokYDKnijTq+eV6Z+jrGfH4k3Lj86oquiI0HTLxzCIJIK7pwMLQd8WyoAX5KFau1/F8l635UsV6uwuf2WnJ2ylmVhhwxJB6Yn4DTW9ojeB8GTM5QLg7PHi14be0Hsxe9pMZMfU6lCvL0opXec8VwMHQYwC5+890dRSo01pGxtr2GqMsivuiKqyueNBcDfM5AQfRmhtq6ESs5wPKjjkAJxTsk3h9KBCfzMHSPwMV79u1Xz8x6Qc16cfn/SJwLg6GP43EyRDLBvaRy8/fe2rLjq61ffHUY4J5fpv6Jx0Y/rQcN+4vHmamc05Z0ZJpRimGIYn7YzhJcz+hW1G0Kz57x+VjiPGPyFO9pQedoOI0Jolt/prjpRhmhzD9svDviMmldDJAbPTjo7cyWXX8lJ58ddA4DSBsABQPOVyBK8YYd1nz97UGFT5EKTT47r0z94wAXA6Zz/6iBA2639ZOXNoAMcU0AUy0BOPQ5gJR+NNrMiRACn7h0vnBTjf4os1h0mTKadlkzacHyd+rf338bgJHi2gbyQ/+usgYvDM4luDn9nlx9bul6vxJc9FO+VdeogRMMqStKZH3gJxXyYtzB8ILPe6BbX+0fw0dGXScaZOe6FjZ8ekxu5GUgJAY2VhKEY+LOFOSMJyNNT901nGUKhtSnX32zGwbXSyte19wHkC+5s5mOZp19R+io5OQI9x7+6PPduwjwOSWzj4FjASw+QydMc8GFLqZU8DPiit9aew2MtbwAnawUwICwzVZJ4HEes11oow4GyGXuesj9XFP7bvfdEg+A3zmvDL4hHhJcDIB//uUXteKNtWrl2xt+RDuBgb4FyJnFa65Ge82OfZYR3GmLV753e6MOPxFclLfUzdVECDTp6A4Y9nXl7XXeNEEJ3VzdjZPDMvbjdPN7eT2GmKcPDSmAOtrQ38EJkzXAnJG6qEIT9dl3x2I+m3cdUM+v2qC6PjFdg39B+SZxgHdW/S6RNDlJTi5WSh26KZS7pXpuD4+4plEFgGFUEeDs+/q9C46dPneBWrZ6rSrf+n79onCR0E7gpejPuan6agkOxT761p+Ac6itcY28/lTVATS4VyY9VO/cPwZcP8CHP/+yKteujy/QOoHwdOpo6mEQFVz8zpbt28vd9eDyB0dM+pjAPDRkrPvA55dtuCOjWZf1BBflrKUr9uLa1es3ql5PTP4afQFc6uP1W7aqtRvf10CjjQBKLtUuVzCkCpVpsLVIhSZf6muCIQV1kFcDjTp6f7XWal9mY/15pXaumlf9brXtxuoxbhs4+PtIlih8aD5Dy5Gz1aT1u9ScLV+rl7bvU+9+dTAh4K9s+UyV6jzE7YN9odT+dgrTlyfF+aZzL7jY1cfQoZEHPLz4zQ3bJfcCYAAL7t3y2S5VsHTdnwjucwuWqE1bP9YWNq7b/vmX+jpIBvR373+qrScnDr++yjq00XDrPnLyuzDaIvdVRW+v805e9TNi13KSArq1YfMu6vJKzdVNtdqqejXbqzkVWmpw4RrJ4Mhloc6qwYx3Yz7Nn9+kHn55m5q+8Uu18etDvoAPXrZZXdVYLOWJSCgYYskCB4zyZIjRFyYRUVIXUx8PGDv5xHll6+uAwtQlKzdLzmUdIEI0Qxejj+7Dxu+RwPI6lGinAXZRiSw3n4s6mADj2i2f7Dwc6tz7wHllGmhjDyoCESsOilRLbWR16+ta0xDDcI2YvWKm6l5cI1eFJr8ZA64N8IeWbVNLt+21Ar1k615Vdeh8VbBsIzKKLm2ZKSaQnOLNUzSNyXYA5dpaOS63gIuXrd34abOHh7qGT+j+/qskULK+c+8B9cEnn2u9XKRCkw3ynK2OwfCvaq2O4b4ECTNOOJbGG7/7zAtLjkmX6/wMR00sWtn9Lvt47pY66q3bs2PaeZ6lCTR0Lnxj+MR4BnwurpmbFLAm2B0WbFFzt3wdA/SrH+9X9aauVRg0vIdbWtKoCDRTrVKOpjEejZsUqdDkxM5v9qmide4OcwoNnWBInXVH9pFhzy58h8ROVK7c+OHyRNd8+tUedWPW3UdxbxD9nasqHKEBN3zGgnW272NQQH/fnB0lUIP/1ogB8+rqrdXCUrGzSwRXljCoGPqkqwTxfWEkfg6Qk+VgE+h75r+vFnzwjQfoV3bs04PmupbRKUzQwFdc64WA4QGXspjGiOAI6jdxFiSyun/EJIyuwxCT19S5+50eo6e9ufWL3YdsBD/ZtsurNP8e94dehW+MeqHS9b6J1y9AhjHXrHt/lwtaNn/AA/ItNdupQmUbqldvcdz2zddVc+sSYNbNqBi4uXDZhvoeF1a9S2X2m6UqDZ6nP1VHLkmJs7st/VBtFjr62U1fWUHW6cCGdc18deKUfEhUBzjCq/EvrthUHTzygwa4WMMOPyIiFY/I+XHuoSen6UgYuRYvULBUvd0w4BL1v+DlFa41zpmqnHqdXQAbVgkHIa6r0dZty67Rzq0TVLOEIUYupsguVLJueCAFHHdAkdjQp5dnd1bFOo1QiUBvOXuzWv7xPpeb+7y6Q4MMA479oUSok6IZJdOZeU3Seli6RuReiGh0ZFrIiQie6Dy4Djqa10HcQ0LwoaGzod+TlRS79h5Q0+YuiAF5TOnmGkSU7Pu+ynfrtsq17lWsm8DKY5nqkwzIvA9KiPOSPZ+Jy93PbvxSg/z+N4dVi+c3afFf+M5W7vOiH4JoM4CTTlig4kaHABZ/qzd8oIrWafstgcivctnqNWr2iy97QD7ZvmGJ00enX12kUnP1WdGqal6xKLddVDEMOjgY9c1FqybkZOlOAWRY2VEgo31H27yx6Asqt4wL9Li3v9AgT16/Sw8GcL+3L+cLiGJ3Eb6wh5AVKznct87wJDrmHwCu07WfO3ngB8L+g0fU3u8Pa45c99Enav7Kd1T/yXPUq+ved7lUfhcBjulzF6m5S5blK8gU1QA6u1PYaGlfo70GUBLsuRINVf9AeI1TZrGaCQGGhS2zN2NBBqBZuwsEnI/SMkLGwvboALiu1aO+3Dxx3U4Ncpu5m/U1xToMN0EO77AgwdX1JLNL6FuBEACWHNxrzLO+1vKBw0fVjz//olAC2PI54WBFk4eH+oILoBHFmrlgieY4gCzBP5n6h5987nIxQqDQx+RYvBfj3iUyHDXghiqagOfcEVLvXlkhIcimqCbIF9kWw5kgBKIcDR3tZ4Uv/GiPGvvW5xpgXGOKajlIZd2Xaz0nhPk9ffFrLsAIVNiIfvDoMfXzr79qcEbPWqwurhgOqt/auJMHMLg/5vcR5QIAo56Z+Ru4DTrZvCavx4iUUVTTT55bpqUGk+FV+MwEGISqc0usayX1MOuYdgSw8oPACCYg4iYNGAaZn6vV7PmNOjBC96pkz8kGF0cHigQYutmDpd9BWmTtb6jrgOMU0zYDC+Ae/+039c13hxTAxc1ubdhOrXihi66jDQDBkAK3mmABYIBQvEH7/QQDbeZ1fsfbv/hSwbCynV+xZp0LMMU0OBbPiGgZZrJQh7+M8poarU+cE3BiluLcd1OsG4W4tOkjS7CZPYISwLtBkoBzIC3gHMb9+LmqUXeruO606AN13+IP3HM2Lo5pSxrgiB9cuFzDnwnwd0d+8BAS+hZ/EMvzVr6tH7hIhcbq+7eaK7WpvsrqcL+CiAa4EL+28OSSyPzyzfXa7X5o2LjjBNl2rQ1EgAt9+/bmLZ5nw7VSTLvZIwFHXVW9lQae/nLBO7J/BrEZU5dRMHA3uJyca5amjyxBlnU3fh1w4O58lRYMHSHAKMGh5FZZ5s5/3203uRiu2I1tB7gDRfeXbOqvNMPf2/G5BvKX48c1p5LQOIZo3rrza1W0Tg4iXmrDS+01uAD4kcE9VJlW3TS4o5+ZGQMA+sEkBEDN7tT7YPEG7fcR4GfnLkza6Pp09x7tGs1dvEyBo/l8qLM/cjCIwMQDimm0QYTT4r7tttouoKjjvATdBBmJ9MwakaCyjiUzmvjg2oiITgs6n7ht8PPLNlK1xq9wwSTIENWsQxfL78D4qjToBU9b8q6S3q0uLEZGz3qRTKwAKjj5yLEfdRvq3Z+Yom8y7MkeLrgAuGSzDuqWuu00kRt17e0SngAgPg0AoIOzOz/609l3hI4REJQLl70W8x1+FyqBdZQAE/7v9LkL1foPoqqA/VEcg0vZhhIEO79MdF4axxcLji0YAeQGAboJsHls6mfPBjTCyEoPhN6WgIEbCaZfyTAmBgQAtwDs2XvMTwXrdt6cwQ4XZVEB98KoKt+mswZ37oz7VbtePdSV1VqE53yfmKiGTpyumjzQzwMIQGFoEZxDEQqukgDAjZJAsg71gA+PUUr/F31LDoY4lskFvAesawn6lVVbai4DaNL4AuclsrDhQn1rGF9ePzmqd0nbtEDoY9YJmh+4aKeYvv2Bse5g4Pd1mawvLDM5aEkLXHUVbhG5t3a7zuqi8o3U5VVaaHF3d6/BasyU51T/0U+ra+5spNZ9sMMDBvQyxDAIDeJTH5oAxxPVx376OQbktzaFEwfQ76yFUSuagJolBpdsu6FOjuZqAHxxRlaYwyPuj5+FbYYxIZohliXnpknOFQZWetB5RwIkgbMBDa7FjJM8J7+fdLBD+sLUwUD1yP9+VKs2fqg+3b1XBzFgVF1Wpblq2q2fGjphqkusHoNGq+p3dVXX3NlQjZ4x3wMuuI3WM4gL/UgdiVISHHU/1wkBlRMnTsSATMlg9pPMcUbj8H5esJxBuEvvbOYaXxDXpjjmsQkyUm6lu3RuqUjc2gMu4suh39IDIZ1ijPslMw1p6uo8AcxoFqYKJefCYkZU6tra4ZGOzme//JoGbPILi1Wzbv1UqUb3qszmnVS/p2bEcC7AhT9M7gXRkYBXNLLBmcnBBMXmQ6MvDDiAzOgZ2vCZs3hZzEBhX/FKDrRzSmZrgPk8nLiA2CaoZgljS4Yy4R4B6JgF6dDrgqMLBJy3JEjgUsmhieoQ7e73kxXRXO1fr9vjEl8PJwJovxAkCW0r6RqR0O7DBUOKBOU5ln5cDGMLAJsW/pZPd6nhk55NGWQCjGeC2uD9mUYUz9iCDkZu14HIFlK0oif2GWLZuE3o40BovaRB2b4zfQGu8OTKmHOeWaekAY6IEql/QUQTMFvwwrxGHuN6Eg0lAOXLFS7X0HNOXod6PC7GKPz5l3A0jfcbN2eJ6jdmctw+zXsAYIhlulI8zzQiPKvN2JKWM/Qvdubr2K6Huq5yU/f98F2bLjYDH37W9B1Dl6lyo2JdKQlwWiB0KK7ljJPSB+ZsEggIo4rEQwmuSgVgukUkGkpyBl6+Quv744Lhx8V4FkTT8PfDjz95ntG5r6967ImJcfuVzwOXTR7LOuPXLf8Tm3EJcU2QkfUh9S8HcLyyQIajd1TANbZEPoB7wyPzVPWJseJbApyUkUX9e31WW000/oO+I8Cvvb1RIdbLY1spo1HImJR6F4QDMQuLAH2gcTgJXhJV1uNZ1AiZ8g91Pg/cuCurtUoJZHlPWael7xfZkuFLZH2kAnJaIEsvGADA0KlS7xJcAJw9bZ3nHK7DFKQ7eJIR0UyVRYqO/IOBBcItfmO9GjDmGW1YkZBmCW5duGyFvh5cboILwtXr3Dv6YBGV4KeDSeh4EoNcbBpdUxa/pq6vc7d229hPXkoppldeZV/uKqcTAbJL+GB0qjDaFtXDaQFnqWwHcAAzY9BLmnMBbrH+i11wnSlvu3X5vYQcLJPtFr3+jsRXW6rgiBKNO2kx5qcTGXuGMeXnsnB1g+fhgiFtUccjPvo0BxOPJReb9kLZNt1VIgkR7748RzFtTkAsvqaSa13rPbIjM02wos13tB2nBbJWynYADHEMYPkpPXy5C6qsy+8lBjiyCQtyscw/ELJ6hz4KQYw5ceZu/UAFkSCWQWg+FNb1dJkw3z1Guy3iRAKjJKC2klyMZ5cqBXPU6Bv+uuwr1TptBhmvhv41kwXkakW6SWmGD0waoCyQ4bwoj+HrmgBXHb9aA4z22x6PJvfJ7yUEmLnQOY894cEXHIEZowsyG2kCvbZ2XQyhwdGYNfIjGsSv1LkAd/wrG1TDGe96JrQR+PfrA+0Q/zZw0Sa5GC8gw5lt+z+pCpdD3DkakIl3H9s5zjjJeDUA5rwyfWOIarpJ3DTOA4QJdsBZLs8jxiwBvrH3fJd7AS6t6ZiUnrizSZaJfqKMWaNiDTrqMCReXBpQEMlvrNsUFxRT3wLcqaveU5wtYYwVL4lBYCMu2xLNF0sulq4T1AsGKAIr7CvVUrp1BPO5a+/U0sGccaJVjYCHC54IcLhtADtDbuwS0pmYtSatdcUzDC2IbeheiGwCbJls8P8VG5lny1RZ6OGMZvep25uEUzghnkEUchFKxnwfGjrOXVAmCSeDB3ipYo06q6WbP1Vt5mxyRyWiNzIiY/qhsr94ehhcDNEs/6RV3XX405rYPYxJDdl/vLo0tAgwgh94Lx6z5EpEcDKXv3C60ANuOFvyXdkGMPGh/gU345gWdaWxq/QxYtfye3EzOphnS/G8cFV4El92QMJAHMOixQvDYMKKAnwY0kPosdmD/fVHfj9n4Hj10b4jqv2C6EQ2X4ZTYbg+npimde4nphndIsjgaF5LXWxysUzviQcwzvF9Fl5dScG4wnFhC8AvXlNJjX7gMS2qExlb0k1Cf6AJOfi/jy3Sx+RegE7AYxLy/DI6uLEXOmeiHQytfpNmu8RB+g2DBivXrlPDn55+ApwmgwOo/1csHyExUGJt7McHflDdl36kH5jAsqw0ZJ5LPFNMMzEABIbLRcD8SgQ85J/k4uyu4Y1UOVjRJ5IF4hmHEnS+0/YryrszTmgzDS9wMtoxZehOGxo5WewrLeAsYx0laEIdTG4l9wJg+sOeIEcwpKxRLCmaGZpEmZnTQ2dryHizGUfGi0M0SwIA5PPKeLfbxyp3LIoetOpjK7h6GqxmdF0RXlJO5UmAcS8/YNmOyQf5J7mY6UWmlEBmSCKQmfWB5+OMkwTGjHLhXJGy9T3bPcjrWS+QkeUCzEAHrGZyL7kZ4EqDS6o13zClKZpBmD5PzdRJdDCsyrXppmYueElnWEgrWVrFyJiQE+cgHh8eBhW2M5j13m4ruBitmCbT14sRLoP95sAikPFKhFbln8wpu7JaS21Ry4HJTJB4IDMxAbr07DvCgQr6xnxfaWyxjUl3tlg0rkkLOlt4LUOV8HXJvbCcqY/pIoEp+J1wH6GFMRws484UzSBK9gMD1VPzlqnrat3l4U4SBFwKMYrP9XVy9IZmkuOkYQW9u+aL71TjmRusACMJXD4o69y/A/eE3iXhwc3xgOU5ACr/ZCy9Ra9h+p40GnEPabzxXnxflnLg4jkBLs55QA5El6/yXVj6+cIFuG9nMKQT6TDoaSlTVBNgtmPWif2itG6myrgzLsAfwnyHfvifavrwMO331u30qBVgAvjGhi2qff/R6vIqzfWcLvUx/UX0O3bR66rtC+9ZwTWtwAJ6U7EwZ2AXPBIWJQw7lImMLAKMUrpMeD/mcs15dY0mjhxEyOeS35WrI3BfDmoSFaDyfaX7hPNIDqABxut9y4DzrTzHrA6GIyGmCS5KGlgxGZU2AytNLBMFuAwMIBUHulcaIpLY4NzaHR5R+747qMGdPP8l1aj7AJ2Zges4APDgPV60g2uOQFyLbEMpxuQ94W8DXMlpEhBbPZ7LhPvB2pf3kFmZSMmViQOMYmE6UaoPfp+JfS5YVDcszeBG5LhAhuOZD4ZvS8MT3CrBRZ3nXLUW6SdGPOupQbGNPziXRKJhhbwqvgBLcueCFWs0906a95Lm/glzFrsEIzGuDbV3H4gPhhIRGGkgaHADzqYIyK7oAWfwvvC5EWDxS8Tjs8vSNLbkdGJGxLdn/yiR0yW/D5C5WhHPEi+MKn1kF2QQHwAjH9pnwiEt4Lwpr2dGBzj4xt4LPABzwsHUv74hSrmSEBuFypcDx8iXZx2iEyIZ3IsP/yCqqZO4yaht8tpmMRfIcDbKl2RdBjwYXPGb5JDPLusIs/JPTkI06xnePEZKKayGkN9FnSm5fP94pZRcfAednuMXwUKQI+jo7SlwPVYqkBGkYUUuZkaHjPzhezH6F1FJbP0g1wLLfSXxYiCo+TKcEx02ZQ5ppkEu36ab5joYWnIk40H4wCxNoyot4HzuEsMQYyAYn4EAmwAkOoZkkn+8vtOg8fqZO/WL7sAHvcvzsoSFzeeIV0InQ4R73icOuLiugFjKgmAP6GQTzQCZelkGhfS9xLZLmBHElK8LOjcdxYVygRkmFOTLADxazSAYuLfDgDHa3QDn0oqWlqaZARgz8gLOkbSA84OXING50/wAGIaV/KOhNWx6eBZLcjDCrhJYWZdrnSRdzLppcKX7iGa8c1rQO7hBH+nzknNR0ifGAJDqDevIqH+R7ow9PdC3uw1TuDGkt9c/u2T20ZlLV31pTh4g7Ei3CLq3WY9BGliEJqXBQf2MG0hxg4ey6l1jCYcZq5UAS2KnWsdkCf+YuMCAhwQYRlW8vqXRZQIrj2mDcODG0b9v8BqUNZ96PUbvEmTOAccYp5FdeKQ0jgl6SJDPK1v/eNtHhih8EGcGsHyIEo3CecMAFsSnm4CXM2eMTP1rWn0FAlmedFHbSKcbk6zv6weOFNMmwAy/4h38RDT75TooCaatnqyoLpDh6A1mQN8iNXJVsf4veowqgosSnA1GMcVzZMX/FGKEEtO+5Gq3lCDLi2XdBixEEvOaea25SZjps3F5Kq/3KzGBAQJK18jMgSbx45Vw//hHVxAcDH0pAUKAI14/OJesPjZF9VmRyJd4192irv6v0cO+4MaznpliJfvSBpaLrKzA+hKuk/wSiC05FjrXlnqDGQ6MNH7MOUudJhoIeZx7eR/UMdGBkgDLXCw5cZAIDHmeQQ+2YX7YzPBguJLX+JVm6FQOElmHlJPvxhpY3FoAABmbSURBVIR6tKUZc8BXd5nkCzCtZzMwJPv21IXRJeF16xF5jh/Jch8Qrg/SbQCqybG47oq6na1LID1Zf2Hx4e6iE+4/alTh+Aanrcq8K7x/I3UwXDYSm7sJ8DjZEmuZpJuE75l+PvzeZPqT/rEE1Fb3hDE1PcPvmxZwogvPMpv5ggvxzNkjU81JfFiXRpcLqLWiuVnvF+0Bmh2xxGbYuZPCGQfkWpYx85UBxzOxLZdwsL/1H33qAViKTYjXvAIMPQyQJYASEJsPLK8163Khm+zHrMNt5Dw53zH8Ow9R5vln40d9AWY2hykJ2ZdZuu6RFVSfxrMCzkIZKL+4UjOFSYSl725Vy3fsd8UxgUVp5gtBNKcFQ+4Pe+gHM8J44FwQkhwc6viIZ0UDQMorwBgcckZJ7gCAaFWy3CuBNuPVJrg8NvWx+e7XPjDNF2DGnm270prg4th1j3ywjG0WO9+hA2xZzw2vt+47qnIi2/1IcFHHLjLyAWKMAUsAANwrAe49ZqqH46BHTS6UBE+lLo0lmWOWSh9yDTLB9CulC6npEnn/QpXa+IJL4wrxBEnLOPWdsQAmaJEzTugYmRkEePgbn1m51zQGCgScrTEPZeFeBiHIwYtWr3cBhnuDP5kOmwoY5rWcEkzWsPLjcPbjB6xsN/1j0OSyNkN8AeZ8sOka4XtoM9sxeZQATuN0HO5d/+VBK7iINRuRlkPpQUdvLuoB2QAY3EvuBMCFStdzwQU4DFbQzTEBS/UYljDEdLLfg861gQzfWIKYqH555eY/Ud2dVaqBuq7HLCvAjFyZ3AvagoFiJhxgwCWyng14/xGPe3st22oF2DSsCgSyPHtReECOWOmwnAEc/sDFAPi2JtF9tsi9mNJMFpD8vg5AInfLBnKyXDxj3mLPr7HFM65s3As9zPCvSefkrWeiHId7X/3Ebljh5gb37rEBaoYk+0+arbkXAAPM2l36KepjAEXuJYfnN3jJ9rd63UYryMlycdMej38j6eFnXJm6F2k8cp4YNk6s+5naz+P6cu+n3/6gOljSXnHTGJ0QCH0mX8itC/F8Tsm6mmvBnfiTc7YgvC3MmCwg+X0duBcWt42TE3Hx5NkL3F3zQYcLna5W0Qy/l5YzQJXA1p2+XkvNmHg0MiqN/aTJp/YyDvfOfv9rq2g2dUVaRjSRzAVWBE7YBlEs86dkMAJhSQKfV/cov0Gm/2uCnMiirtWhp7sGGO9u417oXYJreiW1J69VdSa/pWlveiiY17cD6dMqZybwMNJyvuuF8C6o5gOYNzU3+yKgZnBj4rzlrnjWLKyUu+cGRTPa8xqizG+A0R8T5U2Q/WabJj73wi/u+2Nvrmr3xHAv5oAZsTJpW2PiGlUqsrrQGvBI1biSPivSXukWTd0Q3sfYfAAL934gX8hTN/xfEIxcSoDhCsl8qj8K93KwSB9agkzuNi3pCq3v96gqGXdGpIoT+SZdcVx+9Gvq5r4LFcVzLCNZZo58GFc3IxIiAUHECgBv339UtZodXU8kHyZW90anwWRfui7079W1cjS3EliWJuCc4iOB/wil5FaCbDO2xk+f4+Fe6F4kr2N+Nx6wNSa+qW7pG54+rPn0Gi2ardxry6aMB7DM0wIgCEcC4GfWf5mc7g2EPowBVepeATCsZYjeeH+m0ZUI3M3bPlZvrN+kps1brBo/OFBdVqWFKlSqvna9pGWeqJ9E52WoExy7ILL1ogQe7TeGcg9IepQZvMhXFINpoGdLDFrqivCyo1516W5yr2+ynS/AhnGFlYAAd9u+o6r1HLvujfHHgtHt+eSL2eoDJs3xiGITaGlwgeAAzxZwAOfAikVuM6Y0nY6PKEzNwUJv8cgIj+/87eGj2qjbY+x3mQhQ23kzFo1ngCtFET1iyizP1sGglZR8sl553Gp164DFLrCwpm8bGF3obbOcU447+xlX2GZePgzrlqiV3e/14WAQTRpSEmCIaU7uw0LlMlUZfYLbIt0TBPUvzAz/5M1tjTt5fGkA+8uvx9XhY9H0YBtoqbSZXAxgOVc8dfZ8dUFmA50KhcGN+ADoRdqhrDXpLVV25KvqJiM9FuBCjDtT3tHX43um35uy5QyuNo0rrCnChEJLH91rxpzTA1lrbZzqtgnxjEl9P4ABLkOS0qABmAQAEwTgWHKLTBlC4ITXgVOxbOW3EycUQGa7X2mLVPldi3aTi/k8Hfo/6RnsV7bsq8EMDl2mbh2wRP370ej+GwDU/FSJbNmAgRAjJQOhQ6mHJcUWwgCk4cPDtXjmL4DIkce6ZwI64HyZFnQ8zrwLLDhYgIt2GFggkPnnBy4IB07GdyToaJeZJXC7CMj+Q0fc5StyqpDnbaVNBdiuY5uNiyfO9LpF8WaMTGBxXGpYdMMVMzqoaRp3qwYfBYyJYgkIftw4nuVszvcWiMe9Bri4D+LNIJL8k+CagQNEkHA9OJdckghccC3+UglxYvBISUEg45WSi6fMnqeuqNLcE5KUbpENUNkGvVv/2XDECoxkGlapx5wjgHMDFhCfvq+f34sbm4l06UFnrxwgbt3we9ne8pGRMQBLLqPOJZggIowpKZblHCsHDIAA5xJcALz3YPinfuKBxHMQ0bin1PU851dKLr6330hPMl2R+j1ixK8EVNZv6bvI9XdB4xgVmKcJfQAsNmABABTPOT5RK9xcKv14qxNs6bC4ByxoEIx/iDmTgKYIBsEBsDSokArDlF5Yy/yuCa5c/M1rEpWQFjm9hqr1W8MJCImux3k835hpz+vff+AgLpjZzHc6UAKL+o2PzndDkaBvvolm4GtazxOXrFZz3//GY/HhpvzEmOwZWeHfG5TWsta70bwjvDSA6DJc/8ilGjljkQuwKUIROCDnsmR4kMfYZ4OEbNB9kAswLGX5h+NEAJmGFcDCAPq30zbhd9n3vFffOG6K5n+1H5c091Z76g2XvqBzvolmDXDAmUpioYT1fP/iDz03JLgoYyJXQe9PxUT78mZMwrpFlgbOb9v5tSYeOIyZHCCWLRpEUFkiZZf3wHJTBjD4WxISYNQT+byQGAQKJQDGvS69s7miKpHnzfq2XV+rG+ve41lAF2+2yOTessYusvliNUdUry64jQOIhizJt3Z97wsuAJbi+f8Zyx9JeFM0X1K5uUtEXEMi0R3isdRnBNQsZeoLkgXwXYAo9a4E+ej/vLvQ8l4sATACFDwmwLXv7akKloqKf543y3sGjvX8ikqh8smLZkStpFEVIx3DC9QciVdqdUP/YsOUIa9/4gtwzMSCsc9iGGAv56JN5lddUb2VS0xJLICLkJ8JqDxGMIO6F/3S50UAI94fQJacDF1Now73hfEG6YHnIcDMhoRakc8p67OWv6l/rTz83mGVlKzVjFhz3enRHWTzVe9yFMjfZ8BDTl+xXjWdFf29HimaUY+17Jyv5cuZ/i7OyfQbEAcxaEmkd7dsTQpYqXfRL3auYz8//RJdYOYHNDgc13GVA0Q6vk+pAR8Yx7QBEPbEfSgleC+WEM2XVGrqJrDj2ktb9k9K7/6nzwIVmhrdNRbRKk9cIWzDJPeLogTTVpp5V5PW+nMvADbyc73gmkaWD3Gee3m1JiSANd0hya2oYxGcCSwIiY8MaviJZz+w0W4CjOR3ukl8DtzHJqYBbqk23fWuBHyei7I6JwUuwpCcvCcDxa6bDr2XWpaGDV1Y0GItEiYX/DYq44PInKv0gLNBc6wlkIGX7jLsaZfDOOpRJgIWRhT0rBTFJCJKhDkp8iF2E81I+YFMEc3gCUQz6xJg3FM+P+qm3j2nTMOkXSIza8MC7qF4EwnpGaFMMGZSA0ASLvTgUF/dC4A90SsfUNEfgg60bEkYcAam8WSggkRECbcE65C5/YN8LtYBLHUughfQq3nhXACO7/HZOAMEaULxzGfjvUfMfNG9fuTMRTGL55LVu3dG9pkkw5gqD2t7beAWCIaysCMhF3jDtfXhWdFsGFih3k/5AgwD4F8Nu8XElEkA+LipAgtOxSSBbTEb+0V5vdNWi2Nyq+nr+nFovHZyL0CmUUVQZcnnYGBm4vzl2JVAr6LnuStzhiYlmkuPeMVDX3PHA92fAC4G1IhqSjrBXW6Ehs5rD5njeQCMMmQRmE43XwzleWUbxMy5gmh+HNu5/ygtfuNxKvq9olor3S8kASxeBEPyyq0SaPRx8Ifo7zrE87tpReN5APDKDR/++s+KTT2/HHpJnHW90t+9/XFvjNkPXD9QXZon87sM5GHTgpYpmuDYeMDe4OT+Txo5FHcgmCmKIX7j6VQ+vAQVIhiuDy1eCRLqsIYBOgwlTAMy3gzORJu0lnk9RDqv4/PK8KfkXNS56QyeL7f/2F9Mi/niUJekOLdYvxdV9rToBIIVXCytNSQD6SLKnUnpXQJsWtDUCyW6jXMjRaJzVbB0fVW7S98Y/QpiAViTWH6LxGWfElT0A4NJ7jPpByQBOpnSFvOWIEvrvWjW3bvkcxeukpOUUXVz30Uqe2p44h709QNX9m2r++lmYmktZf7VueUaa/FsWnS42UWVW6ku4+e6RoYkqg1YEAng+lnBJqjgQIhNcJjJkfJefnU8A34kmvPFftfJ9kTgQuqQ0Po3BoULeF7FFkmBe5POyoj6unkFF88BaWsFMV6jdJGwPMKMgRbCb/j0GZ8SsABXTuORSNTVpnUtiZ5sHfod+VnwW00/GlIkHtDJRMvwDnI7KC4Ww7vAHUrGYkbGBrMhwbnFOo1wBwxpYpbm/s88n6dF3QBeAvzPWu08D3BZ7XbqlU3bYsAFcePtGWUDN7f/GN0PcqwwLSgt2ESg4n4ffvKF1utLVqyOAVSKVFmHO4awJz+m+yOvNeuQPiSuLiNz2kmDi+UnE6L5VzapCDARNAJTIf5sjWRBaqS6akFytAT4vPLR39kDuBs//coDrp9VLIkDsWaKZRhimC2Su7DbUmEhZgEkRC0GEIDx85nlPfO7jvCktPC5OWqy4MJyrmZM/dG28Sv9wLVuhyQBTFSXAJ91R/gnVTFin1wUDiWSuxDdMUWhjbBSrKEfgov0V/nHbEnowUSTC7b7nMo2+btOYe51tFi+IndUUhYzd8TxA9Ns9wUXO9iltKDMgrYLsEirgUFFYFGCsxIRFP6iTHwDYRigl5wLkOXG3MkMmkT3zs/z5juAe88unZzOlT4v6sjQuKnPAvXfxxbqpSdIx8FGZ8UHvKh/PYWzSDZXVOddnSy4wNsGcNEG93kA9ltvA8JiIkCKMz3iI9bmjJdXW5elcAsGv4EDEWn+DkR+gmjrC/eM4dxgSJ1dqn5SBpUJbrxj/B4hwAXnnlJw/QA+t1x0Cg4cbHMnYITECy+efUe2HiRybS9FNNcZmUF9GGem/saAQRv8UXAXYtX5DT6kj22QnlWyXr6DW+HJ8O8dnVKxLCW1y8HCxwNRN30Wzj/2E9E2IOSGm3CJ8F25QtAUzwzwk6Mk9ydTB+iQIPx+qiUMQlMk474Qy/kNLsQ095q0bcoaue/J61wJroeD4d+Vjm462rTfUx4xLRdU+bkQGhQxw/TiG++6+24AXBhaMvfKBFjuCKf9TtoFAUcVLttQFSpVz+u6RAYluA8TFhCzyYAMCWADloOqYIWWSQUx4olheQ5J7NS3CAV7plsj76Ct5fzQuSbA8jcb+IIoL6riNbRMPSyv9dQJSmSyAFzMtUdm7pUJsMcCFwPF0z8IIu5hnoPaAGcDcHA3wMQHx9CxNsnj9hFw1HlVc/MNXIQoa00KL/uE5ewX/j0pP9cE1Dw2Y9Huy+LXt0QECz6w5A7PruYGwek3oi/kMnGHHNP3NQF2f5MovJ+llVvl88UD2nOdoX5izkUGUypZkJJDbXUsKKM75GdM4TnyHKEygfQ7NmeT5MsXKtfIo4vlREJcbjO4D8njmPUxl4KaUgEDyNzTUT6Pb90YYL7XCaD1IBTPeUmL5PKobGDKNrhCtSP7OgNgP5GMXfZtk/p+OOW5HTdxCSIIhUhWdu9xqmS7aHKctHrlNJotyc7tMyKquZkKAxwQ3Ux0k5LBs/2ueB7Zn289oDlCG0m2a9ICzjFpCOIarDxIJq4sQfSrlxnxipv+Cq71iz2fMn3rNwpcYgiC0hdGLJohSxl/lhPh7vcFh5jiE6IaFrVcngKQJbiow1CKcnFs6q31XvK+Rj0t4JzARmxp4pfF2Efh2h3zRd9iIp8WMrlW5o3zfpjuO+Ui2Qay6yoJgCs/MMxjRQMMMy7MB/cr5QwMshIpqtEXP9I6J9geLnYBA9j8eJfD6PtrcesdEGmBrM/TIr/FZD5jfojkWwcuVthHQ+raqxp1t9sOSGxMdSccG1h5aXMtaaGTsh8d54IAMGzBDpNotmNpcCFfCwaXFNM2PezlYguYLuj2c1ijnBZwVtieB+t0T1YkI9woZ4oAMCxkq/vze3GtHAiuHo4DsDSwyGlRUaqntDwbjbjEFX2iDVwsfWHTOmff8LVhVWNLf/YFPxm6nwbeeWXqqebd+utrEDnjdRDLrMsy3r6QfnpVtmMVglx1D2BL9nzGs4xH3k8nU/xeXCsBRl3/dpIAo9VQ7z7NpngGEJL4aYEsz2YjnhcVHMcJCIpolLbBQ6B5H+h82UaQ731suG7vOWKcZ5NPaQNg07GT4drbH18aAyzmb216Fu+NiYK4P7VuEv90HMvUHTzkqBe8vwAmicu6XACmAfXbPkkMHFxnrrkFF2M9LvrlBia8h19JMV60ZutjvMYbxHC0hRxvL2bJnWb9P48t1PtpcBMU6llwrG2CIALs72NEJTNAXDEd4bYhz0aTvMFlJKIsSWQNrv6eowqUcDZEj+06ErpYcjDq1MVwxWwcjQEAKx62AD64xunY68S5peu5z1apzQOumMYzXJn7RFLzt1Fw56vg4Je0fq0v1kLD5YGOjcOxh5JeZZAMGKfqmrRAyE3mZpI3gfDjLBl9CgPrIPVzR1og5NmjQoJuW+eD+wA0gIg6QEQyOu6LOp9Dlg+PnqoBhR7mwDu7ZDRenWxkCvOzFZ9c6caLya2YFLip7UCr8RR5n53a7TkVMeRTAXJawFlIIMxFz7agBIlqd2t0ji9+IDGcJC5cMNzDHEAADqIagEoQ49XRB/qqfPeDLsDB3N4uF59VuoEvB2NfKoQTs54J795KUMGtEMMxq/yEHaHtFbH64FRgcUr6lGHLiys2iSG0DHQQXJY0ejhAvKWzNy3D2ShTT23GFkGOB6o8N3DKPA1mZvt+LsD9JsxwAcYzXGGk2SDLotwTK2K4FUaTLTHO+x6hncmtBzol8ORPp3KnHNuiZ5t+BMgxmZSGYQVCmWFC09iS4CVTh6WPflv281rY/1ejrQsyxTRSWBFKlNv1glN9AxOSYxGkOBM51jYkzM1YMKdrEtsGcmar+xVyqCVxE8Wor655V0zf5r3iHSNODoDbD5nocjAGW41uQ12AIaYxHxsSKwswAZBABGtXB/r1d4s+2cDJr7b0YMjdMYeZGSahJchMAKjQcYAaOeV5D8gXOvcrRI9cUWdw9iV3Nlflcx5yP1jx8M9KTVWwVfeE4GPOGv12f2KqB+BhU8O6mfeEsQQdi7VWCTgWRtOo0zLLk19g5amf8I6z7r4T5vYLBBsuzfhnZ6tra7ZWF9zZUoMLDgLQJK7cRgj1S1sPcs/xGr8yeE9fX5CRUsTvjXkuul8lbYJLhJjG+lvM7PiFEhEDyNOykDwR9w/yJdMvJqiynLlyg7q09j2a0LlDJrlcdFV2R5f4tt8EQvCB4CQqL6zcUj250JujjWdAG79rimiAXKljf/d8wTL13Tq/o0usGDhTXJxTMS5ktofp1tTrPd4lWv1eT7jggriX1AwbOfjRp2gQwbubKkKHiA3DCMJWf6jD4gX4+J4HiGBIYfrywafnuRz91vad7jXQueRcljm9R7rnzb707Fmqu6SfCgL/3n1KLs4dMFYTF0AjUAGiFSzTUNXrNSqGuCSo7Ycn/ACX7fg1EnyX/cgSWSa3tu6pckdMV9c0uE9fAy6fMGue5znqdOgZ833Mx/5prOH8GhwkbqDZfXsR/OAxMhzb9x3pISq4BwYPr0llE04JMOuYs7VxM/uXZeHyTdQFmQ3VBeUa6I88p+vJbliSX4Q7U/rhDrQFS9X9ikQDuEOfmhYDLgCGuOZ1V96TaizYK8YBdLG+81XRnIGqYJlGbr/sP5XyTKH3aX9O7QtKpz8YUvc+NvwEdZ1Z/rtBJxcIuCUILGDLoKrjVyv8LhA/JQa/pG57fIn+4Gdl2I4S15vbDCGE+J97BmlfOxVgce1Jr9A77VQ/nTc0duG5tkarNSao8pj7UxYq11jPwNAHZaw32RKAVho8T7s3CCFaXZzw3Ks7oAi81rWB0Ot/2kBFfuNPMQ0C1u/SxxdgadiYYUnMoeIDf9TvgyAErrGBSfAs5U5t7f9RMifym/inoz+51VKbhweukxwr64XLNfBmVRii3QJODPclcw0yJv4aEafTgW7kHjoNBUtayjfcLEFlvUu/ke8RHJ0eCpcknwAOp5uGFuo4+d+cempQl1xcpe2DqwksyienzDx8bul6211AIzMv2o/OcFrprE3MyEAvxgM+co1OHwo4fXRe01850nRqoPTvVejiQz1HPLWD4F5yZ7N3CC4A/EuH//zJdwacCVvUOyNgHirVrNPr55TMdv1j3f5nmTc9A+A4JY8IsesnZvW+Eqfkrn93elopEAHZNarAuRrcv/XlacXh1N4M4jrg9NHc/Fefdju1lD6p3v8/0Zhfmdrq2pgAAAAASUVORK5CYII="/>
    </defs>
  </svg>
);

export const tokenEth = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="12" fill="#6580E3"/>
    <g clip-path="url(#clip0)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9802 5.00008L11.9802 5L16.2772 12.1298L11.9803 14.6697V14.6698L11.9802 14.6697L7.68326 12.1298L7.68323 12.1298L11.9802 5.00008ZM11.9802 19L11.9802 18.9998L7.68323 12.9447L11.9803 15.4834L16.2798 12.9448L11.9803 19L11.9802 19Z" fill="#D7DDE0"/>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="14" height="14" fill="white" transform="translate(4.99988 5)"/>
      </clipPath>
    </defs>
  </svg>
);

export const tokenUSDC = (
  <svg viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="12" fill="#3A76C4"/>
    <g clipPath="url(#clip0)">
    <path d="M10.4598 17.8095C10.4598 18.0195 10.3198 18.0895 10.1098 18.0895C7.51983 17.2495 5.69983 14.8695 5.69983 12.0695C5.69983 9.26946 7.51983 6.88946 10.1098 6.04946C10.3198 5.97946 10.4598 6.11946 10.4598 6.32946V6.81946C10.4598 6.95946 10.3898 7.09946 10.2498 7.16946C8.21983 7.93946 6.81983 9.82946 6.81983 12.0695C6.81983 14.3095 8.28983 16.2695 10.2498 16.9695C10.3898 17.0395 10.4598 17.1795 10.4598 17.3195V17.8095Z" fill="white"/>
    <path d="M12.5599 16.0591C12.5599 16.1991 12.4199 16.3391 12.2799 16.3391H11.7199C11.5799 16.3391 11.4399 16.1991 11.4399 16.0591V15.2191C10.3199 15.0791 9.75987 14.4491 9.54987 13.5391C9.54987 13.3991 9.61987 13.2591 9.75987 13.2591H10.3899C10.5299 13.2591 10.5999 13.3291 10.6699 13.4691C10.8099 13.9591 11.0899 14.3791 11.9999 14.3791C12.6999 14.3791 13.1899 14.0291 13.1899 13.4691C13.1899 12.9091 12.9099 12.6991 11.9299 12.5591C10.4599 12.3491 9.75987 11.9291 9.75987 10.7391C9.75987 9.82914 10.4599 9.12914 11.4399 8.98914V8.14914C11.4399 8.00914 11.5799 7.86914 11.7199 7.86914H12.2799C12.4199 7.86914 12.5599 8.00914 12.5599 8.14914V8.98914C13.3999 9.12914 13.9599 9.61914 14.0999 10.3891C14.0999 10.5291 14.0299 10.6691 13.8899 10.6691H13.3299C13.1899 10.6691 13.1199 10.5991 13.0499 10.4591C12.9099 9.96914 12.5599 9.75914 11.9299 9.75914C11.2299 9.75914 10.8799 10.1091 10.8799 10.5991C10.8799 11.0891 11.0899 11.3691 12.1399 11.5091C13.6099 11.7191 14.3099 12.1391 14.3099 13.3291C14.3099 14.2391 13.6099 15.0091 12.5599 15.2191V16.0591Z" fill="white"/>
    <path d="M13.8899 18.0888C13.6799 18.1588 13.5399 18.0188 13.5399 17.8088V17.3188C13.5399 17.1788 13.6099 17.0388 13.7499 16.9688C15.7799 16.1988 17.1799 14.3088 17.1799 12.0688C17.1799 9.82883 15.7099 7.86883 13.7499 7.16883C13.6099 7.09883 13.5399 6.95883 13.5399 6.81883V6.32883C13.5399 6.11883 13.6799 6.04883 13.8899 6.04883C16.4099 6.88883 18.2999 9.26883 18.2999 12.0688C18.2999 14.8688 16.4799 17.2488 13.8899 18.0888Z" fill="white"/>
    </g>
    <defs>
    <clipPath id="clip0">
    <rect width="14" height="14" fill="white" transform="translate(4.99988 5)"/>
    </clipPath>
    </defs>
  </svg>
);

export const tokenUSDT = (
  <svg viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="12" fill="#6BAC95"/>
    <g clipPath="url(#clip0)">
    <path d="M13.4229 9.89337V8.18578H17.3462V5.58398H6.66274V8.18578H10.5866V9.89199C7.39764 10.0378 4.99988 10.6664 4.99988 11.4194C4.99988 12.1724 7.3988 12.801 10.5866 12.9477V18.4173H13.4238V12.9472C16.607 12.801 18.9999 12.1728 18.9999 11.4205C18.9999 10.6682 16.607 10.0401 13.4238 9.89383L13.4229 9.89337ZM13.4238 12.4839V12.4825C13.3437 12.4876 12.9325 12.5121 12.0167 12.5121C11.2846 12.5121 10.7695 12.4915 10.588 12.4821V12.4844C7.77063 12.3602 5.66765 11.8719 5.66765 11.2876C5.66765 10.7033 7.77086 10.2157 10.588 10.0913V11.9979C10.7725 12.0105 11.3003 12.0415 12.0287 12.0415C12.9036 12.0415 13.3435 12.0052 13.4242 11.9979V10.0913C16.236 10.2159 18.3342 10.7047 18.3342 11.2869C18.3342 11.8691 16.2351 12.3581 13.4242 12.4828" fill="white"/>
    </g>
    <defs>
    <clipPath id="clip0">
    <rect width="14" height="14" fill="white" transform="translate(4.99988 5)"/>
    </clipPath>
    </defs>
  </svg>
);
